
// // // // // // import React, { useEffect, useState } from "react";
// // // // // // import { getMyNews, deleteNews } from "../../../services/adminService";
// // // // // // import {
// // // // // //   CircularProgress,
// // // // // //   Typography,
// // // // // //   Table,
// // // // // //   TableBody,
// // // // // //   TableCell,
// // // // // //   TableContainer,
// // // // // //   TableHead,
// // // // // //   TableRow,
// // // // // //   Paper,
// // // // // //   Button,
// // // // // //   Dialog,
// // // // // //   DialogTitle,
// // // // // //   DialogContent,
// // // // // //   DialogActions,
// // // // // //   Pagination,
// // // // // //   Stack,
// // // // // //   Select,
// // // // // //   MenuItem,
// // // // // // } from "@mui/material";

// // // // // // const MyNewsAdmin = () => {
// // // // // //   const [news, setNews] = useState([]);
// // // // // //   const [loading, setLoading] = useState(true);

// // // // // //   // modal state
// // // // // //   const [open, setOpen] = useState(false);
// // // // // //   const [selectedNews, setSelectedNews] = useState(null);

// // // // // //   // delete confirm modal
// // // // // //   const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
// // // // // //   const [deleting, setDeleting] = useState(false);

// // // // // //   // pagination state
// // // // // //   const [page, setPage] = useState(1);
// // // // // //   const [limit, setLimit] = useState(10);
// // // // // //   const [totalPages, setTotalPages] = useState(1);

// // // // // //   // fetch news
// // // // // //   const fetchMyNews = async (pageNumber = page) => {
// // // // // //     try {
// // // // // //       setLoading(true);
// // // // // //       const response = await getMyNews({ page: pageNumber, limit });
// // // // // //       setNews(response.data || []);
// // // // // //       setTotalPages(response.totalPages || 1);
// // // // // //       setPage(pageNumber);
// // // // // //     } catch (error) {
// // // // // //       console.error("Failed to load my news:", error);
// // // // // //     } finally {
// // // // // //       setLoading(false);
// // // // // //     }
// // // // // //   };

// // // // // //   useEffect(() => {
// // // // // //     fetchMyNews();
// // // // // //   }, [limit]);

// // // // // //   const handleOpen = (item) => {
// // // // // //     setSelectedNews(item);
// // // // // //     setOpen(true);
// // // // // //   };

// // // // // //   const handleClose = () => {
// // // // // //     setOpen(false);
// // // // // //     setSelectedNews(null);
// // // // // //   };

// // // // // //   const handleDeleteClick = (item) => {
// // // // // //     setSelectedNews(item);
// // // // // //     setDeleteConfirmOpen(true);
// // // // // //   };

// // // // // //   const handleDeleteConfirm = async () => {
// // // // // //     if (!selectedNews) return;
// // // // // //     try {
// // // // // //       setDeleting(true);
// // // // // //       await deleteNews(selectedNews._id);
// // // // // //       setDeleteConfirmOpen(false);
// // // // // //       setOpen(false);
// // // // // //       fetchMyNews(page); // refresh current page
// // // // // //     } catch (error) {
// // // // // //       console.error("Failed to delete news:", error);
// // // // // //     } finally {
// // // // // //       setDeleting(false);
// // // // // //     }
// // // // // //   };

// // // // // //   const handleDeleteCancel = () => {
// // // // // //     setDeleteConfirmOpen(false);
// // // // // //     setSelectedNews(null);
// // // // // //   };

// // // // // //   if (loading) {
// // // // // //     return (
// // // // // //       <div className="flex justify-center items-center mt-10">
// // // // // //         <CircularProgress />
// // // // // //       </div>
// // // // // //     );
// // // // // //   }

// // // // // //   return (
// // // // // //     <div className="p-4">
// // // // // //       <Typography variant="h5" gutterBottom>
// // // // // //         My News
// // // // // //       </Typography>

// // // // // //       {news.length === 0 ? (
// // // // // //         <Typography>No news found.</Typography>
// // // // // //       ) : (
// // // // // //         <>
// // // // // //           <TableContainer component={Paper}>
// // // // // //             <Table>
// // // // // //               <TableHead>
// // // // // //                 <TableRow>
                
// // // // // //                   <TableCell></TableCell>
// // // // // //                   <TableCell>Title</TableCell>
// // // // // //                   <TableCell>Category</TableCell>
// // // // // //                   <TableCell>Sub Category</TableCell>
// // // // // //                   <TableCell>Status</TableCell>
// // // // // //                   <TableCell>Created At</TableCell>
// // // // // //                   <TableCell align="center">Action</TableCell>
// // // // // //                 </TableRow>
// // // // // //               </TableHead>
// // // // // //               <TableBody>
// // // // // //                 {news.map((item) => (
// // // // // //                   <TableRow key={item._id}>
// // // // // //                <TableCell>
// // // // // //   {item.media && item.media.length > 0 ? (
// // // // // //     <img
// // // // // //       src={item.media[0].url}
// // // // // //       alt={item.media[0].caption || "News image"}
// // // // // //       style={{
// // // // // //         width: "70px",
// // // // // //         maxHeight: "70px",
// // // // // //         objectFit: "contain",
// // // // // //         borderRadius: "8px",
// // // // // //         marginBottom: "16px",
// // // // // //         backgroundColor: "#f0fdf9ff",
// // // // // //       }}
// // // // // //     />
// // // // // //   ) : (
// // // // // //     <Typography variant="caption" color="textSecondary">
// // // // // //       No Image
// // // // // //     </Typography>
// // // // // //   )}
// // // // // // </TableCell>

// // // // // //                     <TableCell>{item.title}</TableCell>
// // // // // //                     <TableCell>{item.category?.name || "-"}</TableCell>
// // // // // //                     <TableCell>{item.subCategory?.name || "-"}</TableCell>
// // // // // //                     <TableCell>{item.status}</TableCell>
// // // // // //                     <TableCell>
// // // // // //                       {item.createdAtDate} {item.createdAtTime}
// // // // // //                     </TableCell>
// // // // // //                     <TableCell align="center">
// // // // // //                       <Button
// // // // // //                         size="small"
// // // // // //                         variant="outlined"
// // // // // //                         onClick={() => handleOpen(item)}
// // // // // //                         sx={{ mr: 1 }}
// // // // // //                       >
// // // // // //                         View
// // // // // //                       </Button>
// // // // // //                       <Button
// // // // // //                         size="small"
// // // // // //                         variant="outlined"
// // // // // //                         color="error"
// // // // // //                         onClick={() => handleDeleteClick(item)}
// // // // // //                       >
// // // // // //                         Delete
// // // // // //                       </Button>
// // // // // //                     </TableCell>
// // // // // //                   </TableRow>
// // // // // //                 ))}
// // // // // //               </TableBody>
// // // // // //             </Table>
// // // // // //           </TableContainer>

// // // // // //           {/* Pagination Controls */}
// // // // // //           <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
// // // // // //             <Pagination
// // // // // //               count={totalPages}
// // // // // //               page={page}
// // // // // //               onChange={(e, value) => fetchMyNews(value)}
// // // // // //               color="primary"
// // // // // //             />
// // // // // //             <Select
// // // // // //               value={limit}
// // // // // //               onChange={(e) => {
// // // // // //                 setLimit(e.target.value);
// // // // // //                 fetchMyNews(1);
// // // // // //               }}
// // // // // //             >
// // // // // //               {[5, 10, 20, 50].map((l) => (
// // // // // //                 <MenuItem key={l} value={l}>
// // // // // //                   {l} per page
// // // // // //                 </MenuItem>
// // // // // //               ))}
// // // // // //             </Select>
// // // // // //           </Stack>
// // // // // //         </>
// // // // // //       )}

// // // // // //       {/* Popup Modal for Details */}
// // // // // //       <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
// // // // // //         <DialogTitle>{selectedNews?.title}</DialogTitle>
// // // // // //         <DialogContent dividers>
// // // // // //           {selectedNews?.media && selectedNews?.media.length > 0 && (
// // // // // //             <img
// // // // // //               src={selectedNews.media[0].url}
// // // // // //               alt={selectedNews.media[0].caption || "News image"}
// // // // // //               style={{
// // // // // //                 width: "100%",
// // // // // //                 maxHeight: "300px",
// // // // // //                 objectFit: "contain",
// // // // // //                 borderRadius: "8px",
// // // // // //                 marginBottom: "16px",
// // // // // //                 backgroundColor: "#f0fdf9ff",
// // // // // //               }}
// // // // // //             />
// // // // // //           )}

// // // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // // //             <strong>Category:</strong> {selectedNews?.category?.name || "-"}
// // // // // //           </Typography>
// // // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // // //             <strong>Sub Category:</strong> {selectedNews?.subCategory?.name || "-"}
// // // // // //           </Typography>
// // // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // // //             <strong>Status:</strong> {selectedNews?.status}
// // // // // //           </Typography>
// // // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // // //             <strong>Country:</strong> {selectedNews?.country?.name || "-"}
// // // // // //           </Typography>
// // // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // // //             <strong>State:</strong> {selectedNews?.state?.name || "-"}
// // // // // //           </Typography>
// // // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // // //             <strong>City:</strong> {selectedNews?.city?.name || "-"}
// // // // // //           </Typography>
// // // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // // //             <strong>Local Address:</strong> {selectedNews?.localAddress || "-"}
// // // // // //           </Typography>
// // // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // // //             <strong>Reporter:</strong> {selectedNews?.createdBy?.name || "-"} / (
// // // // // //             {selectedNews?.createdBy?.email})
// // // // // //           </Typography>
// // // // // //           <Typography variant="subtitle2" gutterBottom>
// // // // // //             <strong>Posted Date:</strong> {selectedNews?.postedDate}{" "}
// // // // // //             {selectedNews?.postedTime}
// // // // // //           </Typography>
// // // // // //           <Typography variant="subtitle2" gutterBottom>
// // // // // //             <strong>Last Updated:</strong> {selectedNews?.updatedAtDate}{" "}
// // // // // //             {selectedNews?.updatedAtTime}
// // // // // //           </Typography>
// // // // // //           <Typography variant="body1" sx={{ mt: 2, whiteSpace: "pre-line" }}>
// // // // // //             <strong>Content:</strong>
// // // // // //             <br />
// // // // // //             {selectedNews?.content || "No content available"}
// // // // // //           </Typography>
// // // // // //           {selectedNews?.tags?.length > 0 && (
// // // // // //             <Typography variant="subtitle1" sx={{ mt: 2 }}>
// // // // // //               <strong>Tags:</strong> {selectedNews.tags.join(", ")}
// // // // // //             </Typography>
// // // // // //           )}
// // // // // //           <Typography variant="subtitle2" sx={{ mt: 2 }}>
// // // // // //             <strong>Views:</strong> {selectedNews?.viewsCount || 0}
// // // // // //           </Typography>
// // // // // //           <Typography variant="subtitle2">
// // // // // //             <strong>Likes:</strong> {selectedNews?.likesCount || 0}
// // // // // //           </Typography>
// // // // // //           <Typography variant="subtitle2">
// // // // // //             <strong>Comments:</strong> {selectedNews?.commentsCount || 0}
// // // // // //           </Typography>
// // // // // //         </DialogContent>

// // // // // //         <DialogActions>
// // // // // //           <Button onClick={handleClose} variant="contained" color="primary">
// // // // // //             Close
// // // // // //           </Button>
// // // // // //           <Button
// // // // // //             onClick={() => handleDeleteClick(selectedNews)}
// // // // // //             variant="contained"
// // // // // //             color="error"
// // // // // //           >
// // // // // //             Delete
// // // // // //           </Button>
// // // // // //         </DialogActions>
// // // // // //       </Dialog>

// // // // // //       {/* Delete Confirm Modal */}
// // // // // //       <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
// // // // // //         <DialogTitle>Confirm Delete</DialogTitle>
// // // // // //         <DialogContent dividers>
// // // // // //           Are you sure you want to delete this news?
// // // // // //         </DialogContent>
// // // // // //         <DialogActions>
// // // // // //           <Button onClick={handleDeleteCancel} disabled={deleting}>
// // // // // //             Cancel
// // // // // //           </Button>
// // // // // //           <Button
// // // // // //             onClick={handleDeleteConfirm}
// // // // // //             color="error"
// // // // // //             variant="contained"
// // // // // //             disabled={deleting}
// // // // // //           >
// // // // // //             {deleting ? "Deleting..." : "Delete"}
// // // // // //           </Button>
// // // // // //         </DialogActions>
// // // // // //       </Dialog>
// // // // // //     </div>
// // // // // //   );
// // // // // // };

// // // // // // export default MyNewsAdmin;

// // // // // import React, { useEffect, useState } from "react";
// // // // // import { getMyNews, deleteNews, updateNews } from "../../../services/adminService"; // Import updateNews
// // // // // import {
// // // // //   CircularProgress,
// // // // //   Typography,
// // // // //   Table,
// // // // //   TableBody,
// // // // //   TableCell,
// // // // //   TableContainer,
// // // // //   TableHead,
// // // // //   TableRow,
// // // // //   Paper,
// // // // //   Button,
// // // // //   Dialog,
// // // // //   DialogTitle,
// // // // //   DialogContent,
// // // // //   DialogActions,
// // // // //   Pagination,
// // // // //   Stack,
// // // // //   Select,
// // // // //   MenuItem,
// // // // //   TextField, // For input fields
// // // // //   FormControl,
// // // // //   InputLabel,
// // // // //   OutlinedInput,
// // // // //   Chip,
// // // // //   Box,
// // // // //   IconButton,
// // // // // } from "@mui/material";
// // // // // import CloseIcon from '@mui/icons-material/Close'; // For removing media

// // // // // const MyNewsAdmin = () => {
// // // // //   const [news, setNews] = useState([]);
// // // // //   const [loading, setLoading] = useState(true);

// // // // //   // View modal state
// // // // //   const [viewOpen, setViewOpen] = useState(false); // Renamed from 'open' to 'viewOpen'
// // // // //   const [selectedNews, setSelectedNews] = useState(null);

// // // // //   // Edit modal state
// // // // //   const [editOpen, setEditOpen] = useState(false);
// // // // //   const [editFormData, setEditFormData] = useState({}); // State for the edit form data
// // // // //   const [newMediaFiles, setNewMediaFiles] = useState([]); // State for new media files
// // // // //   const [existingMediaToKeep, setExistingMediaToKeep] = useState([]); // State for existing media to keep

// // // // //   // delete confirm modal
// // // // //   const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
// // // // //   const [deleting, setDeleting] = useState(false);
// // // // //   const [updating, setUpdating] = useState(false); // State for update loading

// // // // //   // pagination state
// // // // //   const [page, setPage] = useState(1);
// // // // //   const [limit, setLimit] = useState(10);
// // // // //   const [totalPages, setTotalPages] = useState(1);

// // // // //   // Fetch news
// // // // //   const fetchMyNews = async (pageNumber = page) => {
// // // // //     try {
// // // // //       setLoading(true);
// // // // //       const response = await getMyNews({ page: pageNumber, limit });
// // // // //       setNews(response.data || []);
// // // // //       setTotalPages(response.totalPages || 1);
// // // // //       setPage(pageNumber);
// // // // //     } catch (error) {
// // // // //       console.error("Failed to load my news:", error);
// // // // //     } finally {
// // // // //       setLoading(false);
// // // // //     }
// // // // //   };

// // // // //   useEffect(() => {
// // // // //     fetchMyNews();
// // // // //   }, [limit]); // Refetch when limit changes

// // // // //   // Handle View Modal
// // // // //   const handleViewOpen = (item) => {
// // // // //     setSelectedNews(item);
// // // // //     setViewOpen(true);
// // // // //   };

// // // // //   const handleViewClose = () => {
// // // // //     setViewOpen(false);
// // // // //     setSelectedNews(null);
// // // // //   };

// // // // //   // Handle Edit Modal
// // // // //   const handleEditOpen = (item) => {
// // // // //     setSelectedNews(item);
// // // // //     // Initialize form data with existing news details
// // // // //     setEditFormData({
// // // // //       title: item.title,
// // // // //       content: item.content,
// // // // //       summary: item.summary,
// // // // //       category: item.category?.name || '',
// // // // //       subCategory: item.subCategory?.name || '',
// // // // //       tags: item.tags || [],
// // // // //       country: item.country?.name || '',
// // // // //       state: item.state?.name || '',
// // // // //       city: item.city?.name || '',
// // // // //       localAddress: item.localAddress || '',
// // // // //       status: item.status,
// // // // //     });
// // // // //     setExistingMediaToKeep(item.media ? item.media.map(m => m.url) : []); // Keep all existing media by default
// // // // //     setNewMediaFiles([]); // Clear any previously selected new files
// // // // //     setEditOpen(true);
// // // // //   };

// // // // //   const handleEditClose = () => {
// // // // //     setEditOpen(false);
// // // // //     setSelectedNews(null);
// // // // //     setEditFormData({});
// // // // //     setNewMediaFiles([]);
// // // // //     setExistingMediaToKeep([]);
// // // // //   };

// // // // //   const handleEditFormChange = (e) => {
// // // // //     const { name, value } = e.target;
// // // // //     setEditFormData((prevData) => ({
// // // // //       ...prevData,
// // // // //       [name]: value,
// // // // //     }));
// // // // //   };

// // // // //   const handleTagsChange = (e) => {
// // // // //     const tagsArray = e.target.value.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
// // // // //     setEditFormData((prevData) => ({
// // // // //       ...prevData,
// // // // //       tags: tagsArray,
// // // // //     }));
// // // // //   };

// // // // //   const handleNewMediaUpload = (e) => {
// // // // //     setNewMediaFiles(Array.from(e.target.files));
// // // // //   };

// // // // //   const handleRemoveExistingMedia = (urlToRemove) => {
// // // // //     setExistingMediaToKeep((prev) => prev.filter((url) => url !== urlToRemove));
// // // // //   };

// // // // //   const handleUpdateSubmit = async () => {
// // // // //     if (!selectedNews) return;

// // // // //     try {
// // // // //       setUpdating(true);
// // // // //       const formData = new FormData();

// // // // //       // Append form fields
// // // // //       for (const key in editFormData) {
// // // // //         if (editFormData[key] !== undefined && editFormData[key] !== null) {
// // // // //           if (key === 'tags') {
// // // // //             formData.append(key, JSON.stringify(editFormData[key])); // Send tags as a JSON string array
// // // // //           } else {
// // // // //             formData.append(key, editFormData[key]);
// // // // //           }
// // // // //         }
// // // // //       }

// // // // //       // Append existing media to keep
// // // // //       formData.append('existingMedia', JSON.stringify(existingMediaToKeep));

// // // // //       // Append new media files
// // // // //       newMediaFiles.forEach((file) => {
// // // // //         formData.append('mediaFiles', file);
// // // // //       });

// // // // //       await updateNews(selectedNews._id, formData);
// // // // //       handleEditClose();
// // // // //       fetchMyNews(page); // Refresh current page
// // // // //     } catch (error) {
// // // // //       console.error("Failed to update news:", error);
// // // // //       // You might want to show an error message to the user here
// // // // //     } finally {
// // // // //       setUpdating(false);
// // // // //     }
// // // // //   };

// // // // //   // Handle Delete
// // // // //   const handleDeleteClick = (item) => {
// // // // //     setSelectedNews(item);
// // // // //     setDeleteConfirmOpen(true);
// // // // //   };

// // // // //   const handleDeleteConfirm = async () => {
// // // // //     if (!selectedNews) return;
// // // // //     try {
// // // // //       setDeleting(true);
// // // // //       await deleteNews(selectedNews._id);
// // // // //       setDeleteConfirmOpen(false);
// // // // //       setViewOpen(false); // Close view modal if open
// // // // //       handleEditClose(); // Close edit modal if open
// // // // //       fetchMyNews(page); // refresh current page
// // // // //     } catch (error) {
// // // // //       console.error("Failed to delete news:", error);
// // // // //     } finally {
// // // // //       setDeleting(false);
// // // // //     }
// // // // //   };

// // // // //   const handleDeleteCancel = () => {
// // // // //     setDeleteConfirmOpen(false);
// // // // //     setSelectedNews(null);
// // // // //   };

// // // // //   if (loading) {
// // // // //     return (
// // // // //       <div className="flex justify-center items-center mt-10">
// // // // //         <CircularProgress />
// // // // //       </div>
// // // // //     );
// // // // //   }

// // // // //   return (
// // // // //     <div className="p-4">
// // // // //       <Typography variant="h5" gutterBottom>
// // // // //         My News
// // // // //       </Typography>

// // // // //       {news.length === 0 ? (
// // // // //         <Typography>No news found.</Typography>
// // // // //       ) : (
// // // // //         <>
// // // // //           <TableContainer component={Paper}>
// // // // //             <Table>
// // // // //               <TableHead>
// // // // //                 <TableRow>
// // // // //                   <TableCell></TableCell>
// // // // //                   <TableCell>Title</TableCell>
// // // // //                   <TableCell>Category</TableCell>
// // // // //                   <TableCell>Sub Category</TableCell>
// // // // //                   <TableCell>Status</TableCell>
// // // // //                   <TableCell>Created At</TableCell>
// // // // //                   <TableCell align="center">Action</TableCell>
// // // // //                 </TableRow>
// // // // //               </TableHead>
// // // // //               <TableBody>
// // // // //                 {news.map((item) => (
// // // // //                   <TableRow key={item._id}>
// // // // //                     <TableCell>
// // // // //                       {item.media && item.media.length > 0 ? (
// // // // //                         <img
// // // // //                           src={item.media[0].url}
// // // // //                           alt={item.media[0].caption || "News image"}
// // // // //                           style={{
// // // // //                             width: "70px",
// // // // //                             maxHeight: "70px",
// // // // //                             objectFit: "contain",
// // // // //                             borderRadius: "8px",
// // // // //                             marginBottom: "16px",
// // // // //                             backgroundColor: "#f0fdf9ff",
// // // // //                           }}
// // // // //                         />
// // // // //                       ) : (
// // // // //                         <Typography variant="caption" color="textSecondary">
// // // // //                           No Image
// // // // //                         </Typography>
// // // // //                       )}
// // // // //                     </TableCell>
// // // // //                     <TableCell>{item.title}</TableCell>
// // // // //                     <TableCell>{item.category?.name || "-"}</TableCell>
// // // // //                     <TableCell>{item.subCategory?.name || "-"}</TableCell>
// // // // //                     <TableCell>{item.status}</TableCell>
// // // // //                     <TableCell>
// // // // //                       {item.createdAtDate} {item.createdAtTime}
// // // // //                     </TableCell>
// // // // //                     <TableCell align="center">
// // // // //                       <Button
// // // // //                         size="small"
// // // // //                         variant="outlined"
// // // // //                         onClick={() => handleViewOpen(item)} // Changed to handleViewOpen
// // // // //                         sx={{ mr: 1 }}
// // // // //                       >
// // // // //                         View
// // // // //                       </Button>
// // // // //                       <Button
// // // // //                         size="small"
// // // // //                         variant="outlined"
// // // // //                         color="primary" // Changed color for edit
// // // // //                         onClick={() => handleEditOpen(item)} // New Edit button
// // // // //                         sx={{ mr: 1 }}
// // // // //                       >
// // // // //                         Edit
// // // // //                       </Button>
// // // // //                       <Button
// // // // //                         size="small"
// // // // //                         variant="outlined"
// // // // //                         color="error"
// // // // //                         onClick={() => handleDeleteClick(item)}
// // // // //                       >
// // // // //                         Delete
// // // // //                       </Button>
// // // // //                     </TableCell>
// // // // //                   </TableRow>
// // // // //                 ))}
// // // // //               </TableBody>
// // // // //             </Table>
// // // // //           </TableContainer>

// // // // //           {/* Pagination Controls */}
// // // // //           <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
// // // // //             <Pagination
// // // // //               count={totalPages}
// // // // //               page={page}
// // // // //               onChange={(e, value) => fetchMyNews(value)}
// // // // //               color="primary"
// // // // //             />
// // // // //             <Select
// // // // //               value={limit}
// // // // //               onChange={(e) => {
// // // // //                 setLimit(e.target.value);
// // // // //                 fetchMyNews(1);
// // // // //               }}
// // // // //             >
// // // // //               {[5, 10, 20, 50].map((l) => (
// // // // //                 <MenuItem key={l} value={l}>
// // // // //                   {l} per page
// // // // //                 </MenuItem>
// // // // //               ))}
// // // // //             </Select>
// // // // //           </Stack>
// // // // //         </>
// // // // //       )}

// // // // //       {/* Popup Modal for Details (View) */}
// // // // //       <Dialog open={viewOpen} onClose={handleViewClose} fullWidth maxWidth="md">
// // // // //         <DialogTitle>{selectedNews?.title}</DialogTitle>
// // // // //         <DialogContent dividers>
// // // // //           {selectedNews?.media && selectedNews?.media.length > 0 && (
// // // // //             <img
// // // // //               src={selectedNews.media[0].url}
// // // // //               alt={selectedNews.media[0].caption || "News image"}
// // // // //               style={{
// // // // //                 width: "100%",
// // // // //                 maxHeight: "300px",
// // // // //                 objectFit: "contain",
// // // // //                 borderRadius: "8px",
// // // // //                 marginBottom: "16px",
// // // // //                 backgroundColor: "#f0fdf9ff",
// // // // //               }}
// // // // //             />
// // // // //           )}

// // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // //             <strong>Category:</strong> {selectedNews?.category?.name || "-"}
// // // // //           </Typography>
// // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // //             <strong>Sub Category:</strong> {selectedNews?.subCategory?.name || "-"}
// // // // //           </Typography>
// // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // //             <strong>Status:</strong> {selectedNews?.status}
// // // // //           </Typography>
// // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // //             <strong>Country:</strong> {selectedNews?.country?.name || "-"}
// // // // //           </Typography>
// // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // //             <strong>State:</strong> {selectedNews?.state?.name || "-"}
// // // // //           </Typography>
// // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // //             <strong>City:</strong> {selectedNews?.city?.name || "-"}
// // // // //           </Typography>
// // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // //             <strong>Local Address:</strong> {selectedNews?.localAddress || "-"}
// // // // //           </Typography>
// // // // //           <Typography variant="subtitle1" gutterBottom>
// // // // //             <strong>Reporter:</strong> {selectedNews?.createdBy?.name || "-"} / (
// // // // //             {selectedNews?.createdBy?.email})
// // // // //           </Typography>
// // // // //           <Typography variant="subtitle2" gutterBottom>
// // // // //             <strong>Posted Date:</strong> {selectedNews?.postedDate}{" "}
// // // // //             {selectedNews?.postedTime}
// // // // //           </Typography>
// // // // //           <Typography variant="subtitle2" gutterBottom>
// // // // //             <strong>Last Updated:</strong> {selectedNews?.updatedAtDate}{" "}
// // // // //             {selectedNews?.updatedAtTime}
// // // // //           </Typography>
// // // // //           <Typography variant="body1" sx={{ mt: 2, whiteSpace: "pre-line" }}>
// // // // //             <strong>Content:</strong>
// // // // //             <br />
// // // // //             {selectedNews?.content || "No content available"}
// // // // //           </Typography>
// // // // //           {selectedNews?.tags?.length > 0 && (
// // // // //             <Typography variant="subtitle1" sx={{ mt: 2 }}>
// // // // //               <strong>Tags:</strong> {selectedNews.tags.join(", ")}
// // // // //             </Typography>
// // // // //           )}
// // // // //           <Typography variant="subtitle2" sx={{ mt: 2 }}>
// // // // //             <strong>Views:</strong> {selectedNews?.viewsCount || 0}
// // // // //           </Typography>
// // // // //           <Typography variant="subtitle2">
// // // // //             <strong>Likes:</strong> {selectedNews?.likesCount || 0}
// // // // //           </Typography>
// // // // //           <Typography variant="subtitle2">
// // // // //             <strong>Comments:</strong> {selectedNews?.commentsCount || 0}
// // // // //           </Typography>
// // // // //         </DialogContent>

// // // // //         <DialogActions>
// // // // //           <Button onClick={handleViewClose} variant="contained" color="primary">
// // // // //             Close
// // // // //           </Button>
// // // // //           <Button
// // // // //             onClick={() => handleDeleteClick(selectedNews)}
// // // // //             variant="contained"
// // // // //             color="error"
// // // // //           >
// // // // //             Delete
// // // // //           </Button>
          
// // // // //         </DialogActions>
// // // // //       </Dialog>

// // // // //       {/* Popup Modal for Editing News */}
// // // // //       <Dialog open={editOpen} onClose={handleEditClose} fullWidth maxWidth="md">
// // // // //         <DialogTitle>Edit News: {selectedNews?.title}</DialogTitle>
// // // // //         <DialogContent dividers>
// // // // //           <TextField
// // // // //             margin="dense"
// // // // //             name="title"
// // // // //             label="Title"
// // // // //             type="text"
// // // // //             fullWidth
// // // // //             variant="outlined"
// // // // //             value={editFormData.title || ""}
// // // // //             onChange={handleEditFormChange}
// // // // //             sx={{ mb: 2 }}
// // // // //           />
// // // // //           <TextField
// // // // //             margin="dense"
// // // // //             name="summary"
// // // // //             label="Summary"
// // // // //             type="text"
// // // // //             fullWidth
// // // // //             multiline
// // // // //             rows={2}
// // // // //             variant="outlined"
// // // // //             value={editFormData.summary || ""}
// // // // //             onChange={handleEditFormChange}
// // // // //             sx={{ mb: 2 }}
// // // // //           />
// // // // //           <TextField
// // // // //             margin="dense"
// // // // //             name="content"
// // // // //             label="Content"
// // // // //             type="text"
// // // // //             fullWidth
// // // // //             multiline
// // // // //             rows={6}
// // // // //             variant="outlined"
// // // // //             value={editFormData.content || ""}
// // // // //             onChange={handleEditFormChange}
// // // // //             sx={{ mb: 2 }}
// // // // //           />
// // // // //           <TextField
// // // // //             margin="dense"
// // // // //             name="category"
// // // // //             label="Category"
// // // // //             type="text"
// // // // //             fullWidth
// // // // //             variant="outlined"
// // // // //             value={editFormData.category || ""}
// // // // //             onChange={handleEditFormChange}
// // // // //             sx={{ mb: 2 }}
// // // // //             // You might want to replace this with a Select component
// // // // //             // fetching categories from an API for a better UX
// // // // //           />
// // // // //           <TextField
// // // // //             margin="dense"
// // // // //             name="subCategory"
// // // // //             label="Sub Category"
// // // // //             type="text"
// // // // //             fullWidth
// // // // //             variant="outlined"
// // // // //             value={editFormData.subCategory || ""}
// // // // //             onChange={handleEditFormChange}
// // // // //             sx={{ mb: 2 }}
// // // // //             // Similar to category, a Select would be better here
// // // // //           />
// // // // //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// // // // //             <InputLabel htmlFor="news-tags">Tags (comma separated)</InputLabel>
// // // // //             <OutlinedInput
// // // // //               id="news-tags"
// // // // //               name="tags"
// // // // //               value={editFormData.tags?.join(', ') || ""}
// // // // //               onChange={handleTagsChange}
// // // // //               label="Tags (comma separated)"
// // // // //             />
// // // // //             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
// // // // //               {editFormData.tags?.map((tag, index) => (
// // // // //                 <Chip key={index} label={tag} />
// // // // //               ))}
// // // // //             </Box>
// // // // //           </FormControl>

// // // // //           <TextField
// // // // //             margin="dense"
// // // // //             name="country"
// // // // //             label="Country"
// // // // //             type="text"
// // // // //             fullWidth
// // // // //             variant="outlined"
// // // // //             value={editFormData.country || ""}
// // // // //             onChange={handleEditFormChange}
// // // // //             sx={{ mb: 2 }}
// // // // //             // Consider a Select with autocomplete for countries
// // // // //           />
// // // // //           <TextField
// // // // //             margin="dense"
// // // // //             name="state"
// // // // //             label="State"
// // // // //             type="text"
// // // // //             fullWidth
// // // // //             variant="outlined"
// // // // //             value={editFormData.state || ""}
// // // // //             onChange={handleEditFormChange}
// // // // //             sx={{ mb: 2 }}
// // // // //           />
// // // // //           <TextField
// // // // //             margin="dense"
// // // // //             name="city"
// // // // //             label="City"
// // // // //             type="text"
// // // // //             fullWidth
// // // // //             variant="outlined"
// // // // //             value={editFormData.city || ""}
// // // // //             onChange={handleEditFormChange}
// // // // //             sx={{ mb: 2 }}
// // // // //           />
// // // // //           <TextField
// // // // //             margin="dense"
// // // // //             name="localAddress"
// // // // //             label="Local Address"
// // // // //             type="text"
// // // // //             fullWidth
// // // // //             variant="outlined"
// // // // //             value={editFormData.localAddress || ""}
// // // // //             onChange={handleEditFormChange}
// // // // //             sx={{ mb: 2 }}
// // // // //           />
// // // // //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// // // // //             <InputLabel id="status-select-label">Status</InputLabel>
// // // // //             <Select
// // // // //               labelId="status-select-label"
// // // // //               name="status"
// // // // //               value={editFormData.status || ""}
// // // // //               label="Status"
// // // // //               onChange={handleEditFormChange}
// // // // //             >
// // // // //               <MenuItem value="draft">Draft</MenuItem>
// // // // //               <MenuItem value="pending_approval">Pending Approval</MenuItem>
// // // // //               <MenuItem value="posted">Posted</MenuItem>
// // // // //               <MenuItem value="live">Live</MenuItem>
// // // // //               <MenuItem value="rejected">Rejected</MenuItem>
// // // // //             </Select>
// // // // //           </FormControl>

// // // // //           {/* Media Handling
// // // // //           <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
// // // // //             Media Files
// // // // //           </Typography>
// // // // //           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
// // // // //             {selectedNews?.media && selectedNews.media.length > 0 && selectedNews.media.map((mediaItem, index) => (
// // // // //               existingMediaToKeep.includes(mediaItem.url) && (
// // // // //                 <Box key={index} sx={{ position: 'relative', width: '100px', height: '100px', border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden' }}>
// // // // //                   <img
// // // // //                     src={mediaItem.url}
// // // // //                     alt={`Existing media ${index}`}
// // // // //                     style={{ width: '100%', height: '100%', objectFit: 'cover' }}
// // // // //                   />
// // // // //                   <IconButton
// // // // //                     size="small"
// // // // //                     sx={{
// // // // //                       position: 'absolute',
// // // // //                       top: 0,
// // // // //                       right: 0,
// // // // //                       backgroundColor: 'rgba(255, 255, 255, 0.7)',
// // // // //                       '&:hover': {
// // // // //                         backgroundColor: 'rgba(255, 255, 255, 0.9)',
// // // // //                       },
// // // // //                     }}
// // // // //                     onClick={() => handleRemoveExistingMedia(mediaItem.url)}
// // // // //                   >
// // // // //                     <CloseIcon fontSize="small" />
// // // // //                   </IconButton>
// // // // //                 </Box>
// // // // //               )
// // // // //             ))}
// // // // //           </Box> */}
// // // // //           <Button
// // // // //             variant="contained"
// // // // //             component="label"
// // // // //             sx={{ mt: 1 }}
// // // // //           >
// // // // //             Upload New Media
// // // // //             <input type="file" hidden multiple onChange={handleNewMediaUpload} />
// // // // //           </Button>
// // // // //           <Box sx={{ mt: 1, mb: 2 }}>
// // // // //             {newMediaFiles.length > 0 && (
// // // // //               <Typography variant="body2" color="textSecondary">
// // // // //                 New files selected: {newMediaFiles.map(file => file.name).join(', ')}
// // // // //               </Typography>
// // // // //             )}
// // // // //             {newMediaFiles.length === 0 && (
// // // // //               <Typography variant="body2" color="textSecondary">
// // // // //                 No new files selected.
// // // // //               </Typography>
// // // // //             )}
// // // // //           </Box>

// // // // //         </DialogContent>

// // // // //         <DialogActions>
// // // // //           <Button onClick={handleEditClose} disabled={updating}>
// // // // //             Cancel
// // // // //           </Button>
// // // // //           <Button
// // // // //             onClick={handleUpdateSubmit}
// // // // //             variant="contained"
// // // // //             color="primary"
// // // // //             disabled={updating}
// // // // //           >
// // // // //             {updating ? "Updating..." : "Save Changes"}
// // // // //           </Button>
// // // // //         </DialogActions>
// // // // //       </Dialog>


// // // // //       {/* Delete Confirm Modal */}
// // // // //       <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
// // // // //         <DialogTitle>Confirm Delete</DialogTitle>
// // // // //         <DialogContent dividers>
// // // // //           Are you sure you want to delete this news?
// // // // //         </DialogContent>
// // // // //         <DialogActions>
// // // // //           <Button onClick={handleDeleteCancel} disabled={deleting}>
// // // // //             Cancel
// // // // //           </Button>
// // // // //           <Button
// // // // //             onClick={handleDeleteConfirm}
// // // // //             color="error"
// // // // //             variant="contained"
// // // // //             disabled={deleting}
// // // // //           >
// // // // //             {deleting ? "Deleting..." : "Delete"}
// // // // //           </Button>
// // // // //         </DialogActions>
// // // // //       </Dialog>
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default MyNewsAdmin;

// // // // import React, { useEffect, useState } from "react";
// // // // import { getMyNews, deleteNews, updateNews } from "../../../services/adminService"; // Import updateNews
// // // // import {
// // // //   CircularProgress,
// // // //   Typography,
// // // //   Table,
// // // //   TableBody,
// // // //   TableCell,
// // // //   TableContainer,
// // // //   TableHead,
// // // //   TableRow,
// // // //   Paper,
// // // //   Button,
// // // //   Dialog,
// // // //   DialogTitle,
// // // //   DialogContent,
// // // //   DialogActions,
// // // //   Pagination,
// // // //   Stack,
// // // //   Select,
// // // //   MenuItem,
// // // //   TextField,
// // // //   FormControl,
// // // //   InputLabel,
// // // //   OutlinedInput,
// // // //   Chip,
// // // //   Box,
// // // //   IconButton,
// // // //   ListItem,
// // // //   List,
// // // //   ListItemText,
// // // // } from "@mui/material";
// // // // import CloseIcon from '@mui/icons-material/Close'; // For removing media

// // // // const MyNewsAdmin = () => {
// // // //   const [news, setNews] = useState([]);
// // // //   const [loading, setLoading] = useState(true);

// // // //   // View modal state
// // // //   const [viewOpen, setViewOpen] = useState(false);
// // // //   const [selectedNews, setSelectedNews] = useState(null);

// // // //   // Edit modal state
// // // //   const [editOpen, setEditOpen] = useState(false);
// // // //   const [editFormData, setEditFormData] = useState({}); // State for the edit form data
// // // //   const [newMediaFiles, setNewMediaFiles] = useState([]); // State for new media files
// // // //   const [existingMediaToKeep, setExistingMediaToKeep] = useState([]); // State for existing media to keep

// // // //   // delete confirm modal
// // // //   const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
// // // //   const [deleting, setDeleting] = useState(false);
// // // //   const [updating, setUpdating] = useState(false); // State for update loading

// // // //   // pagination state
// // // //   const [page, setPage] = useState(1);
// // // //   const [limit, setLimit] = useState(10);
// // // //   const [totalPages, setTotalPages] = useState(1);

// // // //   // Fetch news
// // // //   const fetchMyNews = async (pageNumber = page) => {
// // // //     try {
// // // //       setLoading(true);
// // // //       const response = await getMyNews({ page: pageNumber, limit });
// // // //       setNews(response.data || []);
// // // //       setTotalPages(response.totalPages || 1);
// // // //       setPage(pageNumber);
// // // //     } catch (error) {
// // // //       console.error("Failed to load my news:", error);
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   useEffect(() => {
// // // //     fetchMyNews();
// // // //   }, [limit]); // Refetch when limit changes

// // // //   // Handle View Modal
// // // //   const handleViewOpen = (item) => {
// // // //     setSelectedNews(item);
// // // //     setViewOpen(true);
// // // //   };

// // // //   const handleViewClose = () => {
// // // //     setViewOpen(false);
// // // //     setSelectedNews(null);
// // // //   };

// // // //   // Handle Edit Modal
// // // //   const handleEditOpen = (item) => {
// // // //     setSelectedNews(item);
// // // //     // Initialize form data with existing news details
// // // //     setEditFormData({
// // // //       title_en: item.title_en || '',
// // // //       title_hi: item.title_hi || '',
// // // //       content_en: item.content_en || '',
// // // //       content_hi: item.content_hi || '',
// // // //       summary_en: item.summary_en || '',
// // // //       summary_hi: item.summary_hi || '',
// // // //       category: item.category?._id || '', // Use _id for category/subcategory if they are ObjectIds
// // // //       subCategory: item.subCategory?._id || '',
// // // //       tags: item.tags || [],
// // // //       country: item.country?._id || '',
// // // //       state: item.state?._id || '',
// // // //       city: item.city?._id || '',
// // // //       localAddress: item.localAddress || '',
// // // //       status: item.status,
// // // //     });
// // // //     setExistingMediaToKeep(item.media ? item.media.map(m => m.url) : []); // Keep all existing media by default
// // // //     setNewMediaFiles([]); // Clear any previously selected new files
// // // //     setEditOpen(true);
// // // //   };

// // // //   const handleEditClose = () => {
// // // //     setEditOpen(false);
// // // //     setSelectedNews(null);
// // // //     setEditFormData({});
// // // //     setNewMediaFiles([]);
// // // //     setExistingMediaToKeep([]);
// // // //   };

// // // //   const handleEditFormChange = (e) => {
// // // //     const { name, value } = e.target;
// // // //     setEditFormData((prevData) => ({
// // // //       ...prevData,
// // // //       [name]: value,
// // // //     }));
// // // //   };

// // // //   const handleTagsChange = (e) => {
// // // //     const tagsArray = e.target.value.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
// // // //     setEditFormData((prevData) => ({
// // // //       ...prevData,
// // // //       tags: tagsArray,
// // // //     }));
// // // //   };

// // // //   const handleNewMediaUpload = (e) => {
// // // //     setNewMediaFiles(Array.from(e.target.files));
// // // //   };

// // // //   const handleRemoveExistingMedia = (urlToRemove) => {
// // // //     setExistingMediaToKeep((prev) => prev.filter((url) => url !== urlToRemove));
// // // //   };

// // // //   const handleUpdateSubmit = async () => {
// // // //     if (!selectedNews) return;

// // // //     try {
// // // //       setUpdating(true);
// // // //       const formData = new FormData();

// // // //       // Append form fields (English & Hindi)
// // // //       formData.append('title_en', editFormData.title_en || '');
// // // //       formData.append('title_hi', editFormData.title_hi || '');
// // // //       formData.append('summary_en', editFormData.summary_en || '');
// // // //       formData.append('summary_hi', editFormData.summary_hi || '');
// // // //       formData.append('content_en', editFormData.content_en || '');
// // // //       formData.append('content_hi', editFormData.content_hi || '');

// // // //       formData.append('category', editFormData.category || '');
// // // //       formData.append('subCategory', editFormData.subCategory || '');
// // // //       formData.append('country', editFormData.country || '');
// // // //       formData.append('state', editFormData.state || '');
// // // //       formData.append('city', editFormData.city || '');
// // // //       formData.append('localAddress', editFormData.localAddress || '');
// // // //       formData.append('status', editFormData.status || '');
// // // //       formData.append('tags', JSON.stringify(editFormData.tags || []));

// // // //       // Append existing media to keep (as an array of URLs)
// // // //       formData.append('existingMediaUrls', JSON.stringify(existingMediaToKeep));

// // // //       // Append new media files
// // // //       newMediaFiles.forEach((file) => {
// // // //         formData.append('mediaFiles', file);
// // // //       });

// // // //       await updateNews(selectedNews._id, formData);
// // // //       handleEditClose();
// // // //       fetchMyNews(page); // Refresh current page
// // // //     } catch (error) {
// // // //       console.error("Failed to update news:", error);
// // // //       // You might want to show an error message to the user here
// // // //     } finally {
// // // //       setUpdating(false);
// // // //     }
// // // //   };

// // // //   // Handle Delete
// // // //   const handleDeleteClick = (item) => {
// // // //     setSelectedNews(item);
// // // //     setDeleteConfirmOpen(true);
// // // //   };

// // // //   const handleDeleteConfirm = async () => {
// // // //     if (!selectedNews) return;
// // // //     try {
// // // //       setDeleting(true);
// // // //       await deleteNews(selectedNews._id);
// // // //       setDeleteConfirmOpen(false);
// // // //       setViewOpen(false); // Close view modal if open
// // // //       handleEditClose(); // Close edit modal if open
// // // //       fetchMyNews(page); // refresh current page
// // // //     } catch (error) {
// // // //       console.error("Failed to delete news:", error);
// // // //     } finally {
// // // //       setDeleting(false);
// // // //     }
// // // //   };

// // // //   const handleDeleteCancel = () => {
// // // //     setDeleteConfirmOpen(false);
// // // //     setSelectedNews(null);
// // // //   };

// // // //   if (loading) {
// // // //     return (
// // // //       <div className="flex justify-center items-center mt-10">
// // // //         <CircularProgress />
// // // //       </div>
// // // //     );
// // // //   }

// // // //   return (
// // // //     <div className="p-4">
// // // //       <Typography variant="h5" gutterBottom>
// // // //         My News
// // // //       </Typography>

// // // //       {news.length === 0 ? (
// // // //         <Typography>No news found.</Typography>
// // // //       ) : (
// // // //         <>
// // // //           <TableContainer component={Paper}>
// // // //             <Table>
// // // //               <TableHead>
// // // //                 <TableRow>
// // // //                   <TableCell>Image</TableCell>
// // // //                   <TableCell>Title (English)</TableCell> {/* Updated */}
// // // //                   <TableCell>Category</TableCell>
// // // //                   <TableCell>Status</TableCell>
// // // //                   <TableCell>Created At</TableCell>
// // // //                   <TableCell align="center">Action</TableCell>
// // // //                 </TableRow>
// // // //               </TableHead>
// // // //               <TableBody>
// // // //                 {news.map((item) => (
// // // //                   <TableRow key={item._id}>
// // // //                     <TableCell>
// // // //                       {item.media && item.media.length > 0 ? (
// // // //                         <img
// // // //                           src={item.media[0].url}
// // // //                           alt={item.media[0].caption || "News image"}
// // // //                           style={{
// // // //                             width: "70px",
// // // //                             maxHeight: "70px",
// // // //                             objectFit: "contain",
// // // //                             borderRadius: "8px",
// // // //                             backgroundColor: "#f0fdf9ff",
// // // //                           }}
// // // //                         />
// // // //                       ) : (
// // // //                         <Typography variant="caption" color="textSecondary">
// // // //                           No Image
// // // //                         </Typography>
// // // //                       )}
// // // //                     </TableCell>
// // // //                     <TableCell>{item.title_en}</TableCell> {/* Updated */}
// // // //                     <TableCell>{item.category?.name || "-"}</TableCell>
// // // //                     <TableCell>{item.status}</TableCell>
// // // //                     <TableCell>
// // // //                       {item.createdAtDate} {item.createdAtTime}
// // // //                     </TableCell>
// // // //                     <TableCell align="center">
// // // //                       <Button
// // // //                         size="small"
// // // //                         variant="outlined"
// // // //                         onClick={() => handleViewOpen(item)}
// // // //                         sx={{ mr: 1 }}
// // // //                       >
// // // //                         View
// // // //                       </Button>
// // // //                       <Button
// // // //                         size="small"
// // // //                         variant="outlined"
// // // //                         color="primary"
// // // //                         onClick={() => handleEditOpen(item)}
// // // //                         sx={{ mr: 1 }}
// // // //                       >
// // // //                         Edit
// // // //                       </Button>
// // // //                       <Button
// // // //                         size="small"
// // // //                         variant="outlined"
// // // //                         color="error"
// // // //                         onClick={() => handleDeleteClick(item)}
// // // //                       >
// // // //                         Delete
// // // //                       </Button>
// // // //                     </TableCell>
// // // //                   </TableRow>
// // // //                 ))}
// // // //               </TableBody>
// // // //             </Table>
// // // //           </TableContainer>

// // // //           {/* Pagination Controls */}
// // // //           <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
// // // //             <Pagination
// // // //               count={totalPages}
// // // //               page={page}
// // // //               onChange={(e, value) => fetchMyNews(value)}
// // // //               color="primary"
// // // //             />
// // // //             <Select
// // // //               value={limit}
// // // //               onChange={(e) => {
// // // //                 setLimit(e.target.value);
// // // //                 fetchMyNews(1);
// // // //               }}
// // // //             >
// // // //               {[5, 10, 20, 50].map((l) => (
// // // //                 <MenuItem key={l} value={l}>
// // // //                   {l} per page
// // // //                 </MenuItem>
// // // //               ))}
// // // //             </Select>
// // // //           </Stack>
// // // //         </>
// // // //       )}

// // // //       {/* Popup Modal for Details (View) */}
// // // //       <Dialog open={viewOpen} onClose={handleViewClose} fullWidth maxWidth="md">
// // // //         <DialogTitle>News Details</DialogTitle>
// // // //         <DialogContent dividers>
// // // //           {selectedNews?.media && selectedNews?.media.length > 0 && (
// // // //             <img
// // // //               src={selectedNews.media[0].url}
// // // //               alt={selectedNews.media[0].caption || "News image"}
// // // //               style={{
// // // //                 width: "100%",
// // // //                 maxHeight: "300px",
// // // //                 objectFit: "contain",
// // // //                 borderRadius: "8px",
// // // //                 marginBottom: "16px",
// // // //                 backgroundColor: "#f0fdf9ff",
// // // //               }}
// // // //             />
// // // //           )}

// // // //           <Typography variant="h6" gutterBottom><strong>Title (English):</strong> {selectedNews?.title_en || "-"}</Typography>
// // // //           <Typography variant="h6" gutterBottom><strong>शीर्षक (हिंदी):</strong> {selectedNews?.title_hi || "-"}</Typography>
          
// // // //           <Typography variant="subtitle1" gutterBottom><strong>Summary (English):</strong> {selectedNews?.summary_en || "-"}</Typography>
// // // //           <Typography variant="subtitle1" gutterBottom><strong>सारांश (हिंदी):</strong> {selectedNews?.summary_hi || "-"}</Typography>

// // // //           <Typography variant="subtitle1" gutterBottom><strong>Category:</strong> {selectedNews?.category?.name || "-"}</Typography>
// // // //           <Typography variant="subtitle1" gutterBottom><strong>Sub Category:</strong> {selectedNews?.subCategory?.name || "-"}</Typography>
// // // //           <Typography variant="subtitle1" gutterBottom><strong>Status:</strong> {selectedNews?.status}</Typography>
// // // //           <Typography variant="subtitle1" gutterBottom><strong>Country:</strong> {selectedNews?.country?.name || "-"}</Typography>
// // // //           <Typography variant="subtitle1" gutterBottom><strong>State:</strong> {selectedNews?.state?.name || "-"}</Typography>
// // // //           <Typography variant="subtitle1" gutterBottom><strong>City:</strong> {selectedNews?.city?.name || "-"}</Typography>
// // // //           <Typography variant="subtitle1" gutterBottom><strong>Local Address:</strong> {selectedNews?.localAddress || "-"}</Typography>
// // // //           <Typography variant="subtitle1" gutterBottom><strong>Reporter:</strong> {selectedNews?.createdBy?.name || "-"} / ({selectedNews?.createdBy?.email})</Typography>
          
// // // //           <Typography variant="subtitle2" gutterBottom><strong>Posted Date:</strong> {selectedNews?.postedDate} {selectedNews?.postedTime}</Typography>
// // // //           <Typography variant="subtitle2" gutterBottom><strong>Last Updated:</strong> {selectedNews?.updatedAtDate} {selectedNews?.updatedAtTime}</Typography>
          
// // // //           <Typography variant="body1" sx={{ mt: 2 }}>
// // // //             <strong>Content (English):</strong>
// // // //             <br />
// // // //             <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_en || "No English content available" }} />
// // // //           </Typography>
// // // //           <Typography variant="body1" sx={{ mt: 2 }}>
// // // //             <strong>सामग्री (हिंदी):</strong>
// // // //             <br />
// // // //             <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_hi || "कोई हिंदी सामग्री उपलब्ध नहीं है" }} />
// // // //           </Typography>

// // // //           {selectedNews?.tags?.length > 0 && (
// // // //             <Typography variant="subtitle1" sx={{ mt: 2 }}>
// // // //               <strong>Tags:</strong> {selectedNews.tags.join(", ")}
// // // //             </Typography>
// // // //           )}
// // // //           {selectedNews?.referenceLinks?.length > 0 && (
// // // //             <Box sx={{ mt: 2 }}>
// // // //               <Typography variant="subtitle1"><strong>Reference Links:</strong></Typography>
// // // //               <List dense>
// // // //                 {selectedNews.referenceLinks.map((link, index) => (
// // // //                   <ListItem key={index} disablePadding>
// // // //                     <p sx={{ mr: 1 }} fontSize="small" />
// // // //                     <a href={link} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>
// // // //                       <ListItemText primary={link} />
// // // //                     </a>
// // // //                   </ListItem>
// // // //                 ))}
// // // //               </List>
// // // //             </Box>
// // // //           )}
// // // //           <Typography variant="subtitle2" sx={{ mt: 2 }}>
// // // //             <strong>Views:</strong> {selectedNews?.viewsCount || 0}
// // // //           </Typography>
// // // //           <Typography variant="subtitle2">
// // // //             <strong>Likes:</strong> {selectedNews?.likesCount || 0}
// // // //           </Typography>
// // // //           <Typography variant="subtitle2">
// // // //             <strong>Comments:</strong> {selectedNews?.commentsCount || 0}
// // // //           </Typography>
// // // //         </DialogContent>

// // // //         <DialogActions>
// // // //           <Button onClick={handleViewClose} variant="contained" color="primary">
// // // //             Close
// // // //           </Button>
// // // //           <Button
// // // //             onClick={() => handleDeleteClick(selectedNews)}
// // // //             variant="contained"
// // // //             color="error"
// // // //           >
// // // //             Delete
// // // //           </Button>

// // // //         </DialogActions>
// // // //       </Dialog>

// // // //       {/* Popup Modal for Editing News */}
// // // //       <Dialog open={editOpen} onClose={handleEditClose} fullWidth maxWidth="md">
// // // //         <DialogTitle>Edit News: {selectedNews?.title_en}</DialogTitle> {/* Display English title in edit dialog header */}
// // // //         <DialogContent dividers>
// // // //           <TextField
// // // //             margin="dense"
// // // //             name="title_en"
// // // //             label="Title (English)"
// // // //             type="text"
// // // //             fullWidth
// // // //             variant="outlined"
// // // //             value={editFormData.title_en || ""}
// // // //             onChange={handleEditFormChange}
// // // //             sx={{ mb: 2 }}
// // // //           />
// // // //           <TextField
// // // //             margin="dense"
// // // //             name="title_hi"
// // // //             label="शीर्षक (हिंदी)"
// // // //             type="text"
// // // //             fullWidth
// // // //             variant="outlined"
// // // //             value={editFormData.title_hi || ""}
// // // //             onChange={handleEditFormChange}
// // // //             sx={{ mb: 2 }}
// // // //           />
// // // //           <TextField
// // // //             margin="dense"
// // // //             name="summary_en"
// // // //             label="Summary (English)"
// // // //             type="text"
// // // //             fullWidth
// // // //             multiline
// // // //             rows={2}
// // // //             variant="outlined"
// // // //             value={editFormData.summary_en || ""}
// // // //             onChange={handleEditFormChange}
// // // //             sx={{ mb: 2 }}
// // // //           />
// // // //           <TextField
// // // //             margin="dense"
// // // //             name="summary_hi"
// // // //             label="सारांश (हिंदी)"
// // // //             type="text"
// // // //             fullWidth
// // // //             multiline
// // // //             rows={2}
// // // //             variant="outlined"
// // // //             value={editFormData.summary_hi || ""}
// // // //             onChange={handleEditFormChange}
// // // //             sx={{ mb: 2 }}
// // // //           />
// // // //           <TextField
// // // //             margin="dense"
// // // //             name="content_en"
// // // //             label="Content (English)"
// // // //             type="text"
// // // //             fullWidth
// // // //             multiline
// // // //             rows={6}
// // // //             variant="outlined"
// // // //             value={editFormData.content_en || ""}
// // // //             onChange={handleEditFormChange}
// // // //             sx={{ mb: 2 }}
// // // //           />
// // // //           <TextField
// // // //             margin="dense"
// // // //             name="content_hi"
// // // //             label="सामग्री (हिंदी)"
// // // //             type="text"
// // // //             fullWidth
// // // //             multiline
// // // //             rows={6}
// // // //             variant="outlined"
// // // //             value={editFormData.content_hi || ""}
// // // //             onChange={handleEditFormChange}
// // // //             sx={{ mb: 2 }}
// // // //           />
// // // //           <TextField
// // // //             margin="dense"
// // // //             name="category"
// // // //             label="Category"
// // // //             type="text"
// // // //             fullWidth
// // // //             variant="outlined"
// // // //             value={editFormData.category || ""}
// // // //             onChange={handleEditFormChange}
// // // //             sx={{ mb: 2 }}
// // // //             // You might want to replace this with a Select component
// // // //             // fetching categories from an API for a better UX
// // // //           />
// // // //           <TextField
// // // //             margin="dense"
// // // //             name="subCategory"
// // // //             label="Sub Category"
// // // //             type="text"
// // // //             fullWidth
// // // //             variant="outlined"
// // // //             value={editFormData.subCategory || ""}
// // // //             onChange={handleEditFormChange}
// // // //             sx={{ mb: 2 }}
// // // //             // Similar to category, a Select would be better here
// // // //           />
// // // //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// // // //             <InputLabel htmlFor="news-tags">Tags (comma separated)</InputLabel>
// // // //             <OutlinedInput
// // // //               id="news-tags"
// // // //               name="tags"
// // // //               value={editFormData.tags?.join(', ') || ""}
// // // //               onChange={handleTagsChange}
// // // //               label="Tags (comma separated)"
// // // //             />
// // // //             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
// // // //               {editFormData.tags?.map((tag, index) => (
// // // //                 <Chip key={index} label={tag} />
// // // //               ))}
// // // //             </Box>
// // // //           </FormControl>

// // // //           <TextField
// // // //             margin="dense"
// // // //             name="country"
// // // //             label="Country"
// // // //             type="text"
// // // //             fullWidth
// // // //             variant="outlined"
// // // //             value={editFormData.country || ""}
// // // //             onChange={handleEditFormChange}
// // // //             sx={{ mb: 2 }}
// // // //             // Consider a Select with autocomplete for countries
// // // //           />
// // // //           <TextField
// // // //             margin="dense"
// // // //             name="state"
// // // //             label="State"
// // // //             type="text"
// // // //             fullWidth
// // // //             variant="outlined"
// // // //             value={editFormData.state || ""}
// // // //             onChange={handleEditFormChange}
// // // //             sx={{ mb: 2 }}
// // // //           />
// // // //           <TextField
// // // //             margin="dense"
// // // //             name="city"
// // // //             label="City"
// // // //             type="text"
// // // //             fullWidth
// // // //             variant="outlined"
// // // //             value={editFormData.city || ""}
// // // //             onChange={handleEditFormChange}
// // // //             sx={{ mb: 2 }}
// // // //           />
// // // //           <TextField
// // // //             margin="dense"
// // // //             name="localAddress"
// // // //             label="Local Address"
// // // //             type="text"
// // // //             fullWidth
// // // //             variant="outlined"
// // // //             value={editFormData.localAddress || ""}
// // // //             onChange={handleEditFormChange}
// // // //             sx={{ mb: 2 }}
// // // //           />
// // // //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// // // //             <InputLabel id="status-select-label">Status</InputLabel>
// // // //             <Select
// // // //               labelId="status-select-label"
// // // //               name="status"
// // // //               value={editFormData.status || ""}
// // // //               label="Status"
// // // //               onChange={handleEditFormChange}
// // // //             >
// // // //               <MenuItem value="draft">Draft</MenuItem>
// // // //               <MenuItem value="pending_approval">Pending Approval</MenuItem>
// // // //               <MenuItem value="posted">Posted</MenuItem>
// // // //               <MenuItem value="live">Live</MenuItem>
// // // //               <MenuItem value="rejected">Rejected</MenuItem>
// // // //             </Select>
// // // //           </FormControl>

// // // //           {/* Media Handling */}
// // // //           <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
// // // //             Media Files
// // // //           </Typography>
// // // //           <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
// // // //             Click 'X' to remove existing media. Upload new media using the button below.
// // // //           </Typography>
// // // //           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
// // // //             {selectedNews?.media && selectedNews.media.length > 0 && selectedNews.media.map((mediaItem, index) => (
// // // //               existingMediaToKeep.includes(mediaItem.url) && (
// // // //                 <Box key={index} sx={{ position: 'relative', width: '100px', height: '100px', border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden' }}>
// // // //                   <img
// // // //                     src={mediaItem.url}
// // // //                     alt={`Existing media ${index}`}
// // // //                     style={{ width: '100%', height: '100%', objectFit: 'cover' }}
// // // //                   />
// // // //                   <IconButton
// // // //                     size="small"
// // // //                     sx={{
// // // //                       position: 'absolute',
// // // //                       top: 0,
// // // //                       right: 0,
// // // //                       backgroundColor: 'rgba(255, 255, 255, 0.7)',
// // // //                       '&:hover': {
// // // //                         backgroundColor: 'rgba(255, 255, 255, 0.9)',
// // // //                       },
// // // //                     }}
// // // //                     onClick={() => handleRemoveExistingMedia(mediaItem.url)}
// // // //                   >
// // // //                     <CloseIcon fontSize="small" />
// // // //                   </IconButton>
// // // //                 </Box>
// // // //               )
// // // //             ))}
// // // //           </Box>
// // // //           <Button
// // // //             variant="contained"
// // // //             component="label"
// // // //             sx={{ mt: 1 }}
// // // //           >
// // // //             Upload New Media
// // // //             <input type="file" hidden multiple onChange={handleNewMediaUpload} />
// // // //           </Button>
// // // //           <Box sx={{ mt: 1, mb: 2 }}>
// // // //             {newMediaFiles.length > 0 && (
// // // //               <Typography variant="body2" color="textSecondary">
// // // //                 New files selected: {newMediaFiles.map(file => file.name).join(', ')}
// // // //               </Typography>
// // // //             )}
// // // //             {newMediaFiles.length === 0 && (
// // // //               <Typography variant="body2" color="textSecondary">
// // // //                 No new files selected.
// // // //               </Typography>
// // // //             )}
// // // //           </Box>

// // // //         </DialogContent>

// // // //         <DialogActions>
// // // //           <Button onClick={handleEditClose} disabled={updating}>
// // // //             Cancel
// // // //           </Button>
// // // //           <Button
// // // //             onClick={handleUpdateSubmit}
// // // //             variant="contained"
// // // //             color="primary"
// // // //             disabled={updating}
// // // //           >
// // // //             {updating ? "Updating..." : "Save Changes"}
// // // //           </Button>
// // // //         </DialogActions>
// // // //       </Dialog>


// // // //       {/* Delete Confirm Modal */}
// // // //       <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
// // // //         <DialogTitle>Confirm Delete</DialogTitle>
// // // //         <DialogContent dividers>
// // // //           Are you sure you want to delete this news?
// // // //         </DialogContent>
// // // //         <DialogActions>
// // // //           <Button onClick={handleDeleteCancel} disabled={deleting}>
// // // //             Cancel
// // // //           </Button>
// // // //           <Button
// // // //             onClick={handleDeleteConfirm}
// // // //             color="error"
// // // //             variant="contained"
// // // //             disabled={deleting}
// // // //           >
// // // //             {deleting ? "Deleting..." : "Delete"}
// // // //           </Button>
// // // //         </DialogActions>
// // // //       </Dialog>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default MyNewsAdmin;



// // // import React, { useEffect, useState, useRef, useCallback } from "react";
// // // import { getMyNews, deleteNews, updateNews, uploadMediaFiles } from "../../../services/adminService";
// // // import {
// // //   CircularProgress,
// // //   Typography,
// // //   Table,
// // //   TableBody,
// // //   TableCell,
// // //   TableContainer,
// // //   TableHead,
// // //   TableRow,
// // //   Paper,
// // //   Button,
// // //   Dialog,
// // //   DialogTitle,
// // //   DialogContent,
// // //   DialogActions,
// // //   Pagination,
// // //   Stack,
// // //   Select,
// // //   MenuItem,
// // //   TextField,
// // //   FormControl,
// // //   InputLabel,
// // //   OutlinedInput,
// // //   Chip,
// // //   Box,
// // //   IconButton,
// // //   ListItem,
// // //   List,
// // //   ListItemText,
// // //   Alert,
// // //   Divider,
// // // } from "@mui/material";
// // // import CloseIcon from '@mui/icons-material/Close';
// // // import { Editor } from '@tinymce/tinymce-react';

// // // import {
// // //   getCategories,
// // //   getSubcategories,
// // //   getCountries,
// // //   getStatesByCountry,
// // //   getCitiesByState,
// // // } from '../../../services/apiService';
// // // import LinkIcon from '@mui/icons-material/Link';
// // // import AttachFileIcon from '@mui/icons-material/AttachFile'; // Added for file type icon
// // // import VideoFileIcon from '@mui/icons-material/VideoFile'; // Added for file type icon
// // // import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'; // Added for add button

// // // const RASHI_OPTIONS = [
// // //   "Mesh", "Vrishabh", "Mithun", "Karka", "Singh", "Kanya",
// // //   "Tula", "Vrischik", "Dhanu", "Makar", "Kumbh", "Meen"
// // // ];

// // // const isValidUrl = (string) => {
// // //   try {
// // //     new URL(string);
// // //     return true;
// // //   } catch (e) {
// // //     return false;
// // //   }
// // // };

// // // const MyNewsAdmin = () => {
// // //   const [news, setNews] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [viewOpen, setViewOpen] = useState(false);
// // //   const [selectedNews, setSelectedNews] = useState(null);
// // //   const [editOpen, setEditOpen] = useState(false);
// // //   const [editFormData, setEditFormData] = useState({});
// // //   const [newMediaFiles, setNewMediaFiles] = useState([]);
// // //   const [existingMediaToKeep, setExistingMediaToKeep] = useState([]);
// // //   const [mediaUrlInput, setMediaUrlInput] = useState(''); // New state for external media URL input
// // //   const [formErrors, setFormErrors] = useState({}); // Added for form validation errors

// // //   const [categoriesDropdown, setCategoriesDropdown] = useState([]);
// // //   const [subCategoriesDropdown, setSubCategoriesDropdown] = useState([]);
// // //   const [countriesDropdown, setCountriesDropdown] = useState([]);
// // //   const [statesDropdown, setStatesDropdown] = useState([]);
// // //   const [citiesDropdown, setCitiesDropdown] = useState([]);

// // //   const [updateError, setUpdateError] = useState(null);
// // //   const [updateSuccess, setUpdateSuccess] = useState(null);
// // //   const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
// // //   const [deleting, setDeleting] = useState(false);
// // //   const [updating, setUpdating] = useState(false);

// // //   const [page, setPage] = useState(1);
// // //   const [limit, setLimit] = useState(10);
// // //   const [totalPages, setTotalPages] = useState(1);

// // //   const editorRefEn = useRef(null);
// // //   const editorRefHi = useRef(null);

// // //   const extractUrlsFromHtml = useCallback((htmlContent) => {
// // //     const extracted = new Set();
// // //     if (!htmlContent) return Array.from(extracted);

// // //     const parser = new DOMParser();
// // //     const doc = parser.parseFromString(htmlContent, 'text/html');

// // //     doc.querySelectorAll('img, video, source, iframe').forEach(el => {
// // //       const src = el.getAttribute('src');
// // //       if (src && isValidUrl(src)) {
// // //         extracted.add(src);
// // //       }
// // //     });

// // //     doc.querySelectorAll('img').forEach(el => {
// // //       const srcset = el.getAttribute('srcset');
// // //       if (srcset) {
// // //         srcset.split(',').forEach(srcPart => {
// // //           const url = srcPart.trim().split(' ')[0];
// // //           if (url && isValidUrl(url)) {
// // //             extracted.add(url);
// // //           }
// // //         });
// // //       }
// // //     });

// // //     doc.querySelectorAll('a').forEach(el => {
// // //       const href = el.getAttribute('href');
// // //       if (href && isValidUrl(href)) {
// // //         extracted.add(href);
// // //       }
// // //     });

// // //     doc.querySelectorAll('[data-mce-src]').forEach(el => {
// // //       const dataMceSrc = el.getAttribute('data-mce-src');
// // //       if (dataMceSrc && isValidUrl(dataMceSrc)) {
// // //         extracted.add(dataMceSrc);
// // //       }
// // //     });

// // //     doc.querySelectorAll('[data-mce-p-src]').forEach(el => {
// // //       const dataMcePSrc = el.getAttribute('data-mce-p-src');
// // //       if (dataMcePSrc && isValidUrl(dataMcePSrc)) {
// // //         extracted.add(dataMcePSrc);
// // //       }
// // //     });
// // //     return Array.from(extracted);
// // //   }, []);

// // //   const fetchMyNews = useCallback(async (pageNumber = page) => {
// // //     try {
// // //       setLoading(true);
// // //       const response = await getMyNews({ page: pageNumber, limit });
// // //       setNews(response.data || []);
// // //       setTotalPages(response.totalPages || 1);
// // //     } catch (error) {
// // //       console.error("ERROR: Failed to load my news:", error);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   }, [limit]);

// // //   // --- START TinyMCE Editor Configuration (Copied from CreateNews) ---
// // //   const editorConfig = {
// // //     height: 500,
// // //     menubar: true,
// // //     branding: false,
// // //     plugins: [
// // //       'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
// // //       'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
// // //       'insertdatetime', 'media', 'table', 'help', 'wordcount', 'emoticons',
// // //       'template', 'codesample', 'hr', 'pagebreak', 'nonbreaking',
// // //       'toc', 'imagetools', 'textpattern', 'noneditable', 'quickbars',
// // //       'accordion', 'autosave', 'save', 'directionality', 'visualchars'
// // //     ],
// // //     toolbar1: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify',
// // //     // Removed template, codesample, pagebreak, charmap from toolbar 2 and 3 if not in plugins
// // //     toolbar2: 'outdent indent | numlist bullist | forecolor backcolor removeformat | charmap emoticons | fullscreen preview save print',
// // //     toolbar3: 'insertfile image media link anchor | customupload | ltr rtl | showcomments addcomment',
// // //     // Removed: template, codesample, pagebreak, toc, imagetools, textpattern, noneditable, quickbars from toolbars

// // //     content_style: `
// // //     body {
// // //       font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
// // //       font-size: 14px;
// // //       line-height: 1.6;
// // //       margin: 1rem;
// // //     }
// // //     img { max-width: 100%; height: auto; }
// // //     .mce-content-body {
// // //       padding: 20px;
// // //       max-width: none;
// // //     }
// // //   `,

// // //     paste_data_images: true,
// // //     automatic_uploads: true,
// // //     file_picker_types: 'image media',

// // //     file_picker_callback: function (callback, value, meta) {
// // //       console.log('File picker triggered for:', meta.filetype);

// // //       const input = document.createElement('input');
// // //       input.setAttribute('type', 'file');

// // //       if (meta.filetype === 'image') {
// // //         input.setAttribute('accept', 'image/*');
// // //       } else if (meta.filetype === 'media') {
// // //         input.setAttribute('accept', 'video/*,audio/*');
// // //       } else {
// // //         input.setAttribute('accept', 'image/*,video/*,audio/*');
// // //       }

// // //       input.onchange = function () {
// // //         const file = this.files[0];

// // //         if (!file) {
// // //           console.log('No file selected');
// // //           return;
// // //         }

// // //         console.log('File selected:', file.name, file.type, file.size);

// // //         const editor = window.tinymce.activeEditor;
// // //         editor.setProgressState(true);

// // //         const formData = new FormData();
// // //         formData.append('mediaFiles', file);

// // //         uploadMediaFiles(formData)
// // //           .then(response => {
// // //             console.log('Upload response:', response);
// // //             editor.setProgressState(false);

// // //             if (response && response.locations && response.locations.length > 0) {
// // //               const uploadedUrl = response.locations[0];
// // //               console.log('File uploaded successfully:', uploadedUrl);

// // //               setExistingMediaToKeep(prev => {
// // //                 if (!prev.includes(uploadedUrl)) {
// // //                   return [...prev, uploadedUrl];
// // //                 }
// // //                 return prev;
// // //               });

// // //               callback(uploadedUrl, {
// // //                 title: file.name,
// // //                 alt: file.name
// // //               });

// // //               editor.notificationManager.open({
// // //                 text: `File "${file.name}" uploaded successfully!`,
// // //                 type: 'success',
// // //                 timeout: 3000
// // //               });
// // //             } else {
// // //               throw new Error('No URL returned from upload service');
// // //             }
// // //           })
// // //           .catch(error => {
// // //             console.error('Upload failed:', error);
// // //             editor.setProgressState(false);

// // //             editor.notificationManager.open({
// // //               text: `Upload failed: ${error.message || 'Unknown error'}`,
// // //               type: 'error',
// // //               timeout: 5000
// // //             });

// // //             alert(`File upload failed: ${error.message || 'Please try again'}`);
// // //           });
// // //       };

// // //       input.click();
// // //     },

// // //     images_upload_handler: function (blobInfo, success, failure, progress) {
// // //       console.log('Image upload handler triggered');
// // //       console.log('Blob info:', blobInfo.filename(), blobInfo.blob().type, blobInfo.blob().size);

// // //       const blob = blobInfo.blob();

// // //       const file = new File([blob], blobInfo.filename() || `image-${Date.now()}.png`, {
// // //         type: blob.type || 'image/png'
// // //       });

// // //       console.log('Created file object:', file);

// // //       const formData = new FormData();
// // //       formData.append('mediaFiles', file);

// // //       const editor = window.tinymce.activeEditor;
// // //       editor.setProgressState(true);

// // //       uploadMediaFiles(formData)
// // //         .then(response => {
// // //           console.log('Upload response:', response);
// // //           editor.setProgressState(false);

// // //           if (response && response.locations && response.locations.length > 0) {
// // //             const uploadedUrl = response.locations[0];
// // //             console.log('Image uploaded successfully:', uploadedUrl);

// // //             setExistingMediaToKeep(prev => {
// // //               if (!prev.includes(uploadedUrl)) {
// // //                 return [...prev, uploadedUrl];
// // //               }
// // //               return prev;
// // //             });

// // //             success(uploadedUrl);

// // //             editor.notificationManager.open({
// // //               text: `Image uploaded successfully!`,
// // //               type: 'success',
// // //               timeout: 3000
// // //             });
// // //           } else {
// // //             throw new Error('No URL returned from upload service');
// // //           }
// // //         })
// // //         .catch(error => {
// // //           console.error('Image upload failed:', error);
// // //           editor.setProgressState(false);

// // //           failure(`Upload failed: ${error.message || 'Unknown error'}`);

// // //           editor.notificationManager.open({
// // //             text: `Upload failed: ${error.message || 'Unknown error'}`,
// // //             type: 'error',
// // //             timeout: 5000
// // //           });
// // //         });
// // //     },

// // //     setup: function (editor) {
// // //       console.log('TinyMCE editor setup starting');

// // //       editor.on('init', function () {
// // //         console.log('TinyMCE editor initialized');
// // //         editor.getContainer().style.transition = "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out";
// // //       });

// // //       // --- START: Debugging code for "Insert/Edit Image" dialog ---
// // //       // CORRECTED: editor.on is used instead of editor.ui.registry.on
// // //       editor.on('OpenWindow', (e) => {
// // //         // Check if the opened dialog is the 'Insert/Edit Image' or 'Insert/Edit Media' dialog
// // //         if (e.dialog.title === 'Insert/Edit Image' || e.dialog.title === 'Insert/Edit Media') {
// // //           console.log('DEBUG: TinyMCE Image/Media Dialog opened. Inspecting "Source" field...');
// // //           setTimeout(() => {
// // //             const sourceInput = document.querySelector('.tox-dialog__body-content input[type="text"][aria-label="Source"]');
// // //             const fallbackSourceInput = document.querySelector('.tox-textfield[name="src"]');

// // //             const targetInput = sourceInput || fallbackSourceInput;

// // //             if (targetInput) {
// // //               console.log('DEBUG: Found TinyMCE "Source" input field programmatically.');
// // //               console.log('DEBUG:   Element ID:', targetInput.id);
// // //               console.log('DEBUG:   Element Name:', targetInput.name);
// // //               console.log('DEBUG:   Disabled Attribute:', targetInput.disabled);
// // //               console.log('DEBUG:   Readonly Attribute:', targetInput.readOnly);
// // //               console.log('DEBUG:   Pointer Events CSS:', window.getComputedStyle(targetInput).pointerEvents);
// // //               console.log('DEBUG:   Z-Index CSS:', window.getComputedStyle(targetInput).zIndex);
// // //               console.log('DEBUG:   Opacity CSS:', window.getComputedStyle(targetInput).opacity);
// // //               console.log('DEBUG:   Visibility CSS:', window.getComputedStyle(targetInput).visibility);

// // //               // Attempt to enable interaction if found disabled/readonly
// // //               if (targetInput.disabled) {
// // //                 console.warn('DEBUG: "Source" input is disabled. Attempting to re-enable.');
// // //                 targetInput.disabled = false;
// // //                 targetInput.setAttribute('aria-disabled', 'false');
// // //               }
// // //               if (targetInput.readOnly) {
// // //                 console.warn('DEBUG: "Source" input is readOnly. Attempting to remove readOnly.');
// // //                 targetInput.readOnly = false;
// // //               }
// // //               if (window.getComputedStyle(targetInput).pointerEvents === 'none') {
// // //                 console.warn('DEBUG: "Source" input has pointer-events: none. Attempting to set to auto.');
// // //                 targetInput.style.setProperty('pointer-events', 'auto', 'important');
// // //               }

// // //             } else {
// // //               console.log('DEBUG: TinyMCE "Source" input field not found in dialog using known selectors.');
// // //             }
// // //           }, 200);
// // //         }
// // //       });
// // //       // --- END: Debugging code ---

// // //       // Add custom upload button to toolbar
// // //       editor.ui.registry.addButton('customupload', {
// // //         text: 'Upload Media',
// // //         icon: 'upload',
// // //         tooltip: 'Upload images or videos',
// // //         onAction: function () {
// // //           console.log('Custom upload button clicked');

// // //           const input = document.createElement('input');
// // //           input.setAttribute('type', 'file');
// // //           input.setAttribute('accept', 'image/*,video/*');
// // //           input.setAttribute('multiple', 'true');

// // //           input.onchange = function () {
// // //             const files = Array.from(this.files);
// // //             console.log('Multiple files selected:', files.length);

// // //             if (files.length === 0) return;

// // //             editor.setProgressState(true);

// // //             const formData = new FormData();
// // //             files.forEach(file => {
// // //               formData.append('mediaFiles', file);
// // //               console.log('Adding file to FormData:', file.name);
// // //             });

// // //             uploadMediaFiles(formData)
// // //               .then(response => {
// // //                 console.log('Batch upload response:', response);
// // //                 editor.setProgressState(false);

// // //                 if (response && response.locations && response.locations.length > 0) {
// // //                   setExistingMediaToKeep(prev => {
// // //                     const newUrls = response.locations.filter(url => !prev.includes(url));
// // //                     return [...prev, ...newUrls];
// // //                   });

// // //                   response.locations.forEach((url, index) => {
// // //                     const file = files[index];
// // //                     if (file && file.type.startsWith('image/')) {
// // //                       editor.insertContent(`<img src="${url}" alt="${file.name}" style="max-width: 100%; height: auto;" />`);
// // //                     } else if (file && file.type.startsWith('video/')) {
// // //                       editor.insertContent(`<video controls style="max-width: 100%; height: auto;">
// // //                       <source src="${url}" type="${file.type}">
// // //                       Your browser does not support the video tag.
// // //                     </video>`);
// // //                     }
// // //                   });

// // //                   editor.notificationManager.open({
// // //                     text: `Successfully uploaded ${response.locations.length} file(s)!`,
// // //                     type: 'success',
// // //                     timeout: 3000
// // //                   });
// // //                 } else {
// // //                   throw new Error('No URLs returned from upload service');
// // //                 }
// // //               })
// // //               .catch(error => {
// // //                 console.error('Batch upload failed:', error);
// // //                 editor.setProgressState(false);

// // //                 editor.notificationManager.open({
// // //                   text: `Upload failed: ${error.message || 'Unknown error'}`,
// // //                   type: 'error',
// // //                   timeout: 5000
// // //                 });
// // //               });
// // //           };

// // //           input.click();
// // //         }
// // //       });

// // //       editor.on('drop', function (e) {
// // //         console.log('File(s) dropped on editor');
// // //       });

// // //       editor.on('paste', function (e) {
// // //         console.log('Content pasted into editor');
// // //       });
// // //     },

// // //     contextmenu: 'link image table', // Removed imagetools
// // //     quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
// // //     quickbars_insert_toolbar: 'quickimage quicktable customupload',
// // //     // Removed powerpaste_word_import, powerpaste_html_import (if not needed)
// // //     powerpaste_word_import: 'clean',
// // //     powerpaste_html_import: 'clean',


// // //     image_advtab: true,
// // //     image_uploadtab: true,
// // //     image_caption: true,
// // //     image_title: true,

// // //     // Removed deprecated options
// // //     // template_cdate_format: '[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]',
// // //     // template_mdate_format: '[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]',

// // //     formats: {
// // //       alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'left' },
// // //       aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'center' },
// // //       alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'right' },
// // //       alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'full' },
// // //       bold: { inline: 'strong' },
// // //       italic: { inline: 'em' },
// // //       underline: { inline: 'u' },
// // //       strikethrough: { inline: 'del' },
// // //       customformat: { inline: 'span', styles: { color: '#00ff00', fontSize: '20px' }, attributes: { title: 'My custom format' }, classes: 'example1' }
// // //     }
// // //   };
// // //   // --- END TinyMCE Editor Configuration ---


// // //   useEffect(() => {
// // //     const fetchInitialDropdownData = async () => {
// // //       try {
// // //         const [catsRes, countriesRes] = await Promise.all([
// // //           getCategories(),
// // //           getCountries(),
// // //         ]);
// // //         setCategoriesDropdown(catsRes.data || []);
// // //         setCountriesDropdown(countriesRes.data || []);
// // //       } catch (err) {
// // //         console.error("ERROR: Failed to load initial dropdown data (categories/countries):", err);
// // //       }
// // //     };
// // //     fetchInitialDropdownData();
// // //     fetchMyNews();
// // //   }, [limit, fetchMyNews]);

// // //   const fetchSubcategoriesForEdit = useCallback(async (categoryId) => {
// // //     if (categoryId) {
// // //       try {
// // //         const res = await getSubcategories(categoryId);
// // //         setSubCategoriesDropdown(res.data || []);
// // //       } catch (err) {
// // //         console.error("ERROR: Failed to load subcategories for edit:", err);
// // //         setSubCategoriesDropdown([]);
// // //       }
// // //     } else {
// // //       setSubCategoriesDropdown([]);
// // //     }
// // //   }, []);

// // //   const fetchStatesForEdit = useCallback(async (countryId) => {
// // //     if (countryId) {
// // //       try {
// // //         const res = await getStatesByCountry(countryId);
// // //         setStatesDropdown(res.data || []);
// // //       } catch (err) {
// // //         console.error("ERROR: Failed to load states for edit:", err);
// // //         setStatesDropdown([]);
// // //       }
// // //     } else {
// // //       setStatesDropdown([]);
// // //     }
// // //   }, []);

// // //   const fetchCitiesForEdit = useCallback(async (stateId) => {
// // //     if (stateId) {
// // //       try {
// // //         const res = await getCitiesByState(stateId);
// // //         setCitiesDropdown(res.data || []);
// // //       } catch (err) {
// // //         console.error("ERROR: Failed to load cities for edit:", err);
// // //         setCitiesDropdown([]);
// // //       }
// // //     } else {
// // //       setCitiesDropdown([]);
// // //     }
// // //   }, []);


// // //   const handleViewOpen = (item) => {
// // //     setSelectedNews(item);
// // //     setViewOpen(true);
// // //   };

// // //   const handleViewClose = () => {
// // //     setViewOpen(false);
// // //     setSelectedNews(null);
// // //   };

// // //   const handleEditOpen = async (item) => {
// // //     console.log('DEBUG: handleEditOpen triggered for news item:', item._id);
// // //     setSelectedNews(item);
// // //     setUpdateError(null);
// // //     setUpdateSuccess(null);
// // //     setFormErrors({}); // Clear form errors on opening edit dialog

// // //     await fetchSubcategoriesForEdit(item.category?._id);
// // //     await fetchStatesForEdit(item.country?._id);
// // //     await fetchCitiesForEdit(item.state?._id);

// // //     setEditFormData({
// // //       title_en: item.title_en || '',
// // //       title_hi: item.title_hi || '',
// // //       content_en: item.content_en || '',
// // //       content_hi: item.content_hi || '',
// // //       summary_en: item.summary_en || '',
// // //       summary_hi: item.summary_hi || '',
// // //       category: item.category?._id || '',
// // //       subCategory: item.subCategory?._id || '',
// // //       tags: item.tags || [],
// // //       country: item.country?._id || '',
// // //       state: item.state?._id || '',
// // //       city: item.city?._id || '',
// // //       localAddress: item.localAddress || '',
// // //       status: item.status,
// // //       subSubCategory: item.subSubCategory || '',
// // //     });

// // //     let initialMediaUrlsToKeep = new Set(item.media ? item.media.map(m => m.url) : []);

// // //     if (item.mediaUrls && Array.isArray(item.mediaUrls)) {
// // //         item.mediaUrls.forEach(url => initialMediaUrlsToKeep.add(url));
// // //     }

// // //     const urlsFromEnglishContent = extractUrlsFromHtml(item.content_en);
// // //     const urlsFromHindiContent = extractUrlsFromHtml(item.content_hi);

// // //     urlsFromEnglishContent.forEach(url => initialMediaUrlsToKeep.add(url));
// // //     urlsFromHindiContent.forEach(url => initialMediaUrlsToKeep.add(url));

// // //     setExistingMediaToKeep(Array.from(initialMediaUrlsToKeep));
// // //     console.log("DEBUG: handleEditOpen: Initial existingMediaToKeep set to:", Array.from(initialMediaUrlsToKeep));

// // //     setNewMediaFiles([]);
// // //     setMediaUrlInput(''); // Reset external URL input
// // //     setEditOpen(true);
// // //   };

// // //   const handleEditClose = () => {
// // //     console.log('DEBUG: handleEditClose triggered.');
// // //     setEditOpen(false);
// // //     setSelectedNews(null);
// // //     setEditFormData({});
// // //     setNewMediaFiles([]);
// // //     setExistingMediaToKeep([]);
// // //     setSubCategoriesDropdown([]);
// // //     setStatesDropdown([]);
// // //     setCitiesDropdown([]);
// // //     setUpdateError(null);
// // //     setUpdateSuccess(null);
// // //     setMediaUrlInput('');
// // //     setFormErrors({}); // Clear form errors on closing
// // //   };

// // //   const handleEditFormChange = async (e) => {
// // //     const { name, value } = e.target;
// // //     setEditFormData((prevData) => ({
// // //       ...prevData,
// // //       [name]: value,
// // //     }));
// // //     setFormErrors((prev) => ({ ...prev, [name]: '' }));

// // //     if (name === 'category') {
// // //       setEditFormData((prevData) => ({ ...prevData, subCategory: '', subSubCategory: '' }));
// // //       await fetchSubcategoriesForEdit(value);
// // //     } else if (name === 'country') {
// // //       setEditFormData((prevData) => ({ ...prevData, state: '', city: '' }));
// // //       await fetchStatesForEdit(value);
// // //     } else if (name === 'state') {
// // //       setEditFormData((prevData) => ({ ...prevData, city: '' }));
// // //       await fetchCitiesForEdit(value);
// // //     }
// // //   };

// // //   const handleEditEditorChange = (content, editorName) => {
// // //     setEditFormData((prevData) => ({
// // //       ...prevData,
// // //       [editorName]: content,
// // //     }));
// // //     setFormErrors((prev) => ({ ...prev, [editorName]: '' }));

// // //     console.log('DEBUG: --- TinyMCE Editor Content Changed (onEditorChange) ---');
// // //     console.log('DEBUG: Editor Name:', editorName);

// // //     const extractedUrlsFromCurrentContent = extractUrlsFromHtml(content);

// // //     setExistingMediaToKeep(prev => {
// // //       const combinedUrls = new Set([...prev, ...extractedUrlsFromCurrentContent]);
// // //       const finalUniqueUrls = Array.from(combinedUrls);
// // //       return finalUniqueUrls;
// // //     });
// // //     console.log('DEBUG: --- End Editor Content Change ---');
// // //   };

// // //   const handleTagsChange = (e) => {
// // //     const tagsArray = e.target.value.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
// // //     setEditFormData((prevData) => ({
// // //       ...prevData,
// // //       tags: tagsArray,
// // //     }));
// // //   };

// // //   const handleNewMediaUpload = (e) => {
// // //     console.log('DEBUG: handleNewMediaUpload triggered.');
// // //     setNewMediaFiles(Array.from(e.target.files));
// // //   };

// // //   const handleRemoveExistingMedia = (urlToRemove) => {
// // //     console.log('DEBUG: handleRemoveExistingMedia triggered for URL:', urlToRemove);
// // //     setExistingMediaToKeep((prev) => prev.filter((url) => url !== urlToRemove));
// // //   };

// // //   const handleMediaUrlInputChange = (e) => {
// // //     setMediaUrlInput(e.target.value);
// // //     setFormErrors((prev) => ({ ...prev, mediaUrlInput: '' }));
// // //   };

// // //   const handleAddMediaUrl = () => {
// // //     const url = mediaUrlInput.trim();
// // //     if (url) {
// // //       if (!isValidUrl(url)) {
// // //         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' }));
// // //         return;
// // //       }
// // //       if (!existingMediaToKeep.includes(url)) {
// // //         setExistingMediaToKeep(prev => [...prev, url]);
// // //         setMediaUrlInput('');
// // //       } else {
// // //         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'This URL has already been added.' }));
// // //       }
// // //     }
// // //   };

// // //   const handleUpdateSubmit = async () => {
// // //     if (!selectedNews) return;

// // //     setUpdating(true);
// // //     setUpdateError(null);
// // //     setUpdateSuccess(null);
// // //     setFormErrors({});

// // //     let currentMediaUrls = [...existingMediaToKeep];
// // //     const currentMediaUrlInputVal = mediaUrlInput.trim();
// // //     if (currentMediaUrlInputVal) {
// // //       if (!isValidUrl(currentMediaUrlInputVal)) {
// // //         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' }));
// // //         setUpdating(false);
// // //         setUpdateError("Please correct the errors in the form.");
// // //         return;
// // //       }
// // //       if (!currentMediaUrls.includes(currentMediaUrlInputVal)) {
// // //         currentMediaUrls.push(currentMediaUrlInputVal);
// // //       } else {
// // //         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'This URL has already been added.' }));
// // //         setUpdating(false);
// // //         setUpdateError("Please correct the errors in the form.");
// // //         return;
// // //       }
// // //     }

// // //     try {
// // //       let finalMediaUrls = [...currentMediaUrls];

// // //       if (newMediaFiles.length > 0) {
// // //         console.log('DEBUG: Uploading new media files from dedicated button...');
// // //         const formDataForNewFiles = new FormData();
// // //         newMediaFiles.forEach(file => {
// // //           formDataForNewFiles.append('mediaFiles', file);
// // //         });
// // //         const uploadResponse = await uploadMediaFiles(formDataForNewFiles);
// // //         if (uploadResponse && uploadResponse.locations) {
// // //           console.log('DEBUG: New media files uploaded, locations:', uploadResponse.locations);
// // //           const uniqueNewUploadUrls = uploadResponse.locations.filter(url => !finalMediaUrls.includes(url));
// // //           finalMediaUrls = [...finalMediaUrls, ...uniqueNewUploadUrls];
// // //         } else {
// // //           throw new Error('Failed to upload new media files.');
// // //         }
// // //       }

// // //       const formDataPayload = new FormData();

// // //       Object.keys(editFormData).forEach(key => {
// // //         if (key === 'tags') {
// // //           formDataPayload.append(key, JSON.stringify(editFormData[key]));
// // //         } else if (editFormData[key] !== undefined && editFormData[key] !== null) {
// // //           formDataPayload.append(key, editFormData[key]);
// // //         } else {
// // //           formDataPayload.append(key, '');
// // //         }
// // //       });

// // //       formDataPayload.append('mediaUrls', JSON.stringify(finalMediaUrls));

// // //       console.log("DEBUG: Submitting formDataPayload (for debug, cannot inspect FormData directly):");
// // //       console.log("DEBUG:   title_en:", editFormData.title_en);
// // //       console.log("DEBUG:   content_en length:", editFormData.content_en?.length);
// // //       console.log("DEBUG:   finalMediaUrls (sent to backend):", finalMediaUrls);


// // //       const response = await updateNews(selectedNews._id, formDataPayload);
// // //       setUpdateSuccess(response.message || "News updated successfully!");
// // //       handleEditClose();
// // //       fetchMyNews(page);
// // //     } catch (error) {
// // //       console.error("ERROR: Failed to update news:", error);
// // //       setUpdateError(error.response?.data?.message || error.message || "Failed to update news.");
// // //     } finally {
// // //       setUpdating(false);
// // //     }
// // //   };

// // //   const handleDeleteClick = (item) => {
// // //     setSelectedNews(item);
// // //     setDeleteConfirmOpen(true);
// // //   };

// // //   const handleDeleteConfirm = async () => {
// // //     if (!selectedNews) return;
// // //     try {
// // //       setDeleting(true);
// // //       await deleteNews(selectedNews._id);
// // //       setDeleteConfirmOpen(false);
// // //       setViewOpen(false);
// // //       handleEditClose();
// // //       fetchMyNews(page);
// // //     } catch (error) {
// // //       console.error("ERROR: Failed to delete news:", error);
// // //     } finally {
// // //       setDeleting(false);
// // //     }
// // //   };

// // //   const handleDeleteCancel = () => {
// // //     setDeleteConfirmOpen(false);
// // //     setSelectedNews(null);
// // //   };

// // //   const selectedCategoryName = categoriesDropdown.find(cat => cat._id === editFormData.category)?.name?.toLowerCase();
// // //   const selectedSubCategoryName = subCategoriesDropdown.find(sub => sub._id === editFormData.subCategory)?.name?.toLowerCase();
// // //   const showSubSubCategoryDropdown = selectedCategoryName === 'astrology' && selectedSubCategoryName === 'rashi';

// // //   if (loading) {
// // //     return (
// // //       <div className="flex justify-center items-center mt-10">
// // //         <CircularProgress />
// // //       </div>
// // //     );
// // //   }

// // //   return (
// // //     <div className="p-4">
// // //       <Typography variant="h5" gutterBottom>
// // //         My News
// // //       </Typography>

// // //       {news.length === 0 ? (
// // //         <Typography>No news found.</Typography>
// // //       ) : (
// // //         <>
// // //           <TableContainer component={Paper}>
// // //             <Table>
// // //               <TableHead>
// // //                 <TableRow>
// // //                   <TableCell>Image</TableCell>
// // //                   <TableCell>Title (English)</TableCell>
// // //                   <TableCell>Category</TableCell>
// // //                   <TableCell>Status</TableCell>
// // //                   <TableCell>Created At</TableCell>
// // //                   <TableCell align="center">Action</TableCell>
// // //                 </TableRow>
// // //               </TableHead>
// // //               <TableBody>
// // //                 {news.map((item) => (
// // //                   <TableRow key={item._id}>
// // //                     <TableCell>
// // //                       {item.media && item.media.length > 0 ? (
// // //                         <img
// // //                           src={item.media[0].url}
// // //                           alt={item.media[0].caption || "News image"}
// // //                           style={{
// // //                             width: "70px",
// // //                             maxHeight: "70px",
// // //                             objectFit: "contain",
// // //                             borderRadius: "8px",
// // //                             backgroundColor: "#f0fdf9ff",
// // //                           }}
// // //                         />
// // //                       ) : (
// // //                         <Typography variant="caption" color="textSecondary">
// // //                           No Image
// // //                         </Typography>
// // //                       )}
// // //                     </TableCell>
// // //                     <TableCell>{item.title_en}</TableCell>
// // //                     <TableCell>{item.category?.name || "-"}</TableCell>
// // //                     <TableCell>{item.status}</TableCell>
// // //                     <TableCell>
// // //                       {item.createdAtDate} {item.createdAtTime}
// // //                     </TableCell>
// // //                     <TableCell align="center">
// // //                       <Button
// // //                         size="small"
// // //                         variant="outlined"
// // //                         onClick={() => handleViewOpen(item)}
// // //                         sx={{ mr: 1 }}
// // //                       >
// // //                         View
// // //                       </Button>
// // //                       <Button
// // //                         size="small"
// // //                         variant="outlined"
// // //                         color="primary"
// // //                         onClick={() => handleEditOpen(item)}
// // //                         sx={{ mr: 1 }}
// // //                       >
// // //                         Edit
// // //                       </Button>
// // //                       <Button
// // //                         size="small"
// // //                         variant="outlined"
// // //                         color="error"
// // //                         onClick={() => handleDeleteClick(item)}
// // //                       >
// // //                         Delete
// // //                       </Button>
// // //                     </TableCell>
// // //                   </TableRow>
// // //                 ))}
// // //               </TableBody>
// // //             </Table>
// // //           </TableContainer>

// // //           <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
// // //             <Pagination
// // //               count={totalPages}
// // //               page={page}
// // //               onChange={(e, value) => setPage(value)}
// // //               color="primary"
// // //             />
// // //             <Select
// // //               value={limit}
// // //               onChange={(e) => {
// // //                 setLimit(e.target.value);
// // //                 fetchMyNews(1);
// // //               }}
// // //             >
// // //               {[5, 10, 20, 50].map((l) => (
// // //                 <MenuItem key={l} value={l}>
// // //                   {l} per page
// // //                 </MenuItem>
// // //               ))}
// // //             </Select>
// // //           </Stack>
// // //         </>
// // //       )}

// // //       <Dialog open={viewOpen} onClose={handleViewClose} fullWidth maxWidth="md">
// // //         <DialogTitle>News Details</DialogTitle>
// // //         <DialogContent dividers>
// // //           {selectedNews?.media && selectedNews?.media.length > 0 && (
// // //             <img
// // //               src={selectedNews.media[0].url}
// // //               alt={selectedNews.media[0].caption || "News image"}
// // //               style={{
// // //                 width: "100%",
// // //                 maxHeight: "300px",
// // //                 objectFit: "contain",
// // //                 borderRadius: "8px",
// // //                 marginBottom: "16px",
// // //                 backgroundColor: "#f0fdf9ff",
// // //               }}
// // //             />
// // //           )}

// // //           <Typography variant="h6" gutterBottom><strong>Title (English):</strong> {selectedNews?.title_en || "-"}</Typography>
// // //           <Typography variant="h6" gutterBottom><strong>शीर्षक (हिंदी):</strong> {selectedNews?.title_hi || "-"}</Typography>

// // //           <Typography variant="subtitle1" gutterBottom><strong>Summary (English):</strong> {selectedNews?.summary_en || "-"}</Typography>
// // //           <Typography variant="subtitle1" gutterBottom><strong>सारांश (हिंदी):</strong> {selectedNews?.summary_hi || "-"}</Typography>

// // //           <Typography variant="subtitle1" gutterBottom><strong>Category:</strong> {selectedNews?.category?.name || "-"}</Typography>
// // //           <Typography variant="subtitle1" gutterBottom><strong>Sub Category:</strong> {selectedNews?.subCategory?.name || "-"}</Typography>
// // //           {selectedNews?.subSubCategory && (
// // //             <Typography variant="subtitle1" gutterBottom><strong>Sub-Sub Category (Rashi):</strong> {selectedNews.subSubCategory}</Typography>
// // //           )}
// // //           <Typography variant="subtitle1" gutterBottom><strong>Status:</strong> {selectedNews?.status}</Typography>
// // //           <Typography variant="subtitle1" gutterBottom><strong>Country:</strong> {selectedNews?.country?.name || "-"}</Typography>
// // //           <Typography variant="subtitle1" gutterBottom><strong>State:</strong> {selectedNews?.state?.name || "-"}</Typography>
// // //           <Typography variant="subtitle1" gutterBottom><strong>City:</strong> {selectedNews?.city?.name || "-"}</Typography>
// // //           <Typography variant="subtitle1" gutterBottom><strong>Local Address:</strong> {selectedNews?.localAddress || "-"}</Typography>
// // //           <Typography variant="subtitle1" gutterBottom><strong>Reporter:</strong> {selectedNews?.createdBy?.name || "-"} / ({selectedNews?.createdBy?.email})</Typography>

// // //           <Typography variant="subtitle2" gutterBottom><strong>Posted Date:</strong> {selectedNews?.postedDate || "N/A"} {selectedNews?.postedTime || "N/A"}</Typography>
// // //           <Typography variant="subtitle2" gutterBottom><strong>Last Updated:</strong> {selectedNews?.updatedAtDate} {selectedNews?.updatedAtTime}</Typography>

// // //           <Typography variant="body1" sx={{ mt: 2 }}>
// // //             <strong>Content (English):</strong>
// // //             <br />
// // //             <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_en || "No English content available" }} />
// // //           </Typography>
// // //           <Typography variant="body1" sx={{ mt: 2 }}>
// // //             <strong>सामग्री (हिंदी):</strong>
// // //             <br />
// // //             <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_hi || "कोई हिंदी सामग्री उपलब्ध नहीं है" }} />
// // //           </Typography>

// // //           {selectedNews?.tags?.length > 0 && (
// // //             <Typography variant="subtitle1" sx={{ mt: 2 }}>
// // //               <strong>Tags:</strong> {selectedNews.tags.join(", ")}
// // //             </Typography>
// // //           )}
// // //           {selectedNews?.referenceLinks?.length > 0 && (
// // //             <Box sx={{ mt: 2 }}>
// // //               <Typography variant="subtitle1"><strong>Reference Links:</strong></Typography>
// // //               <List dense>
// // //                 {selectedNews.referenceLinks.map((link, index) => (
// // //                   <ListItem key={index} disablePadding>
// // //                     <ListItemText primary={<a href={link} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{link}</a>} />
// // //                   </ListItem>
// // //                 ))}
// // //               </List>
// // //             </Box>
// // //           )}
// // //           {selectedNews?.mediaUrls?.length > 0 && ( // Display external media URLs if present
// // //             <Box sx={{ mt: 2 }}>
// // //               <Typography variant="subtitle1"><strong>External Media URLs:</strong></Typography>
// // //               <List dense>
// // //                 {selectedNews.mediaUrls.map((url, index) => (
// // //                   <ListItem key={index} disablePadding>
// // //                     <ListItemText primary={<a href={url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{url}</a>} />
// // //                   </ListItem>
// // //                 ))}
// // //               </List>
// // //             </Box>
// // //           )}
// // //           <Typography variant="subtitle2" sx={{ mt: 2 }}>
// // //             <strong>Views:</strong> {selectedNews?.viewsCount || 0}
// // //           </Typography>
// // //           <Typography variant="subtitle2">
// // //             <strong>Likes:</strong> {selectedNews?.likesCount || 0}
// // //           </Typography>
// // //           <Typography variant="subtitle2">
// // //             <strong>Comments:</strong> {selectedNews?.commentsCount || 0}
// // //           </Typography>
// // //         </DialogContent>

// // //         <DialogActions>
// // //           <Button onClick={handleViewClose} variant="contained" color="primary">
// // //             Close
// // //           </Button>
// // //           <Button
// // //             onClick={() => handleDeleteClick(selectedNews)}
// // //             variant="contained"
// // //             color="error"
// // //           >
// // //             Delete
// // //           </Button>

// // //         </DialogActions>
// // //       </Dialog>

// // //       <Dialog open={editOpen} onClose={handleEditClose} fullWidth maxWidth="md">
// // //         <DialogTitle>Edit News: {selectedNews?.title_en}</DialogTitle>
// // //         <DialogContent dividers>
// // //           {updateError && <Alert severity="error" sx={{ mb: 2 }}>{updateError}</Alert>}
// // //           {updateSuccess && <Alert severity="success" sx={{ mb: 2 }}>{updateSuccess}</Alert>}

// // //           <TextField
// // //             margin="dense"
// // //             name="title_en"
// // //             label="Title (English)"
// // //             type="text"
// // //             fullWidth
// // //             variant="outlined"
// // //             value={editFormData.title_en || ""}
// // //             onChange={handleEditFormChange}
// // //             sx={{ mb: 2 }}
// // //             error={!!formErrors.title_en}
// // //             helperText={formErrors.title_en}
// // //           />
// // //           <TextField
// // //             margin="dense"
// // //             name="title_hi"
// // //             label="शीर्षक (हिंदी)"
// // //             type="text"
// // //             fullWidth
// // //             variant="outlined"
// // //             value={editFormData.title_hi || ""}
// // //             onChange={handleEditFormChange}
// // //             sx={{ mb: 2 }}
// // //             error={!!formErrors.title_hi}
// // //             helperText={formErrors.title_hi}
// // //           />
// // //           <TextField
// // //             margin="dense"
// // //             name="summary_en"
// // //             label="Summary (English)"
// // //             type="text"
// // //             fullWidth
// // //             multiline
// // //             rows={2}
// // //             variant="outlined"
// // //             value={editFormData.summary_en || ""}
// // //             onChange={handleEditFormChange}
// // //             sx={{ mb: 2 }}
// // //             error={!!formErrors.summary_en}
// // //             helperText={formErrors.summary_en}
// // //           />
// // //           <TextField
// // //             margin="dense"
// // //             name="summary_hi"
// // //             label="सारांश (हिंदी)"
// // //             type="text"
// // //             fullWidth
// // //             multiline
// // //             rows={2}
// // //             variant="outlined"
// // //             value={editFormData.summary_hi || ""}
// // //             onChange={handleEditFormChange}
// // //             sx={{ mb: 2 }}
// // //             error={!!formErrors.summary_hi}
// // //             helperText={formErrors.summary_hi}
// // //           />

// // //           <Box sx={{ mt: 3, mb: 3 }}>
// // //             <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 1 }}>
// // //               Content (English) *
// // //             </Typography>
// // //             <Box sx={{ border: formErrors.content_en ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
// // //               <Editor
// // //                 apiKey="eqp6uwfvp5am7ljwyqw294zsk9cvb0n212tg8offs3ki9h6q"
// // //                 onInit={(evt, editor) => editorRefEn.current = editor}
// // //                 init={editorConfig}
// // //                 value={editFormData.content_en}
// // //                 onEditorChange={(content) => handleEditEditorChange(content, 'content_en')}
// // //               />
// // //             </Box>
// // //             {formErrors.content_en && (
// // //               <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
// // //                 {formErrors.content_en}
// // //               </Typography>
// // //             )}
// // //           </Box>
// // //           <Divider sx={{ my: 2 }} />

// // //           <Box sx={{ mt: 3, mb: 3 }}>
// // //             <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 1 }}>
// // //               सामग्री (हिंदी) *
// // //             </Typography>
// // //             <Box sx={{ border: formErrors.content_hi ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
// // //               <Editor
// // //                 apiKey="eqp6uwfvp5am7ljwyqw294zsk9cvb0n212tg8offs3ki9h6q"
// // //                 onInit={(evt, editor) => editorRefHi.current = editor}
// // //                 init={editorConfig}
// // //                 value={editFormData.content_hi}
// // //                 onEditorChange={(content) => handleEditEditorChange(content, 'content_hi')}
// // //               />
// // //             </Box>
// // //             {formErrors.content_hi && (
// // //               <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
// // //                 {formErrors.content_hi}
// // //               </Typography>
// // //             )}
// // //           </Box>
// // //           <Divider sx={{ my: 2 }} />

// // //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// // //             <InputLabel id="category-select-label">Category</InputLabel>
// // //             <Select
// // //               labelId="category-select-label"
// // //               name="category"
// // //               value={editFormData.category || ''}
// // //               label="Category"
// // //               onChange={handleEditFormChange}
// // //               error={!!formErrors.category}
// // //             >
// // //               <MenuItem value="">Select Category</MenuItem>
// // //               {categoriesDropdown.map((cat) => (
// // //                 <MenuItem key={cat._id} value={cat._id}>
// // //                   {cat.name}
// // //                 </MenuItem>
// // //               ))}
// // //             </Select>
// // //             {formErrors.category && (
// // //               <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
// // //                 {formErrors.category}
// // //               </Typography>
// // //             )}
// // //           </FormControl>

// // //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// // //             <InputLabel id="subcategory-select-label">Sub Category</InputLabel>
// // //             <Select
// // //               labelId="subcategory-select-label"
// // //               name="subCategory"
// // //               value={editFormData.subCategory || ''}
// // //               label="Sub Category"
// // //               onChange={handleEditFormChange}
// // //               disabled={!editFormData.category || subCategoriesDropdown.length === 0}
// // //             >
// // //               <MenuItem value="">Select Sub Category (Optional)</MenuItem>
// // //               {subCategoriesDropdown.map((subCat) => (
// // //                 <MenuItem key={subCat._id} value={subCat._id}>
// // //                   {subCat.name}
// // //                 </MenuItem>
// // //               ))}
// // //             </Select>
// // //           </FormControl>

// // //           {showSubSubCategoryDropdown && (
// // //             <TextField
// // //               label="Select Rashi (subSubCategory)"
// // //               name="subSubCategory"
// // //               select
// // //               fullWidth
// // //               margin="normal"
// // //               value={editFormData.subSubCategory}
// // //               onChange={handleEditFormChange}
// // //               sx={{ mb: 2 }}
// // //             >
// // //               <MenuItem value="">Select Rashi</MenuItem>
// // //               {RASHI_OPTIONS.map(r => (
// // //                 <MenuItem key={r} value={r}>{r}</MenuItem>
// // //               ))}
// // //             </TextField>
// // //           )}

// // //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// // //             <InputLabel htmlFor="news-tags">Tags (comma separated)</InputLabel>
// // //             <OutlinedInput
// // //               id="news-tags"
// // //               name="tags"
// // //               value={editFormData.tags?.join(', ') || ""}
// // //               onChange={handleTagsChange}
// // //               label="Tags (comma separated)"
// // //             />
// // //             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
// // //               {editFormData.tags?.map((tag, index) => (
// // //                 <Chip key={index} label={tag} />
// // //               ))}
// // //             </Box>
// // //           </FormControl>

// // //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// // //             <InputLabel id="country-select-label">Country</InputLabel>
// // //             <Select
// // //               labelId="country-select-label"
// // //               name="country"
// // //               value={editFormData.country || ''}
// // //               label="Country"
// // //               onChange={handleEditFormChange}
// // //             >
// // //               <MenuItem value="">Select Country (Optional)</MenuItem>
// // //               {countriesDropdown.map((country) => (
// // //                 <MenuItem key={country._id} value={country._id}>
// // //                   {country.name}
// // //                 </MenuItem>
// // //               ))}
// // //             </Select>
// // //           </FormControl>

// // //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// // //             <InputLabel id="state-select-label">State</InputLabel>
// // //             <Select
// // //               labelId="state-select-label"
// // //               name="state"
// // //               value={editFormData.state || ''}
// // //               label="State"
// // //               onChange={handleEditFormChange}
// // //               disabled={!editFormData.country || statesDropdown.length === 0}
// // //             >
// // //               <MenuItem value="">Select State (Optional)</MenuItem>
// // //               {statesDropdown.map((state) => (
// // //                 <MenuItem key={state._id} value={state._id}>
// // //                   {state.name}
// // //                 </MenuItem>
// // //               ))}
// // //             </Select>
// // //           </FormControl>

// // //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// // //             <InputLabel id="city-select-label">City</InputLabel>
// // //             <Select
// // //               labelId="city-select-label"
// // //               name="city"
// // //               value={editFormData.city || ''}
// // //               label="City"
// // //               onChange={handleEditFormChange}
// // //               disabled={!editFormData.state || citiesDropdown.length === 0}
// // //             >
// // //               <MenuItem value="">Select City (Optional)</MenuItem>
// // //               {citiesDropdown.map((city) => (
// // //                 <MenuItem key={city._id} value={city._id}>
// // //                   {city.name}
// // //                 </MenuItem>
// // //               ))}
// // //             </Select>
// // //           </FormControl>

// // //           <TextField
// // //             margin="dense"
// // //             name="localAddress"
// // //             label="Local Address"
// // //             type="text"
// // //             fullWidth
// // //             variant="outlined"
// // //             value={editFormData.localAddress || ""}
// // //             onChange={handleEditFormChange}
// // //             sx={{ mb: 2 }}
// // //           />
// // //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// // //             <InputLabel id="status-select-label">Status</InputLabel>
// // //             <Select
// // //               labelId="status-select-label"
// // //               name="status"
// // //               value={editFormData.status || ""}
// // //               label="Status"
// // //               onChange={handleEditFormChange}
// // //             >
// // //               <MenuItem value="draft">Draft</MenuItem>
// // //               <MenuItem value="pending_approval">Pending Approval</MenuItem>
// // //               <MenuItem value="posted">Posted</MenuItem>
// // //               <MenuItem value="live">Live</MenuItem>
// // //               <MenuItem value="rejected">Rejected</MenuItem>
// // //             </Select>
// // //           </FormControl>

// // //           <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
// // //             Media Files & External URLs
// // //           </Typography>
// // //           <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
// // //             Click 'X' to remove existing media. Upload new media using the button below or add external URLs.
// // //           </Typography>

// // //           <Button
// // //             variant="contained"
// // //             component="label"
// // //             sx={{ mt: 1, mb: 2 }}
// // //           >
// // //             Upload New Media Files
// // //             <input type="file" hidden multiple onChange={handleNewMediaUpload} accept="image/*,video/*" />
// // //           </Button>
// // //           <Box sx={{ mt: 1, mb: 2 }}>
// // //             {newMediaFiles.length > 0 && (
// // //               <Typography variant="body2" color="textSecondary">
// // //                 New files selected: {newMediaFiles.map(file => file.name).join(', ')}
// // //               </Typography>
// // //             )}
// // //             {newMediaFiles.length === 0 && (
// // //               <Typography variant="body2" color="textSecondary">
// // //                 No new files selected.
// // //               </Typography>
// // //             )}
// // //           </Box>

// // //           {/* External Media URL Section (Added similar to CreateNews) */}
// // //           <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mt: 2 }}>
// // //             <TextField
// // //               label="Add External Media URL"
// // //               fullWidth
// // //               value={mediaUrlInput}
// // //               onChange={handleMediaUrlInputChange}
// // //               placeholder="e.g., https://www.youtube.com/watch?v=..., https://example.com/image.jpg"
// // //               error={!!formErrors.mediaUrlInput}
// // //               helperText={formErrors.mediaUrlInput || "YouTube, Vimeo, direct image/video links supported"}
// // //               multiline
// // //               maxRows={2}
// // //             />
// // //             <Button
// // //               variant="contained"
// // //               onClick={handleAddMediaUrl}
// // //               startIcon={<AddCircleOutlineIcon />}
// // //               sx={{ flexShrink: 0, mt: 1 }}
// // //             >
// // //               Add URL
// // //             </Button>
// // //           </Box>

// // //           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2, mt:2 }}>
// // //             {existingMediaToKeep.map((url, index) => {
// // //               const fileType = url.match(/\.(jpeg|jpg|gif|png)$/i) ? 'image' : (url.match(/\.(mp4|webm|ogg)$/i) || url.includes('youtube.com') || url.includes('vimeo.com') ? 'video' : 'link');
// // //               return (
// // //                 <Box key={url} sx={{ position: 'relative', width: '100px', height: '100px', border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden' }}>
// // //                   {fileType === 'image' ? (
// // //                     <img
// // //                       src={url}
// // //                       alt={`Media ${index}`}
// // //                       style={{ width: '100%', height: '100%', objectFit: 'cover' }}
// // //                     />
// // //                   ) : fileType === 'video' ? (
// // //                     <video
// // //                       src={url}
// // //                       controls={false}
// // //                       style={{ width: '100%', height: '100%', objectFit: 'cover' }}
// // //                       preload="metadata"
// // //                     />
// // //                   ) : (
// // //                     <LinkIcon sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'text.secondary' }} />
// // //                   )}
// // //                   <IconButton
// // //                     size="small"
// // //                     sx={{
// // //                       position: 'absolute',
// // //                       top: 0,
// // //                       right: 0,
// // //                       backgroundColor: 'rgba(255, 255, 255, 0.7)',
// // //                       '&:hover': {
// // //                         backgroundColor: 'rgba(255, 255, 255, 0.9)',
// // //                       },
// // //                     }}
// // //                     onClick={() => handleRemoveExistingMedia(url)}
// // //                   >
// // //                     <CloseIcon fontSize="small" />
// // //                   </IconButton>
// // //                 </Box>
// // //               )
// // //             })}
// // //           </Box>


// // //         </DialogContent>

// // //         <DialogActions>
// // //           <Button onClick={handleEditClose} disabled={updating}>
// // //             Cancel
// // //           </Button>
// // //           <Button
// // //             onClick={handleUpdateSubmit}
// // //             variant="contained"
// // //             color="primary"
// // //             disabled={updating}
// // //           >
// // //             {updating ? "Updating..." : "Save Changes"}
// // //           </Button>
// // //         </DialogActions>
// // //       </Dialog>


// // //       <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
// // //         <DialogTitle>Confirm Delete</DialogTitle>
// // //         <DialogContent dividers>
// // //           Are you sure you want to delete this news?
// // //         </DialogContent>
// // //         <DialogActions>
// // //           <Button onClick={handleDeleteCancel} disabled={deleting}>
// // //             Cancel
// // //           </Button>
// // //           <Button
// // //             onClick={handleDeleteConfirm}
// // //             color="error"
// // //             variant="contained"
// // //             disabled={deleting}
// // //           >
// // //             {deleting ? "Deleting..." : "Delete"}
// // //           </Button>
// // //         </DialogActions>
// // //       </Dialog>
// // //     </div>
// // //   );
// // // };

// // // export default MyNewsAdmin;

// // //////////////////////////////////////////////////////////// wrok kar rhahai

// // import React, { useEffect, useState, useRef, useCallback } from "react";
// // import { getMyNews, deleteNews, updateNews, uploadMediaFiles } from "../../../services/adminService";
// // import {
// //   CircularProgress,
// //   Typography,
// //   Table,
// //   TableBody,
// //   TableCell,
// //   TableContainer,
// //   TableHead,
// //   TableRow,
// //   Paper,
// //   Button,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   Pagination,
// //   Stack,
// //   Select,
// //   MenuItem,
// //   TextField,
// //   FormControl,
// //   InputLabel,
// //   OutlinedInput,
// //   Chip,
// //   Box,
// //   IconButton,
// //   ListItem,
// //   List,
// //   ListItemText,
// //   Alert,
// //   Divider,
// //   ListItemIcon,
// // } from "@mui/material";
// // import CloseIcon from '@mui/icons-material/Close';
// // import { Editor } from '@tinymce/tinymce-react';

// // import {
// //   getCategories,
// //   getSubcategories,
// //   getCountries,
// //   getStatesByCountry,
// //   getCitiesByState,
// // } from '../../../services/apiService';
// // import LinkIcon from '@mui/icons-material/Link';
// // import VideoFileIcon from '@mui/icons-material/VideoFile';
// // import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined'; // Added for image type icon in media display
// // import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'; // Added for add button

// // const RASHI_OPTIONS = [
// //   "Mesh", "Vrishabh", "Mithun", "Karka", "Singh", "Kanya",
// //   "Tula", "Vrischik", "Dhanu", "Makar", "Kumbh", "Meen"
// // ];

// // const isValidUrl = (string) => {
// //   try {
// //     new URL(string);
// //     return true;
// //   } catch (e) {
// //     return false;
// //   }
// // };

// // const MyNewsAdmin = () => {
// //   const [news, setNews] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [viewOpen, setViewOpen] = useState(false);
// //   const [selectedNews, setSelectedNews] = useState(null);
// //   const [editOpen, setEditOpen] = useState(false);
// //   const [editFormData, setEditFormData] = useState({});
// //   const [newMediaFiles, setNewMediaFiles] = useState([]);
// //   const [existingMediaToKeep, setExistingMediaToKeep] = useState([]);
// //   const [mediaUrlInput, setMediaUrlInput] = useState(''); // New state for external media URL input
// //   const [formErrors, setFormErrors] = useState({}); // Added for form validation errors

// //   const [categoriesDropdown, setCategoriesDropdown] = useState([]);
// //   const [subCategoriesDropdown, setSubCategoriesDropdown] = useState([]);
// //   const [countriesDropdown, setCountriesDropdown] = useState([]);
// //   const [statesDropdown, setStatesDropdown] = useState([]);
// //   const [citiesDropdown, setCitiesDropdown] = useState([]);

// //   const [updateError, setUpdateError] = useState(null);
// //   const [updateSuccess, setUpdateSuccess] = useState(null);
// //   const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
// //   const [deleting, setDeleting] = useState(false);
// //   const [updating, setUpdating] = useState(false);

// //   const [page, setPage] = useState(1);
// //   const [limit, setLimit] = useState(10);
// //   const [totalPages, setTotalPages] = useState(1);

// //   const editorRefEn = useRef(null);
// //   const editorRefHi = useRef(null);

// //   const extractUrlsFromHtml = useCallback((htmlContent) => {
// //     const extracted = new Set();
// //     if (!htmlContent) return Array.from(extracted);

// //     const parser = new DOMParser();
// //     const doc = parser.parseFromString(htmlContent, 'text/html');

// //     // Selectors for elements with src or href attributes
// //     doc.querySelectorAll('img, video, source, iframe, a').forEach(el => {
// //       let url = el.getAttribute('src') || el.getAttribute('href');
// //       if (url && isValidUrl(url)) {
// //         extracted.add(url);
// //       }
// //     });

// //     // Selectors for srcset in images
// //     doc.querySelectorAll('img').forEach(el => {
// //       const srcset = el.getAttribute('srcset');
// //       if (srcset) {
// //         srcset.split(',').forEach(srcPart => {
// //           const url = srcPart.trim().split(' ')[0];
// //           if (url && isValidUrl(url)) {
// //             extracted.add(url);
// //           }
// //         });
// //       }
// //     });

// //     // Selectors for data-mce-src or data-mce-p-src (TinyMCE specific)
// //     doc.querySelectorAll('[data-mce-src]').forEach(el => {
// //       const dataMceSrc = el.getAttribute('data-mce-src');
// //       if (dataMceSrc && isValidUrl(dataMceSrc)) {
// //         extracted.add(dataMceSrc);
// //       }
// //     });

// //     doc.querySelectorAll('[data-mce-p-src]').forEach(el => {
// //       const dataMcePSrc = el.getAttribute('data-mce-p-src');
// //       if (dataMcePSrc && isValidUrl(dataMcePSrc)) {
// //         extracted.add(dataMcePSrc);
// //       }
// //     });
// //     return Array.from(extracted);
// //   }, []);

// //   const fetchMyNews = useCallback(async (pageNumber = page) => {
// //     try {
// //       setLoading(true);
// //       const response = await getMyNews({ page: pageNumber, limit });
// //       setNews(response.data || []);
// //       setTotalPages(response.totalPages || 1);
// //     } catch (error) {
// //       console.error("ERROR: Failed to load my news:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, [limit, page]);

// //   // --- START TinyMCE Editor Configuration (Copied from CreateNews) ---
// //   const editorConfig = {
// //     height: 500,
// //     menubar: true,
// //     branding: false,
// //     plugins: [
// //       'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
// //       'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
// //       'insertdatetime', 'media', 'table', 'help', 'wordcount', 'emoticons',
// //       'template', 'codesample', 'hr', 'pagebreak', 'nonbreaking',
// //       'toc', 'imagetools', 'textpattern', 'noneditable', 'quickbars',
// //       'accordion', 'autosave', 'save', 'directionality', 'visualchars'
// //     ],
// //     toolbar1: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify',
// //     toolbar2: 'outdent indent | numlist bullist | forecolor backcolor removeformat | charmap emoticons | fullscreen preview save print',
// //     toolbar3: 'insertfile image media link anchor | customupload | ltr rtl | showcomments addcomment',

// //     content_style: `
// //     body {
// //       font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
// //       font-size: 14px;
// //       line-height: 1.6;
// //       margin: 1rem;
// //     }
// //     img { max-width: 100%; height: auto; }
// //     .mce-content-body {
// //       padding: 20px;
// //       max-width: none;
// //     }
// //   `,

// //     paste_data_images: true,
// //     automatic_uploads: true,
// //     file_picker_types: 'image media',

// //     file_picker_callback: function (callback, value, meta) {
// //       console.log('File picker triggered for:', meta.filetype);

// //       const input = document.createElement('input');
// //       input.setAttribute('type', 'file');

// //       if (meta.filetype === 'image') {
// //         input.setAttribute('accept', 'image/*');
// //       } else if (meta.filetype === 'media') {
// //         input.setAttribute('accept', 'video/*,audio/*');
// //       } else {
// //         input.setAttribute('accept', 'image/*,video/*,audio/*');
// //       }

// //       input.onchange = function () {
// //         const file = this.files[0];

// //         if (!file) {
// //           console.log('No file selected');
// //           return;
// //         }

// //         console.log('File selected:', file.name, file.type, file.size);

// //         const editor = window.tinymce.activeEditor;
// //         editor.setProgressState(true);

// //         const formData = new FormData();
// //         formData.append('mediaFiles', file);

// //         uploadMediaFiles(formData)
// //           .then(response => {
// //             console.log('Upload response:', response);
// //             editor.setProgressState(false);

// //             if (response && response.locations && response.locations.length > 0) {
// //               const uploadedUrl = response.locations[0];
// //               console.log('File uploaded successfully:', uploadedUrl);

// //               setExistingMediaToKeep(prev => {
// //                 if (!prev.includes(uploadedUrl)) {
// //                   return [...prev, uploadedUrl];
// //                 }
// //                 return prev;
// //               });

// //               callback(uploadedUrl, {
// //                 title: file.name,
// //                 alt: file.name
// //               });

// //               editor.notificationManager.open({
// //                 text: `File "${file.name}" uploaded successfully!`,
// //                 type: 'success',
// //                 timeout: 3000
// //               });
// //             } else {
// //               throw new Error('No URL returned from upload service');
// //             }
// //           })
// //           .catch(error => {
// //             console.error('Upload failed:', error);
// //             editor.setProgressState(false);

// //             editor.notificationManager.open({
// //               text: `Upload failed: ${error.message || 'Unknown error'}`,
// //               type: 'error',
// //               timeout: 5000
// //             });

// //             alert(`File upload failed: ${error.message || 'Please try again'}`);
// //           });
// //       };

// //       input.click();
// //     },

// //     images_upload_handler: function (blobInfo, success, failure, progress) {
// //       console.log('Image upload handler triggered');
// //       console.log('Blob info:', blobInfo.filename(), blobInfo.blob().type, blobInfo.blob().size);

// //       const blob = blobInfo.blob();

// //       const file = new File([blob], blobInfo.filename() || `image-${Date.now()}.png`, {
// //         type: blob.type || 'image/png'
// //       });

// //       console.log('Created file object:', file);

// //       const formData = new FormData();
// //       formData.append('mediaFiles', file);

// //       const editor = window.tinymce.activeEditor;
// //       editor.setProgressState(true);

// //       uploadMediaFiles(formData)
// //         .then(response => {
// //           console.log('Upload response:', response);
// //           editor.setProgressState(false);

// //           if (response && response.locations && response.locations.length > 0) {
// //             const uploadedUrl = response.locations[0];
// //             console.log('Image uploaded successfully:', uploadedUrl);

// //             setExistingMediaToKeep(prev => {
// //               if (!prev.includes(uploadedUrl)) {
// //                 return [...prev, uploadedUrl];
// //               }
// //               return prev;
// //             });

// //             success(uploadedUrl);

// //             editor.notificationManager.open({
// //               text: `Image uploaded successfully!`,
// //               type: 'success',
// //               timeout: 3000
// //             });
// //           } else {
// //             throw new Error('No URL returned from upload service');
// //           }
// //         })
// //         .catch(error => {
// //           console.error('Image upload failed:', error);
// //           editor.setProgressState(false);

// //           failure(`Upload failed: ${error.message || 'Unknown error'}`);

// //           editor.notificationManager.open({
// //             text: `Upload failed: ${error.message || 'Unknown error'}`,
// //             type: 'error',
// //             timeout: 5000
// //           });
// //         });
// //     },

// //     setup: function (editor) {
// //       console.log('TinyMCE editor setup starting');

// //       editor.on('init', function () {
// //         console.log('TinyMCE editor initialized');
// //         editor.getContainer().style.transition = "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out";
// //       });

// //       // DEBUG: TinyMCE Image/Media Dialog debugging logic
// //       editor.on('OpenWindow', (e) => {
// //         if (e.dialog.title === 'Insert/Edit Image' || e.dialog.title === 'Insert/Edit Media') {
// //           console.log('DEBUG: TinyMCE Image/Media Dialog opened. Inspecting "Source" field...');
// //           // Using a timeout to ensure TinyMCE's dialog has fully rendered
// //           setTimeout(() => {
// //             const sourceInput = document.querySelector('.tox-dialog__body-content input[type="text"][aria-label="Source"]');
// //             const fallbackSourceInput = document.querySelector('.tox-textfield[name="src"]');

// //             const targetInput = sourceInput || fallbackSourceInput;

// //             if (targetInput) {
// //               console.log('DEBUG: Found TinyMCE "Source" input field programmatically.');
// //               console.log('DEBUG:   Element ID:', targetInput.id);
// //               console.log('DEBUG:   Element Name:', targetInput.name);
// //               console.log('DEBUG:   Disabled Attribute (before fix):', targetInput.disabled);
// //               console.log('DEBUG:   Readonly Attribute (before fix):', targetInput.readOnly);
// //               console.log('DEBUG:   Pointer Events CSS (before fix):', window.getComputedStyle(targetInput).pointerEvents);

// //               // Attempt to enable interaction
// //               if (targetInput.disabled) {
// //                 console.warn('DEBUG: "Source" input is disabled. Attempting to re-enable.');
// //                 targetInput.disabled = false;
// //                 targetInput.setAttribute('aria-disabled', 'false');
// //               }
// //               if (targetInput.readOnly) {
// //                 console.warn('DEBUG: "Source" input is readOnly. Attempting to remove readOnly.');
// //                 targetInput.readOnly = false;
// //               }
// //               if (window.getComputedStyle(targetInput).pointerEvents === 'none') {
// //                 console.warn('DEBUG: "Source" input has pointer-events: none. Attempting to set to auto.');
// //                 targetInput.style.setProperty('pointer-events', 'auto', 'important');
// //               }

// //               // After attempting to enable, try to focus it.
// //               setTimeout(() => {
// //                 if (targetInput && !targetInput.disabled && !targetInput.readOnly && window.getComputedStyle(targetInput).pointerEvents !== 'none') {
// //                   targetInput.focus();
// //                   console.log('DEBUG: Attempted to focus the "Source" input field.');
// //                 }
// //               }, 50);

// //               console.log('DEBUG:   Disabled Attribute (after fix):', targetInput.disabled);
// //               console.log('DEBUG:   Readonly Attribute (after fix):', targetInput.readOnly);
// //               console.log('DEBUG:   Pointer Events CSS (after fix):', window.getComputedStyle(targetInput).pointerEvents);

// //             } else {
// //               console.log('DEBUG: TinyMCE "Source" input field not found in dialog using known selectors.');
// //             }
// //           }, 500);
// //         }
// //       });
// //       // --- END: Debugging code ---

// //       // Add custom upload button to toolbar
// //       editor.ui.registry.addButton('customupload', {
// //         text: 'Upload Media',
// //         icon: 'upload',
// //         tooltip: 'Upload images or videos',
// //         onAction: function () {
// //           console.log('Custom upload button clicked');

// //           const input = document.createElement('input');
// //           input.setAttribute('type', 'file');
// //           input.setAttribute('accept', 'image/*,video/*');
// //           input.setAttribute('multiple', 'true');

// //           input.onchange = function () {
// //             const files = Array.from(this.files);
// //             console.log('Multiple files selected:', files.length);

// //             if (files.length === 0) return;

// //             editor.setProgressState(true);

// //             const formData = new FormData();
// //             files.forEach(file => {
// //               formData.append('mediaFiles', file);
// //               console.log('Adding file to FormData:', file.name);
// //             });

// //             uploadMediaFiles(formData)
// //               .then(response => {
// //                 console.log('Batch upload response:', response);
// //                 editor.setProgressState(false);

// //                 if (response && response.locations && response.locations.length > 0) {
// //                   setExistingMediaToKeep(prev => {
// //                     const newUrls = response.locations.filter(url => !prev.includes(url));
// //                     return [...prev, ...newUrls];
// //                   });

// //                   response.locations.forEach((url, index) => {
// //                     const file = files[index];
// //                     if (file && file.type.startsWith('image/')) {
// //                       editor.insertContent(`<img src="${url}" alt="${file.name}" style="max-width: 100%; height: auto;" />`);
// //                     } else if (file && file.type.startsWith('video/')) {
// //                       editor.insertContent(`<video controls style="max-width: 100%; height: auto;">
// //                       <source src="${url}" type="${file.type}">
// //                       Your browser does not support the video tag.
// //                     </video>`);
// //                     }
// //                   });

// //                   editor.notificationManager.open({
// //                     text: `Successfully uploaded ${response.locations.length} file(s)!`,
// //                     type: 'success',
// //                     timeout: 3000
// //                   });
// //                 } else {
// //                   throw new Error('No URLs returned from upload service');
// //                 }
// //               })
// //               .catch(error => {
// //                 console.error('Batch upload failed:', error);
// //                 editor.setProgressState(false);

// //                 editor.notificationManager.open({
// //                   text: `Upload failed: ${error.message || 'Unknown error'}`,
// //                   type: 'error',
// //                   timeout: 5000
// //                 });
// //               });
// //           };

// //           input.click();
// //         }
// //       });

// //       editor.on('drop', function (e) {
// //         console.log('File(s) dropped on editor');
// //       });

// //       editor.on('paste', function (e) {
// //         console.log('Content pasted into editor');
// //       });
// //     },

// //     contextmenu: 'link image table',
// //     quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
// //     quickbars_insert_toolbar: 'quickimage quicktable customupload',
// //     powerpaste_word_import: 'clean',
// //     powerpaste_html_import: 'clean',

// //     image_advtab: true,
// //     image_uploadtab: true,
// //     image_caption: true,
// //     image_title: true,

// //     formats: {
// //       alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'left' },
// //       aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'center' },
// //       alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'right' },
// //       alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'full' },
// //       bold: { inline: 'strong' },
// //       italic: { inline: 'em' },
// //       underline: { inline: 'u' },
// //       strikethrough: { inline: 'del' },
// //       customformat: { inline: 'span', styles: { color: '#00ff00', fontSize: '20px' }, attributes: { title: 'My custom format' }, classes: 'example1' }
// //     }
// //   };
// //   // --- END TinyMCE Editor Configuration ---


// //   useEffect(() => {
// //     const fetchInitialDropdownData = async () => {
// //       try {
// //         const [catsRes, countriesRes] = await Promise.all([
// //           getCategories(),
// //           getCountries(),
// //         ]);
// //         setCategoriesDropdown(catsRes.data || []);
// //         setCountriesDropdown(countriesRes.data || []);
// //       } catch (err) {
// //         console.error("ERROR: Failed to load initial dropdown data (categories/countries):", err);
// //       }
// //     };
// //     fetchInitialDropdownData();
// //     fetchMyNews();
// //   }, [limit, fetchMyNews]);

// //   const fetchSubcategoriesForEdit = useCallback(async (categoryId) => {
// //     if (categoryId) {
// //       try {
// //         const res = await getSubcategories(categoryId);
// //         setSubCategoriesDropdown(res.data || []);
// //       } catch (err) {
// //         console.error("ERROR: Failed to load subcategories for edit:", err);
// //         setSubCategoriesDropdown([]);
// //       }
// //     } else {
// //       setSubCategoriesDropdown([]);
// //     }
// //   }, []);

// //   const fetchStatesForEdit = useCallback(async (countryId) => {
// //     if (countryId) {
// //       try {
// //         const res = await getStatesByCountry(countryId);
// //         setStatesDropdown(res.data || []);
// //       } catch (err) {
// //         console.error("ERROR: Failed to load states for edit:", err);
// //         setStatesDropdown([]);
// //       }
// //     } else {
// //       setStatesDropdown([]);
// //     }
// //   }, []);

// //   const fetchCitiesForEdit = useCallback(async (stateId) => {
// //     if (stateId) {
// //       try {
// //         const res = await getCitiesByState(stateId);
// //         setCitiesDropdown(res.data || []);
// //       } catch (err) {
// //         console.error("ERROR: Failed to load cities for edit:", err);
// //         setCitiesDropdown([]);
// //       }
// //     } else {
// //       setCitiesDropdown([]);
// //     }
// //   }, []);


// //   const handleViewOpen = (item) => {
// //     setSelectedNews(item);
// //     setViewOpen(true);
// //   };

// //   const handleViewClose = () => {
// //     setViewOpen(false);
// //     setSelectedNews(null);
// //   };

// //   const handleEditOpen = async (item) => {
// //     console.log('DEBUG: handleEditOpen triggered for news item:', item._id);
// //     setSelectedNews(item);
// //     setUpdateError(null);
// //     setUpdateSuccess(null);
// //     setFormErrors({}); // Clear form errors on opening edit dialog

// //     await fetchSubcategoriesForEdit(item.category?._id);
// //     await fetchStatesForEdit(item.country?._id);
// //     await fetchCitiesForEdit(item.state?._id);

// //     setEditFormData({
// //       title_en: item.title_en || '',
// //       title_hi: item.title_hi || '',
// //       content_en: item.content_en || '',
// //       content_hi: item.content_hi || '',
// //       summary_en: item.summary_en || '',
// //       summary_hi: item.summary_hi || '',
// //       category: item.category?._id || '',
// //       subCategory: item.subCategory?._id || '',
// //       tags: item.tags || [],
// //       country: item.country?._id || '',
// //       state: item.state?._id || '',
// //       city: item.city?._id || '',
// //       localAddress: item.localAddress || '',
// //       status: item.status,
// //       subSubCategory: item.subSubCategory || '',
// //     });

// //     let initialMediaUrlsToKeep = new Set(item.media ? item.media.map(m => m.url) : []);

// //     if (item.mediaUrls && Array.isArray(item.mediaUrls)) {
// //         item.mediaUrls.forEach(url => initialMediaUrlsToKeep.add(url));
// //     }

// //     const urlsFromEnglishContent = extractUrlsFromHtml(item.content_en);
// //     const urlsFromHindiContent = extractUrlsFromHtml(item.content_hi);

// //     urlsFromEnglishContent.forEach(url => initialMediaUrlsToKeep.add(url));
// //     urlsFromHindiContent.forEach(url => initialMediaUrlsToKeep.add(url));

// //     setExistingMediaToKeep(Array.from(initialMediaUrlsToKeep));
// //     console.log("DEBUG: handleEditOpen: Initial existingMediaToKeep set to:", Array.from(initialMediaUrlsToKeep));

// //     setNewMediaFiles([]);
// //     setMediaUrlInput(''); // Reset external URL input
// //     setEditOpen(true);
// //   };

// //   const handleEditClose = () => {
// //     console.log('DEBUG: handleEditClose triggered.');
// //     setEditOpen(false);
// //     setSelectedNews(null);
// //     setEditFormData({});
// //     setNewMediaFiles([]);
// //     setExistingMediaToKeep([]);
// //     setSubCategoriesDropdown([]);
// //     setStatesDropdown([]);
// //     setCitiesDropdown([]);
// //     setUpdateError(null);
// //     setUpdateSuccess(null);
// //     setMediaUrlInput('');
// //     setFormErrors({}); // Clear form errors on closing
// //   };

// //   const handleEditFormChange = async (e) => {
// //     const { name, value } = e.target;
// //     setEditFormData((prevData) => ({
// //       ...prevData,
// //       [name]: value,
// //     }));
// //     setFormErrors((prev) => ({ ...prev, [name]: '' }));

// //     if (name === 'category') {
// //       setEditFormData((prevData) => ({ ...prevData, subCategory: '', subSubCategory: '' }));
// //       await fetchSubcategoriesForEdit(value);
// //     } else if (name === 'country') {
// //       setEditFormData((prevData) => ({ ...prevData, state: '', city: '' }));
// //       await fetchStatesForEdit(value);
// //     } else if (name === 'state') {
// //       setEditFormData((prevData) => ({ ...prevData, city: '' }));
// //       await fetchCitiesForEdit(value);
// //     }
// //   };

// //   const handleEditEditorChange = (content, editorName) => {
// //     setEditFormData((prevData) => ({
// //       ...prevData,
// //       [editorName]: content,
// //     }));
// //     setFormErrors((prev) => ({ ...prev, [editorName]: '' }));

// //     console.log('DEBUG: --- TinyMCE Editor Content Changed (onEditorChange) ---');
// //     console.log('DEBUG: Editor Name:', editorName);

// //     const extractedUrlsFromCurrentContent = extractUrlsFromHtml(content);

// //     setExistingMediaToKeep(prev => {
// //       const combinedUrls = new Set([...prev, ...extractedUrlsFromCurrentContent]);
// //       const finalUniqueUrls = Array.from(combinedUrls);
// //       return finalUniqueUrls;
// //     });
// //     console.log('DEBUG: --- End Editor Content Change ---');
// //   };

// //   const handleTagsChange = (e) => {
// //     const tagsArray = e.target.value.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
// //     setEditFormData((prevData) => ({
// //       ...prevData,
// //       tags: tagsArray,
// //     }));
// //   };

// //   const handleNewMediaUpload = (e) => {
// //     console.log('DEBUG: handleNewMediaUpload triggered.');
// //     setNewMediaFiles(Array.from(e.target.files));
// //   };

// //   const handleRemoveExistingMedia = (urlToRemove) => {
// //     console.log('DEBUG: handleRemoveExistingMedia triggered for URL:', urlToRemove);
// //     setExistingMediaToKeep((prev) => prev.filter((url) => url !== urlToRemove));
// //   };

// //   const handleMediaUrlInputChange = (e) => {
// //     setMediaUrlInput(e.target.value);
// //     setFormErrors((prev) => ({ ...prev, mediaUrlInput: '' }));
// //   };

// //   const handleAddMediaUrl = () => {
// //     const url = mediaUrlInput.trim();
// //     if (url) {
// //       if (!isValidUrl(url)) {
// //         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' }));
// //         return;
// //       }
// //       if (!existingMediaToKeep.includes(url)) {
// //         setExistingMediaToKeep(prev => [...prev, url]);
// //         setMediaUrlInput('');
// //       } else {
// //         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'This URL has already been added.' }));
// //       }
// //     }
// //   };

// //   const handleUpdateSubmit = async () => {
// //     if (!selectedNews) return;

// //     setUpdating(true);
// //     setUpdateError(null);
// //     setUpdateSuccess(null);
// //     setFormErrors({});

// //     let currentMediaUrls = [...existingMediaToKeep];
// //     const currentMediaUrlInputVal = mediaUrlInput.trim();
// //     if (currentMediaUrlInputVal) {
// //       if (!isValidUrl(currentMediaUrlInputVal)) {
// //         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' }));
// //         setUpdating(false);
// //         setUpdateError("Please correct the errors in the form.");
// //         return;
// //       }
// //       if (!currentMediaUrls.includes(currentMediaUrlInputVal)) {
// //         currentMediaUrls.push(currentMediaUrlInputVal);
// //       } else {
// //         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'This URL has already been added.' }));
// //         setUpdating(false);
// //         setUpdateError("Please correct the errors in the form.");
// //         return;
// //       }
// //     }

// //     try {
// //       let finalMediaUrls = [...currentMediaUrls];

// //       if (newMediaFiles.length > 0) {
// //         console.log('DEBUG: Uploading new media files from dedicated button...');
// //         const formDataForNewFiles = new FormData();
// //         newMediaFiles.forEach(file => {
// //           formDataForNewFiles.append('mediaFiles', file);
// //         });
// //         const uploadResponse = await uploadMediaFiles(formDataForNewFiles);
// //         if (uploadResponse && uploadResponse.locations) {
// //           console.log('DEBUG: New media files uploaded, locations:', uploadResponse.locations);
// //           const uniqueNewUploadUrls = uploadResponse.locations.filter(url => !finalMediaUrls.includes(url));
// //           finalMediaUrls = [...finalMediaUrls, ...uniqueNewUploadUrls];
// //         } else {
// //           throw new Error('Failed to upload new media files.');
// //         }
// //       }

// //       const formDataPayload = new FormData();

// //       Object.keys(editFormData).forEach(key => {
// //         if (key === 'tags') {
// //           formDataPayload.append(key, JSON.stringify(editFormData[key]));
// //         } else if (editFormData[key] !== undefined && editFormData[key] !== null) {
// //           formDataPayload.append(key, editFormData[key]);
// //         } else {
// //           formDataPayload.append(key, '');
// //         }
// //       });

// //       formDataPayload.append('mediaUrls', JSON.stringify(finalMediaUrls));

// //       console.log("DEBUG: Submitting formDataPayload (for debug, cannot inspect FormData directly):");
// //       console.log("DEBUG:   title_en:", editFormData.title_en);
// //       console.log("DEBUG:   content_en length:", editFormData.content_en?.length);
// //       console.log("DEBUG:   finalMediaUrls (sent to backend):", finalMediaUrls);


// //       const response = await updateNews(selectedNews._id, formDataPayload);
// //       setUpdateSuccess(response.message || "News updated successfully!");
// //       handleEditClose();
// //       fetchMyNews(page);
// //     } catch (error) {
// //       console.error("ERROR: Failed to update news:", error);
// //       setUpdateError(error.response?.data?.message || error.message || "Failed to update news.");
// //     } finally {
// //       setUpdating(false);
// //     }
// //   };

// //   const handleDeleteClick = (item) => {
// //     setSelectedNews(item);
// //     setDeleteConfirmOpen(true);
// //   };

// //   const handleDeleteConfirm = async () => {
// //     if (!selectedNews) return;
// //     try {
// //       setDeleting(true);
// //       await deleteNews(selectedNews._id);
// //       setDeleteConfirmOpen(false);
// //       setViewOpen(false);
// //       handleEditClose();
// //       fetchMyNews(page);
// //     } catch (error) {
// //       console.error("ERROR: Failed to delete news:", error);
// //     } finally {
// //       setDeleting(false);
// //     }
// //   };

// //   const handleDeleteCancel = () => {
// //     setDeleteConfirmOpen(false);
// //     setSelectedNews(null);
// //   };

// //   const selectedCategoryName = categoriesDropdown.find(cat => cat._id === editFormData.category)?.name?.toLowerCase();
// //   const selectedSubCategoryName = subCategoriesDropdown.find(sub => sub._id === editFormData.subCategory)?.name?.toLowerCase();
// //   const showSubSubCategoryDropdown = selectedCategoryName === 'astrology' && selectedSubCategoryName === 'rashi';

// //   if (loading) {
// //     return (
// //       <div className="flex justify-center items-center mt-10">
// //         <CircularProgress />
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="p-4">
// //       <Typography variant="h5" gutterBottom>
// //         My News
// //       </Typography>

// //       {news.length === 0 ? (
// //         <Typography>No news found.</Typography>
// //       ) : (
// //         <>
// //           <TableContainer component={Paper}>
// //             <Table>
// //               <TableHead>
// //                 <TableRow>
// //                   <TableCell>Image</TableCell>
// //                   <TableCell>Title (English)</TableCell>
// //                   <TableCell>Category</TableCell>
// //                   <TableCell>Status</TableCell>
// //                   <TableCell>Created At</TableCell>
// //                   <TableCell align="center">Action</TableCell>
// //                 </TableRow>
// //               </TableHead>
// //               <TableBody>
// //                 {news.map((item) => (
// //                   <TableRow key={item._id}>
// //                     <TableCell>
// //   {item.media && item.media.length > 0 ? (
// //     item.media[0].type === "video" ? (
// //       <video
// //         src={item.media[0].url}
// //         width="90"
// //         height="60"
// //         controls={false}
// //         autoPlay="true"
// //         muted
// //         loop
// //         style={{
// //           borderRadius: "8px",
// //           objectFit: "cover",
// //           backgroundColor: "#f0fdf9ff",
// //         }}
// //       />
// //     ) : (
// //       <img
// //         src={item.media[0].url}
// //         alt={item.media[0].caption || "News image"}
// //         style={{
// //           width: "90px",
// //           maxHeight: "70px",
// //           objectFit: "contain",
// //           borderRadius: "8px",
// //           backgroundColor: "#f0fdf9ff",
// //         }}
// //       />
// //     )
// //   ) : (
// //     <Typography variant="caption" color="textSecondary">
// //       No Media
// //     </Typography>
// //   )}
// // </TableCell>

// //                     {/* <TableCell>{item.title_en}</TableCell> */}
// //                     <TableCell>{item.title_en || item.title_hi}</TableCell>
// //                     <TableCell>{item.category?.name || "-"}</TableCell>
// //                     <TableCell>{item.status}</TableCell>
// //                     <TableCell>
// //                       {item.createdAtDate} {item.createdAtTime}
// //                     </TableCell>
// //                     <TableCell align="center">
// //                       <Button
// //                         size="small"
// //                         variant="outlined"
// //                         onClick={() => handleViewOpen(item)}
// //                         sx={{ mr: 1 }}
// //                       >
// //                         View
// //                       </Button>
// //                       <Button
// //                         size="small"
// //                         variant="outlined"
// //                         color="primary"
// //                         onClick={() => handleEditOpen(item)}
// //                         sx={{ mr: 1 }}
// //                       >
// //                         Edit
// //                       </Button>
// //                       <Button
// //                         size="small"
// //                         variant="outlined"
// //                         color="error"
// //                         onClick={() => handleDeleteClick(item)}
// //                       >
// //                         Delete
// //                       </Button>
// //                     </TableCell>
// //                   </TableRow>
// //                 ))}
// //               </TableBody>
// //             </Table>

            
// //           </TableContainer>
// //           <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
// //             <Pagination
// //               count={totalPages}
// //               page={page}
// //               onChange={(e, value) => setPage(value)}
// //               color="primary"
// //             />
// //             <Select
// //               value={limit}
// //               onChange={(e) => {
// //                 setLimit(e.target.value);
// //                 fetchMyNews(1);
// //               }}
// //             >
// //               {[5, 10, 20, 50].map((l) => (
// //                 <MenuItem key={l} value={l}>
// //                   {l} per page
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </Stack>

// //           {/* <Stack spacing={2} sx={{ mt: 2 }} alignItems="center}>
// //             <Pagination
// //               count={totalPages}
// //               page={page}
// //               onChange={(e, value) => setPage(value)}
// //               color="primary"
// //             />
// //             <Select
// //               value={limit}
// //               onChange={(e) => {
// //                 setLimit(e.target.value);
// //                 fetchMyNews(1);
// //               }}
// //             >
// //               {[5, 10, 20, 50].map((l) => (
// //                 <MenuItem key={l} value={l}>
// //                   {l} per page
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </Stack> */}
// //         </>
// //       )}

// //       <Dialog open={viewOpen} onClose={handleViewClose} fullWidth maxWidth="md">
// //         <DialogTitle>News Details</DialogTitle>
// //         <DialogContent dividers>
// //           {selectedNews?.media && selectedNews?.media.length > 0 && (
// //             <img
// //               src={selectedNews.media[0].url}
// //               alt={selectedNews.media[0].caption || "News image"}
// //               style={{
// //                 width: "100%",
// //                 maxHeight: "300px",
// //                 objectFit: "contain",
// //                 borderRadius: "8px",
// //                 marginBottom: "16px",
// //                 backgroundColor: "#f0fdf9ff",
// //               }}
// //             />
// //           )}

// //           <Typography variant="h6" gutterBottom><strong>Title (English):</strong> {selectedNews?.title_en || "-"}</Typography>
// //           <Typography variant="h6" gutterBottom><strong>शीर्षक (हिंदी):</strong> {selectedNews?.title_hi || "-"}</Typography>

// //           <Typography variant="subtitle1" gutterBottom><strong>Summary (English):</strong> {selectedNews?.summary_en || "-"}</Typography>
// //           <Typography variant="subtitle1" gutterBottom><strong>सारांश (हिंदी):</strong> {selectedNews?.summary_hi || "-"}</Typography>

// //           <Typography variant="subtitle1" gutterBottom><strong>Category:</strong> {selectedNews?.category?.name || "-"}</Typography>
// //           <Typography variant="subtitle1" gutterBottom><strong>Sub Category:</strong> {selectedNews?.subCategory?.name || "-"}</Typography>
// //           {selectedNews?.subSubCategory && (
// //             <Typography variant="subtitle1" gutterBottom><strong>Sub-Sub Category (Rashi):</strong> {selectedNews.subSubCategory}</Typography>
// //           )}
// //           <Typography variant="subtitle1" gutterBottom><strong>Status:</strong> {selectedNews?.status}</Typography>
// //           <Typography variant="subtitle1" gutterBottom><strong>Country:</strong> {selectedNews?.country?.name || "-"}</Typography>
// //           <Typography variant="subtitle1" gutterBottom><strong>State:</strong> {selectedNews?.state?.name || "-"}</Typography>
// //           <Typography variant="subtitle1" gutterBottom><strong>City:</strong> {selectedNews?.city?.name || "-"}</Typography>
// //           <Typography variant="subtitle1" gutterBottom><strong>Local Address:</strong> {selectedNews?.localAddress || "-"}</Typography>
// //           <Typography variant="subtitle1" gutterBottom><strong>Reporter:</strong> {selectedNews?.createdBy?.name || "-"} / ({selectedNews?.createdBy?.email})</Typography>

// //           <Typography variant="subtitle2" gutterBottom><strong>Posted Date:</strong> {selectedNews?.postedDate || "N/A"} {selectedNews?.postedTime || "N/A"}</Typography>
// //           <Typography variant="subtitle2" gutterBottom><strong>Last Updated:</strong> {selectedNews?.updatedAtDate} {selectedNews?.updatedAtTime}</Typography>

// //           <Typography variant="body1" sx={{ mt: 2 }}>
// //             <strong>Content (English):</strong>
// //             <br />
// //             <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_en || "No English content available" }} />
// //           </Typography>
// //           <Typography variant="body1" sx={{ mt: 2 }}>
// //             <strong>सामग्री (हिंदी):</strong>
// //             <br />
// //             <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_hi || "कोई हिंदी सामग्री उपलब्ध नहीं है" }} />
// //           </Typography>

// //           {selectedNews?.tags?.length > 0 && (
// //             <Typography variant="subtitle1" sx={{ mt: 2 }}>
// //               <strong>Tags:</strong> {selectedNews.tags.join(", ")}
// //             </Typography>
// //           )}
// //           {selectedNews?.referenceLinks?.length > 0 && (
// //             <Box sx={{ mt: 2 }}>
// //               <Typography variant="subtitle1"><strong>Reference Links:</strong></Typography>
// //               <List dense>
// //                 {selectedNews.referenceLinks.map((link, index) => (
// //                   <ListItem key={index} disablePadding>
// //                     <ListItemText primary={<a href={link} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{link}</a>} />
// //                   </ListItem>
// //                 ))}
// //               </List>
// //             </Box>
// //           )}
// //           {selectedNews?.mediaUrls?.length > 0 && ( // Display external media URLs if present
// //             <Box sx={{ mt: 2 }}>
// //               <Typography variant="subtitle1"><strong>External Media URLs:</strong></Typography>
// //               <List dense>
// //                 {selectedNews.mediaUrls.map((url, index) => (
// //                   <ListItem key={index} disablePadding>
// //                     <ListItemText primary={<a href={url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{url}</a>} />
// //                   </ListItem>
// //                 ))}
// //               </List>
// //             </Box>
// //           )}
// //           <Typography variant="subtitle2" sx={{ mt: 2 }}>
// //             <strong>Views:</strong> {selectedNews?.viewsCount || 0}
// //           </Typography>
// //           <Typography variant="subtitle2">
// //             <strong>Likes:</strong> {selectedNews?.likesCount || 0}
// //           </Typography>
// //           <Typography variant="subtitle2">
// //             <strong>Comments:</strong> {selectedNews?.commentsCount || 0}
// //           </Typography>
// //         </DialogContent>

// //         <DialogActions>
// //           <Button onClick={handleViewClose} variant="contained" color="primary">
// //             Close
// //           </Button>
// //           <Button
// //             onClick={() => handleDeleteClick(selectedNews)}
// //             variant="contained"
// //             color="error"
// //           >
// //             Delete
// //           </Button>

// //         </DialogActions>
// //       </Dialog>

// //       <Dialog open={editOpen} onClose={handleEditClose} fullWidth maxWidth="md" disableEnforceFocus={true}> {/*  <<<<---- यहां disableEnforceFocus={true} जोड़ा गया है */}
// //        <DialogTitle>
// //   Edit News: {selectedNews?.title_en || selectedNews?.title_hi}
// // </DialogTitle>

// //         <DialogContent dividers>
// //           {updateError && <Alert severity="error" sx={{ mb: 2 }}>{updateError}</Alert>}
// //           {updateSuccess && <Alert severity="success" sx={{ mb: 2 }}>{updateSuccess}</Alert>}

// //           <TextField
// //             margin="dense"
// //             name="title_en"
// //             label="Title (English)"
// //             type="text"
// //             fullWidth
// //             variant="outlined"
// //             value={editFormData.title_en || ""}
// //             onChange={handleEditFormChange}
// //             sx={{ mb: 2 }}
// //             error={!!formErrors.title_en}
// //             helperText={formErrors.title_en}
// //           />
// //           <TextField
// //             margin="dense"
// //             name="title_hi"
// //             label="शीर्षक (हिंदी)"
// //             type="text"
// //             fullWidth
// //             variant="outlined"
// //             value={editFormData.title_hi || ""}
// //             onChange={handleEditFormChange}
// //             sx={{ mb: 2 }}
// //             error={!!formErrors.title_hi}
// //             helperText={formErrors.title_hi}
// //           />
// //           <TextField
// //             margin="dense"
// //             name="summary_en"
// //             label="Summary (English)"
// //             type="text"
// //             fullWidth
// //             multiline
// //             rows={2}
// //             variant="outlined"
// //             value={editFormData.summary_en || ""}
// //             onChange={handleEditFormChange}
// //             sx={{ mb: 2 }}
// //             error={!!formErrors.summary_en}
// //             helperText={formErrors.summary_en}
// //           />
// //           <TextField
// //             margin="dense"
// //             name="summary_hi"
// //             label="सारांश (हिंदी)"
// //             type="text"
// //             fullWidth
// //             multiline
// //             rows={2}
// //             variant="outlined"
// //             value={editFormData.summary_hi || ""}
// //             onChange={handleEditFormChange}
// //             sx={{ mb: 2 }}
// //             error={!!formErrors.summary_hi}
// //             helperText={formErrors.summary_hi}
// //           />

// //           <Box sx={{ mt: 3, mb: 3 }}>
// //             <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 1 }}>
// //               Content (English) *
// //             </Typography>
// //             <Box sx={{ border: formErrors.content_en ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
// //               <Editor
// //                 apiKey="eqp6uwfvp5am7ljwyqw294zsk9cvb0n212tg8offs3ki9h6q"
// //                 onInit={(evt, editor) => editorRefEn.current = editor}
// //                 init={editorConfig}
// //                 value={editFormData.content_en}
// //                 onEditorChange={(content) => handleEditEditorChange(content, 'content_en')}
// //               />
// //             </Box>
// //             {formErrors.content_en && (
// //               <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
// //                 {formErrors.content_en}
// //               </Typography>
// //             )}
// //           </Box>
// //           <Divider sx={{ my: 2 }} />

// //           <Box sx={{ mt: 3, mb: 3 }}>
// //             <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 1 }}>
// //               सामग्री (हिंदी) *
// //             </Typography>
// //             <Box sx={{ border: formErrors.content_hi ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
// //               <Editor
// //                 apiKey="eqp6uwfvp5am7ljwyqw294zsk9cvb0n212tg8offs3ki9h6q"
// //                 onInit={(evt, editor) => editorRefHi.current = editor}
// //                 init={editorConfig}
// //                 value={editFormData.content_hi}
// //                 onEditorChange={(content) => handleEditEditorChange(content, 'content_hi')}
// //               />
// //             </Box>
// //             {formErrors.content_hi && (
// //               <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
// //                 {formErrors.content_hi}
// //               </Typography>
// //             )}
// //           </Box>
// //           <Divider sx={{ my: 2 }} />

// //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// //             <InputLabel id="category-select-label">Category</InputLabel>
// //             <Select
// //               labelId="category-select-label"
// //               name="category"
// //               value={editFormData.category || ''}
// //               label="Category"
// //               onChange={handleEditFormChange}
// //               error={!!formErrors.category}
// //             >
// //               <MenuItem value="">Select Category</MenuItem>
// //               {categoriesDropdown.map((cat) => (
// //                 <MenuItem key={cat._id} value={cat._id}>
// //                   {cat.name}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //             {formErrors.category && (
// //               <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
// //                 {formErrors.category}
// //               </Typography>
// //             )}
// //           </FormControl>

// //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// //             <InputLabel id="subcategory-select-label">Sub Category</InputLabel>
// //             <Select
// //               labelId="subcategory-select-label"
// //               name="subCategory"
// //               value={editFormData.subCategory || ''}
// //               label="Sub Category"
// //               onChange={handleEditFormChange}
// //               disabled={!editFormData.category || subCategoriesDropdown.length === 0}
// //             >
// //               <MenuItem value="">Select Sub Category (Optional)</MenuItem>
// //               {subCategoriesDropdown.map((subCat) => (
// //                 <MenuItem key={subCat._id} value={subCat._id}>
// //                   {subCat.name}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           {showSubSubCategoryDropdown && (
// //             <TextField
// //               label="Select Rashi (subSubCategory)"
// //               name="subSubCategory"
// //               select
// //               fullWidth
// //               margin="normal"
// //               value={editFormData.subSubCategory}
// //               onChange={handleEditFormChange}
// //               sx={{ mb: 2 }}
// //             >
// //               <MenuItem value="">Select Rashi</MenuItem>
// //               {RASHI_OPTIONS.map(r => (
// //                 <MenuItem key={r} value={r}>{r}</MenuItem>
// //               ))}
// //             </TextField>
// //           )}

// //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// //             <InputLabel htmlFor="news-tags">Tags (comma separated)</InputLabel>
// //             <OutlinedInput
// //               id="news-tags"
// //               name="tags"
// //               value={editFormData.tags?.join(', ') || ""}
// //               onChange={handleTagsChange}
// //               label="Tags (comma separated)"
// //             />
// //             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
// //               {editFormData.tags?.map((tag, index) => (
// //                 <Chip key={index} label={tag} />
// //               ))}
// //             </Box>
// //           </FormControl>

// //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// //             <InputLabel id="country-select-label">Country</InputLabel>
// //             <Select
// //               labelId="country-select-label"
// //               name="country"
// //               value={editFormData.country || ''}
// //               label="Country"
// //               onChange={handleEditFormChange}
// //             >
// //               <MenuItem value="">Select Country (Optional)</MenuItem>
// //               {countriesDropdown.map((country) => (
// //                 <MenuItem key={country._id} value={country._id}>
// //                   {country.name}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// //             <InputLabel id="state-select-label">State</InputLabel>
// //             <Select
// //               labelId="state-select-label"
// //               name="state"
// //               value={editFormData.state || ''}
// //               label="State"
// //               onChange={handleEditFormChange}
// //               disabled={!editFormData.country || statesDropdown.length === 0}
// //             >
// //               <MenuItem value="">Select State (Optional)</MenuItem>
// //               {statesDropdown.map((state) => (
// //                 <MenuItem key={state._id} value={state._id}>
// //                   {state.name}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>
// //           {/* Enhanced Media Section - Similar to Create News */}
// //           <Box sx={{ my: 3 }}>
// //             <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
// //               Media Files & External URLs
// //             </Typography>
// //             <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>
// //               Upload new files or add external media URLs. TinyMCE में uploaded media automatically यहां add हो जाएगा।
// //             </Typography>

// //             {/* File Upload Button */}
// //             <Button
// //               variant="outlined"
// //               component="label"
// //               fullWidth
// //               startIcon={<p />}
// //               sx={{ mb: 2, py: 1.5 }}
// //               disabled={updating}
// //             >
// //               Upload Media Files (Images/Videos)
// //               <input
// //                 type="file"
// //                 hidden
// //                 onChange={handleNewMediaUpload}
// //                 multiple
// //                 accept="image/*,video/*"
// //               />
// //             </Button>

// //             {/* New Files Preview */}
// //             {newMediaFiles.length > 0 && (
// //               <Box sx={{ mt: 2, mb: 2 }}>
// //                 <Typography variant="subtitle2" gutterBottom>New Files to Upload:</Typography>
// //                 <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
// //                   {newMediaFiles.map((file) => (
// //                     <ListItem
// //                       key={file.name + file.size}
// //                       secondaryAction={
// //                         <IconButton edge="end" aria-label="delete" onClick={() => {
// //                           setNewMediaFiles(prev => prev.filter(f => f !== file));
// //                         }}>
// //                           <p />
// //                         </IconButton>
// //                       }
// //                     >
// //                       <ListItemIcon>
// //                         {file.type.startsWith('image/') ? <ImageOutlinedIcon color="primary" /> : <VideoFileIcon color="secondary" />}
// //                       </ListItemIcon>
// //                       <ListItemText
// //                         primary={file.name}
// //                         secondary={`${(file.size / 1024 / 1024).toFixed(2)} MB (${file.type})`}
// //                       />
// //                     </ListItem>
// //                   ))}
// //                 </List>
// //               </Box>
// //             )}

// //             {/* External URL Input */}
// //             <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
// //               <TextField
// //                 label="Add External Media URL (YouTube, Image, Video)"
// //                 value={mediaUrlInput}
// //                 onChange={handleMediaUrlInputChange}
// //                 fullWidth
// //                 placeholder="https://example.com/image.jpg"
// //                 error={!!formErrors.mediaUrlInput}
// //                 helperText={formErrors.mediaUrlInput}
// //                 disabled={updating}
// //               />
// //               <IconButton
// //                 color="primary"
// //                 onClick={handleAddMediaUrl}
// //                 disabled={!mediaUrlInput.trim() || updating}
// //                 sx={{ 
// //                   border: '1px solid',
// //                   borderColor: 'primary.main',
// //                   borderRadius: 1
// //                 }}
// //               >
// //                 <AddCircleOutlineIcon />
// //               </IconButton>
// //             </Box>

// //             {/* Existing Media Display */}
// //             {existingMediaToKeep.length > 0 && (
// //               <Box sx={{ mt: 2 }}>
// //                 <Typography variant="subtitle2" gutterBottom>Current Media ({existingMediaToKeep.length}):</Typography>
// //                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 1 }}>
// //                   {existingMediaToKeep.map((url, index) => {
// //                     const isImage = /\.(jpeg|jpg|gif|png|webp|svg)\b/i.test(url.split('?')[0]);
// //                     const isVideo = /\.(mp4|webm|ogg)\b/i.test(url.split('?')[0]) || url.includes('youtube.com') || url.includes('vimeo.com');
// //                     const isLink = !isImage && !isVideo;

// //                     return (
// //                       <Box key={url} sx={{ 
// //                           position: 'relative', 
// //                           width: '100px', 
// //                           height: '100px', 
// //                           border: '1px solid #ccc', 
// //                           borderRadius: '4px', 
// //                           overflow: 'hidden', 
// //                           display: 'flex', 
// //                           alignItems: 'center', 
// //                           justifyContent: 'center', 
// //                           backgroundColor: '#f5f5f5',
// //                           flexDirection: 'column',
// //                           padding: '5px'
// //                       }}>
// //                         {isImage && (
// //                           <img
// //                             src={url}
// //                             alt={`Media ${index}`}
// //                             style={{ maxWidth: '100%', maxHeight: 'calc(100% - 20px)', objectFit: 'contain' }}
// //                           />
// //                         )}
// //                         {isVideo && (
// //                           <VideoFileIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
// //                         )}
// //                         {isLink && !isImage && !isVideo && (
// //                           <LinkIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
// //                         )}
// //                         {(!isImage && !isVideo && !isLink) && (
// //                           <ImageOutlinedIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
// //                         )}
// //                         <IconButton
// //                           size="small"
// //                           sx={{
// //                             position: 'absolute',
// //                             top: 0,
// //                             right: 0,
// //                             backgroundColor: 'rgba(255, 255, 255, 0.7)',
// //                             '&:hover': {
// //                               backgroundColor: 'rgba(255, 255, 255, 0.9)',
// //                             },
// //                             zIndex: 1,
// //                           }}
// //                           onClick={() => handleRemoveExistingMedia(url)}
// //                         >
// //                           <CloseIcon fontSize="small" />
// //                         </IconButton>
// //                         <Typography 
// //                           variant="caption" 
// //                           title={url}
// //                           sx={{ 
// //                             position: 'absolute', 
// //                             bottom: 0, 
// //                             left: 0, 
// //                             right: 0, 
// //                             backgroundColor: 'rgba(0,0,0,0.6)', 
// //                             color: 'white', 
// //                             px: 0.5, 
// //                             py: 0.2, 
// //                             fontSize: '0.6rem',
// //                             whiteSpace: 'nowrap', 
// //                             overflow: 'hidden', 
// //                             textOverflow: 'ellipsis' 
// //                           }}
// //                         >
// //                           {url.split('/').pop().split('?')[0] || url}
// //                         </Typography>
// //                       </Box>
// //                     );
// //                   })}
// //                 </Box>
// //               </Box>
// //             )}
// //           </Box>

// //           <Divider sx={{ my: 2 }} />

// //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// //             <InputLabel id="city-select-label">City</InputLabel>
// //             <Select
// //               labelId="city-select-label"
// //               name="city"
// //               value={editFormData.city || ''}
// //               label="City"
// //               onChange={handleEditFormChange}
// //               disabled={!editFormData.state || citiesDropdown.length === 0}
// //             >
// //               <MenuItem value="">Select City (Optional)</MenuItem>
// //               {citiesDropdown.map((city) => (
// //                 <MenuItem key={city._id} value={city._id}>
// //                   {city.name}
// //                 </MenuItem>
// //               ))}
// //             </Select>
// //           </FormControl>

// //           <TextField
// //             margin="dense"
// //             name="localAddress"
// //             label="Local Address"
// //             type="text"
// //             fullWidth
// //             variant="outlined"
// //             value={editFormData.localAddress || ""}
// //             onChange={handleEditFormChange}
// //             sx={{ mb: 2 }}
// //           />
// //           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
// //             <InputLabel id="status-select-label">Status</InputLabel>
// //             <Select
// //               labelId="status-select-label"
// //               name="status"
// //               value={editFormData.status || ""}
// //               label="Status"
// //               onChange={handleEditFormChange}
// //             >
// //               <MenuItem value="draft">Draft</MenuItem>
// //               <MenuItem value="pending_approval">Pending Approval</MenuItem>
// //               <MenuItem value="posted">Posted</MenuItem>
// //               <MenuItem value="live">Live</MenuItem>
// //               <MenuItem value="rejected">Rejected</MenuItem>
// //             </Select>
// //           </FormControl>



// //           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2, mt:2 }}>
// //             {existingMediaToKeep.map((url, index) => {
// //               // Determine file type for icon/display
// //               // Check for common image extensions (jpg, jpeg, png, gif, webp, svg)
// //               const isImage = /\.(jpeg|jpg|gif|png|webp|svg)\b/i.test(url.split('?')[0]);
// //               // Check for common video extensions (mp4, webm, ogg) and known video platforms (YouTube, Vimeo)
// //               const isVideo = /\.(mp4|webm|ogg)\b/i.test(url.split('?')[0]) || url.includes('youtube.com') || url.includes('vimeo.com');
// //               const isLink = !isImage && !isVideo;

// //               return (
// //                 <Box key={url} sx={{ 
// //                     position: 'relative', 
// //                     width: '100px', 
// //                     height: '100px', 
// //                     border: '1px solid #ccc', 
// //                     borderRadius: '4px', 
// //                     overflow: 'hidden', 
// //                     display: 'flex', 
// //                     alignItems: 'center', 
// //                     justifyContent: 'center', 
// //                     backgroundColor: '#f5f5f5',
// //                     flexDirection: 'column',
// //                     padding: '5px'
// //                 }}>
// //                   {isImage && (
// //                     <img
// //                       src={url}
// //                       alt={`Media ${index}`}
// //                       style={{ maxWidth: '100%', maxHeight: 'calc(100% - 20px)', objectFit: 'contain' }}
// //                     />
// //                   )}
// //                   {isVideo && (
// //                     <VideoFileIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
// //                   )}
// //                   {isLink && !isImage && !isVideo && (
// //                     <LinkIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
// //                   )}
// //                    {/* Fallback for cases where image/video type couldn't be determined from URL, show generic link/file icon */}
// //                    {(!isImage && !isVideo && !isLink) && ( // If it's none of the specific types, show a generic file icon
// //                     <ImageOutlinedIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
// //                    )}
// //                   <IconButton
// //                     size="small"
// //                     sx={{
// //                       position: 'absolute',
// //                       top: 0,
// //                       right: 0,
// //                       backgroundColor: 'rgba(255, 255, 255, 0.7)',
// //                       '&:hover': {
// //                         backgroundColor: 'rgba(255, 255, 255, 0.9)',
// //                       },
// //                       zIndex: 1,
// //                     }}
// //                     onClick={() => handleRemoveExistingMedia(url)}
// //                   >
// //                     <CloseIcon fontSize="small" />
// //                   </IconButton>
// //                   <Typography 
// //                     variant="caption" 
// //                     title={url}
// //                     sx={{ 
// //                       position: 'absolute', 
// //                       bottom: 0, 
// //                       left: 0, 
// //                       right: 0, 
// //                       backgroundColor: 'rgba(0,0,0,0.6)', 
// //                       color: 'white', 
// //                       px: 0.5, 
// //                       py: 0.2, 
// //                       fontSize: '0.6rem',
// //                       whiteSpace: 'nowrap', 
// //                       overflow: 'hidden', 
// //                       textOverflow: 'ellipsis' 
// //                     }}
// //                   >
// //                     {url.split('/').pop().split('?')[0] || url}
// //                   </Typography>
// //                 </Box>
// //               );
// //             })}
// //           </Box>


// //         </DialogContent>

// //         <DialogActions>
// //           <Button onClick={handleEditClose} disabled={updating}>
// //             Cancel
// //           </Button>
// //           <Button
// //             onClick={handleUpdateSubmit}
// //             variant="contained"
// //             color="primary"
// //             disabled={updating}
// //           >
// //             {updating ? "Updating..." : "Save Changes"}
// //           </Button>
// //         </DialogActions>
// //       </Dialog>


// //       <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
// //         <DialogTitle>Confirm Delete</DialogTitle>
// //         <DialogContent dividers>
// //           Are you sure you want to delete this news?
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={handleDeleteCancel} disabled={deleting}>
// //             Cancel
// //           </Button>
// //           <Button
// //             onClick={handleDeleteConfirm}
// //             color="error"
// //             variant="contained"
// //             disabled={deleting}
// //           >
// //             {deleting ? "Deleting..." : "Delete"}
// //           </Button>
// //         </DialogActions>
// //       </Dialog>
// //     </div>
// //   );
// // };

// // export default MyNewsAdmin;



//  import React, { useEffect, useState, useRef, useCallback } from "react";
// import { getMyNews, deleteNews, updateNews, uploadMediaFiles } from "../../../services/adminService";
// import {
//   CircularProgress,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Pagination,
//   Stack,
//   Select,
//   MenuItem,
//   TextField,
//   FormControl,
//   InputLabel,
//   OutlinedInput,
//   Chip,
//   Box,
//   IconButton,
//   ListItem,
//   List,
//   ListItemText,
//   Alert,
//   Divider,
//   ListItemIcon,
// } from "@mui/material";
// import CloseIcon from '@mui/icons-material/Close';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'; // PDF Icon
// import { Editor } from '@tinymce/tinymce-react';

// import {
//   getCategories,
//   getSubcategories,
//   getCountries,
//   getStatesByCountry,
//   getCitiesByState,
// } from '../../../services/apiService';
// import LinkIcon from '@mui/icons-material/Link';
// import VideoFileIcon from '@mui/icons-material/VideoFile';
// import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

// const RASHI_OPTIONS = [
//   "Mesh", "Vrishabh", "Mithun", "Karka", "Singh", "Kanya",
//   "Tula", "Vrischik", "Dhanu", "Makar", "Kumbh", "Meen"
// ];

// const isValidUrl = (string) => {
//   try {
//     new URL(string);
//     return true;
//   } catch (e) {
//     return false;
//   }
// };

// const MyNewsAdmin = () => {
//   const [news, setNews] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [viewOpen, setViewOpen] = useState(false);
//   const [selectedNews, setSelectedNews] = useState(null);
//   const [editOpen, setEditOpen] = useState(false);
//   const [editFormData, setEditFormData] = useState({});
//   const [newMediaFiles, setNewMediaFiles] = useState([]);
//   const [existingMediaToKeep, setExistingMediaToKeep] = useState([]);
//   const [mediaUrlInput, setMediaUrlInput] = useState('');

//   // --- PDF specific states ---
//   const [existingPdfFiles, setExistingPdfFiles] = useState([]); // To store PDF objects {url, originalName, _id}
//   const [newPdfFiles, setNewPdfFiles] = useState([]);           // To store actual File objects for new PDF uploads
//   const [pdfUrlInput, setPdfUrlInput] = useState('');           // For adding external PDF URLs
//   // --- End PDF specific states ---

//   const [formErrors, setFormErrors] = useState({});

//   const [categoriesDropdown, setCategoriesDropdown] = useState([]);
//   const [subCategoriesDropdown, setSubCategoriesDropdown] = useState([]);
//   const [countriesDropdown, setCountriesDropdown] = useState([]);
//   const [statesDropdown, setStatesDropdown] = useState([]);
//   const [citiesDropdown, setCitiesDropdown] = useState([]);

//   const [updateError, setUpdateError] = useState(null);
//   const [updateSuccess, setUpdateSuccess] = useState(null);
//   const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
//   const [deleting, setDeleting] = useState(false);
//   const [updating, setUpdating] = useState(false);

//   const [page, setPage] = useState(1);
//   const [limit, setLimit] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);

//   const editorRefEn = useRef(null);
//   const editorRefHi = useRef(null);

//   const extractUrlsFromHtml = useCallback((htmlContent) => {
//     const extracted = new Set();
//     if (!htmlContent) return Array.from(extracted);

//     const parser = new DOMParser();
//     const doc = parser.parseFromString(htmlContent, 'text/html');

//     doc.querySelectorAll('img, video, source, iframe, a').forEach(el => {
//       let url = el.getAttribute('src') || el.getAttribute('href');
//       if (url && isValidUrl(url)) {
//         extracted.add(url);
//       }
//     });

//     doc.querySelectorAll('img').forEach(el => {
//       const srcset = el.getAttribute('srcset');
//       if (srcset) {
//         srcset.split(',').forEach(srcPart => {
//           const url = srcPart.trim().split(' ')[0];
//           if (url && isValidUrl(url)) {
//             extracted.add(url);
//           }
//         });
//       }
//     });

//     doc.querySelectorAll('[data-mce-src]').forEach(el => {
//       const dataMceSrc = el.getAttribute('data-mce-src');
//       if (dataMceSrc && isValidUrl(dataMceSrc)) {
//         extracted.add(dataMceSrc);
//       }
//     });

//     doc.querySelectorAll('[data-mce-p-src]').forEach(el => {
//       const dataMcePSrc = el.getAttribute('data-mce-p-src');
//       if (dataMcePSrc && isValidUrl(dataMcePSrc)) {
//         extracted.add(dataMcePSrc);
//       }
//     });
//     return Array.from(extracted);
//   }, []);

//   const fetchMyNews = useCallback(async (pageNumber = page) => {
//     try {
//       setLoading(true);
//       const response = await getMyNews({ page: pageNumber, limit });
//       setNews(response.data || []);
//       setTotalPages(response.totalPages || 1);
//     } catch (error) {
//       console.error("ERROR: Failed to load my news:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [limit, page]);


//   const headlineEditorConfig = {
//     height: 180,
//     menubar: false,
//     branding: false,
//     plugins: [
//       'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview', 
//       'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen', 
//       'insertdatetime', 'media', 'table', 'help', 'wordcount'
//     ],

//      // यह सुनिश्चित करेगा कि टेक्स्ट हमेशा <p> टैग में ही रहे
//   forced_root_block: 'p',
  
//   // अगर कोई बाहर से कलर या स्टाइल पेस्ट करे तो उसे हटा देगा
//   paste_as_text: true, 
//   invalid_styles: 'font-size font-family',
//     // 'fontsizeselect' ही वो बटन है जिससे साइज बदलता है
//     toolbar: 'undo redo | italic underline | fontsizeselect | forecolor backcolor | removeformat',
    
//     // यहाँ हमने साइज की लिस्ट दे दी है ताकि आप बहुत बड़ा साइज भी चुन सकें
//     fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt',
    
//     content_style: 'body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: 18px; }'
//   };



//   const editorConfig = {
//     height: 500,
//     menubar: true,
//     branding: false,
//     plugins: [
//       'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
//       'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
//       'insertdatetime', 'media', 'table', 'help', 'wordcount', 'emoticons',
//       'template', 'codesample', 'hr', 'pagebreak', 'nonbreaking',
//       'toc', 'imagetools', 'textpattern', 'noneditable', 'quickbars',
//       'accordion', 'autosave', 'save', 'directionality', 'visualchars'
//     ],
//     toolbar1: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify',
//     toolbar2: 'outdent indent | numlist bullist | forecolor backcolor removeformat | charmap emoticons | fullscreen preview save print',
//     toolbar3: 'insertfile image media link anchor | customupload | ltr rtl | showcomments addcomment',

//     content_style: `
//     body {
//       font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
//       font-size: 14px;
//       line-height: 1.6;
//       margin: 1rem;
//     }
//     img { max-width: 100%; height: auto; }
//     .mce-content-body {
//       padding: 20px;
//       max-width: none;
//     }
//   `,

//     paste_data_images: true,
//     automatic_uploads: true,
//     file_picker_types: 'image media', // Note: TinyMCE's file_picker_types does not directly support 'application/pdf' without custom implementation

//     file_picker_callback: function (callback, value, meta) {
//       console.log('File picker triggered for:', meta.filetype);

//       const input = document.createElement('input');
//       input.setAttribute('type', 'file');

//       if (meta.filetype === 'image') {
//         input.setAttribute('accept', 'image/*');
//       } else if (meta.filetype === 'media') {
//         input.setAttribute('accept', 'video/*,audio/*');
//       } else {
//         input.setAttribute('accept', 'image/*,video/*,audio/*');
//       }

//       input.onchange = function () {
//         const file = this.files[0];

//         if (!file) {
//           console.log('No file selected');
//           return;
//         }

//         console.log('File selected:', file.name, file.type, file.size);

//         const editor = window.tinymce.activeEditor;
//         editor.setProgressState(true);

//         const formData = new FormData();
//         formData.append('mediaFiles', file); // Assuming uploadMediaFiles can handle various types

//         uploadMediaFiles(formData)
//           .then(response => {
//             console.log('Upload response:', response);
//             editor.setProgressState(false);

//             if (response && response.locations && response.locations.length > 0) {
//               const uploadedUrl = response.locations[0];
//               console.log('File uploaded successfully:', uploadedUrl);

//               // Add to existingMediaToKeep for general media URLs
//               setExistingMediaToKeep(prev => {
//                 if (!prev.includes(uploadedUrl)) {
//                   return [...prev, uploadedUrl];
//                 }
//                 return prev;
//               });

//               callback(uploadedUrl, {
//                 title: file.name,
//                 alt: file.name
//               });

//               editor.notificationManager.open({
//                 text: `File "${file.name}" uploaded successfully!`,
//                 type: 'success',
//                 timeout: 3000
//               });
//             } else {
//               throw new Error('No URL returned from upload service');
//             }
//           })
//           .catch(error => {
//             console.error('Upload failed:', error);
//             editor.setProgressState(false);

//             editor.notificationManager.open({
//               text: `Upload failed: ${error.message || 'Unknown error'}`,
//               type: 'error',
//               timeout: 5000
//             });

//             alert(`File upload failed: ${error.message || 'Please try again'}`);
//           });
//       };

//       input.click();
//     },

//     images_upload_handler: function (blobInfo, success, failure, progress) {
//       console.log('Image upload handler triggered');
//       console.log('Blob info:', blobInfo.filename(), blobInfo.blob().type, blobInfo.blob().size);

//       const blob = blobInfo.blob();

//       const file = new File([blob], blobInfo.filename() || `image-${Date.now()}.png`, {
//         type: blob.type || 'image/png'
//       });

//       console.log('Created file object:', file);

//       const formData = new FormData();
//       formData.append('mediaFiles', file);

//       const editor = window.tinymce.activeEditor;
//       editor.setProgressState(true);

//       uploadMediaFiles(formData)
//         .then(response => {
//           console.log('Upload response:', response);
//           editor.setProgressState(false);

//           if (response && response.locations && response.locations.length > 0) {
//             const uploadedUrl = response.locations[0];
//             console.log('Image uploaded successfully:', uploadedUrl);

//             setExistingMediaToKeep(prev => {
//               if (!prev.includes(uploadedUrl)) {
//                 return [...prev, uploadedUrl];
//               }
//               return prev;
//             });

//             success(uploadedUrl);

//             editor.notificationManager.open({
//               text: `Image uploaded successfully!`,
//               type: 'success',
//               timeout: 3000
//             });
//           } else {
//             throw new Error('No URL returned from upload service');
//           }
//         })
//         .catch(error => {
//           console.error('Image upload failed:', error);
//           editor.setProgressState(false);

//           failure(`Upload failed: ${error.message || 'Unknown error'}`);

//           editor.notificationManager.open({
//             text: `Upload failed: ${error.message || 'Unknown error'}`,
//             type: 'error',
//             timeout: 5000
//           });
//         });
//     },

//     setup: function (editor) {
//       console.log('TinyMCE editor setup starting');

//       editor.on('init', function () {
//         console.log('TinyMCE editor initialized');
//         editor.getContainer().style.transition = "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out";
//       });

//       editor.on('OpenWindow', (e) => {
//         if (e.dialog.title === 'Insert/Edit Image' || e.dialog.title === 'Insert/Edit Media') {
//           console.log('DEBUG: TinyMCE Image/Media Dialog opened. Inspecting "Source" field...');
//           setTimeout(() => {
//             const sourceInput = document.querySelector('.tox-dialog__body-content input[type="text"][aria-label="Source"]');
//             const fallbackSourceInput = document.querySelector('.tox-textfield[name="src"]');

//             const targetInput = sourceInput || fallbackSourceInput;

//             if (targetInput) {
//               console.log('DEBUG: Found TinyMCE "Source" input field programmatically.');
//               if (targetInput.disabled) {
//                 console.warn('DEBUG: "Source" input is disabled. Attempting to re-enable.');
//                 targetInput.disabled = false;
//                 targetInput.setAttribute('aria-disabled', 'false');
//               }
//               if (targetInput.readOnly) {
//                 console.warn('DEBUG: "Source" input is readOnly. Attempting to remove readOnly.');
//                 targetInput.readOnly = false;
//               }
//               if (window.getComputedStyle(targetInput).pointerEvents === 'none') {
//                 console.warn('DEBUG: "Source" input has pointer-events: none. Attempting to set to auto.');
//                 targetInput.style.setProperty('pointer-events', 'auto', 'important');
//               }

//               setTimeout(() => {
//                 if (targetInput && !targetInput.disabled && !targetInput.readOnly && window.getComputedStyle(targetInput).pointerEvents !== 'none') {
//                   targetInput.focus();
//                   console.log('DEBUG: Attempted to focus the "Source" input field.');
//                 }
//               }, 50);

//             } else {
//               console.log('DEBUG: TinyMCE "Source" input field not found in dialog using known selectors.');
//             }
//           }, 500);
//         }
//       });
//       editor.ui.registry.addButton('customupload', {
//         text: 'Upload Media',
//         icon: 'upload',
//         tooltip: 'Upload images or videos',
//         onAction: function () {
//           console.log('Custom upload button clicked');

//           const input = document.createElement('input');
//           input.setAttribute('type', 'file');
//           input.setAttribute('accept', 'image/*,video/*,application/pdf'); // Added PDF to accept
//           input.setAttribute('multiple', 'true');

//           input.onchange = function () {
//             const files = Array.from(this.files);
//             console.log('Multiple files selected:', files.length);

//             if (files.length === 0) return;

//             editor.setProgressState(true);

//             const formData = new FormData();
//             files.forEach(file => {
//               formData.append('mediaFiles', file);
//               console.log('Adding file to FormData:', file.name);
//             });

//             uploadMediaFiles(formData)
//               .then(response => {
//                 console.log('Batch upload response:', response);
//                 editor.setProgressState(false);

//                 if (response && response.locations && response.locations.length > 0) {
//                     const newUrls = response.locations.filter(url => !existingMediaToKeep.includes(url));
//                     setExistingMediaToKeep(prev => [...prev, ...newUrls]);

//                     // Distribute files into TinyMCE content or pdf state based on type
//                     response.locations.forEach((url, index) => {
//                       const file = files[index];
//                       if (file && file.type.startsWith('image/')) {
//                         editor.insertContent(`<img src="${url}" alt="${file.name}" style="max-width: 100%; height: auto;" />`);
//                       } else if (file && file.type.startsWith('video/')) {
//                         editor.insertContent(`<video controls style="max-width: 100%; height: auto;">
//                         <source src="${url}" type="${file.type}">
//                         Your browser does not support the video tag.
//                       </video>`);
//                       } else if (file && file.type === 'application/pdf') {
//                         // For PDFs, we add them to the specific PDF state
//                         setExistingPdfFiles(prev => [...prev, { url, originalName: file.name }]);
//                         editor.insertContent(`<p><a href="${url}" target="_blank">${file.name}</a></p>`); // Also insert a link into the editor
//                       }
//                     });

//                   editor.notificationManager.open({
//                     text: `Successfully uploaded ${response.locations.length} file(s)!`,
//                     type: 'success',
//                     timeout: 3000
//                   });
//                 } else {
//                   throw new Error('No URLs returned from upload service');
//                 }
//               })
//               .catch(error => {
//                 console.error('Batch upload failed:', error);
//                 editor.setProgressState(false);

//                 editor.notificationManager.open({
//                   text: `Upload failed: ${error.message || 'Unknown error'}`,
//                   type: 'error',
//                   timeout: 5000
//                 });
//               });
//           };

//           input.click();
//         }
//       });

//       editor.on('drop', function (e) {
//         console.log('File(s) dropped on editor');
//       });

//       editor.on('paste', function (e) {
//         console.log('Content pasted into editor');
//       });
//     },

//     contextmenu: 'link image table',
//     quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
//     quickbars_insert_toolbar: 'quickimage quicktable customupload',
//     powerpaste_word_import: 'clean',
//     powerpaste_html_import: 'clean',

//     image_advtab: true,
//     image_uploadtab: true,
//     image_caption: true,
//     image_title: true,

//     formats: {
//       alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'left' },
//       aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'center' },
//       alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'right' },
//       alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li,table,img', classes: 'full' },
//       bold: { inline: 'strong' },
//       italic: { inline: 'em' },
//       underline: { inline: 'u' },
//       strikethrough: { inline: 'del' },
//       customformat: { inline: 'span', styles: { color: '#00ff00', fontSize: '20px' }, attributes: { title: 'My custom format' }, classes: 'example1' }
//     }
//   };


//   useEffect(() => {
//     const fetchInitialDropdownData = async () => {
//       try {
//         const [catsRes, countriesRes] = await Promise.all([
//           getCategories(),
//           getCountries(),
//         ]);
//         setCategoriesDropdown(catsRes.data || []);
//         setCountriesDropdown(countriesRes.data || []);
//       } catch (err) {
//         console.error("ERROR: Failed to load initial dropdown data (categories/countries):", err);
//       }
//     };
//     fetchInitialDropdownData();
//     fetchMyNews();
//   }, [limit, fetchMyNews]);

//   const fetchSubcategoriesForEdit = useCallback(async (categoryId) => {
//     if (categoryId) {
//       try {
//         const res = await getSubcategories(categoryId);
//         setSubCategoriesDropdown(res.data || []);
//       } catch (err) {
//         console.error("ERROR: Failed to load subcategories for edit:", err);
//         setSubCategoriesDropdown([]);
//       }
//     } else {
//       setSubCategoriesDropdown([]);
//     }
//   }, []);

//   const fetchStatesForEdit = useCallback(async (countryId) => {
//     if (countryId) {
//       try {
//         const res = await getStatesByCountry(countryId);
//         setStatesDropdown(res.data || []);
//       } catch (err) {
//         console.error("ERROR: Failed to load states for edit:", err);
//         setStatesDropdown([]);
//       }
//     } else {
//       setStatesDropdown([]);
//     }
//   }, []);

//   const fetchCitiesForEdit = useCallback(async (stateId) => {
//     if (stateId) {
//       try {
//         const res = await getCitiesByState(stateId);
//         setCitiesDropdown(res.data || []);
//       } catch (err) {
//         console.error("ERROR: Failed to load cities for edit:", err);
//         setCitiesDropdown([]);
//       }
//     } else {
//       setCitiesDropdown([]);
//     }
//   }, []);


//   const handleViewOpen = (item) => {
//     setSelectedNews(item);
//     setViewOpen(true);
//   };

//   const handleViewClose = () => {
//     setViewOpen(false);
//     setSelectedNews(null);
//   };

//   const handleEditOpen = async (item) => {
//     console.log('DEBUG: handleEditOpen triggered for news item:', item._id);
//     setSelectedNews(item);
//     setUpdateError(null);
//     setUpdateSuccess(null);
//     setFormErrors({});

//     await fetchSubcategoriesForEdit(item.category?._id);
//     await fetchStatesForEdit(item.country?._id);
//     await fetchCitiesForEdit(item.state?._id);

//     setEditFormData({
//       title_en: item.title_en || '',
//       title_hi: item.title_hi || '',
//       content_en: item.content_en || '',
//       content_hi: item.content_hi || '',
//       summary_en: item.summary_en || '',
//       summary_hi: item.summary_hi || '',
//       category: item.category?._id || '',
//       subCategory: item.subCategory?._id || '',
//       tags: item.tags || [],
//       country: item.country?._id || '',
//       state: item.state?._id || '',
//       city: item.city?._id || '',
//       localAddress: item.localAddress || '',
//       status: item.status,
//       subSubCategory: item.subSubCategory || '',
//     });

//     let initialMediaUrlsToKeep = new Set(item.media ? item.media.map(m => m.url) : []);

//     if (item.mediaUrls && Array.isArray(item.mediaUrls)) {
//         item.mediaUrls.forEach(url => initialMediaUrlsToKeep.add(url));
//     }

//     const urlsFromEnglishContent = extractUrlsFromHtml(item.content_en);
//     const urlsFromHindiContent = extractUrlsFromHtml(item.content_hi);

//     urlsFromEnglishContent.forEach(url => initialMediaUrlsToKeep.add(url));
//     urlsFromHindiContent.forEach(url => initialMediaUrlsToKeep.add(url));

//     setExistingMediaToKeep(Array.from(initialMediaUrlsToKeep));
//     console.log("DEBUG: handleEditOpen: Initial existingMediaToKeep set to:", Array.from(initialMediaUrlsToKeep));

//     // --- PDF specific initialization ---
//     setExistingPdfFiles(item.pdfFiles || []);
//     setNewPdfFiles([]);
//     setPdfUrlInput('');
//     // --- End PDF specific initialization ---

//     setNewMediaFiles([]);
//     setMediaUrlInput('');
//     setEditOpen(true);
//   };

//   const handleEditClose = () => {
//     console.log('DEBUG: handleEditClose triggered.');
//     setEditOpen(false);
//     setSelectedNews(null);
//     setEditFormData({});
//     setNewMediaFiles([]);
//     setExistingMediaToKeep([]);
//     setSubCategoriesDropdown([]);
//     setStatesDropdown([]);
//     setCitiesDropdown([]);
//     setUpdateError(null);
//     setUpdateSuccess(null);
//     setMediaUrlInput('');
//     setFormErrors({});
//     // --- PDF specific reset ---
//     setExistingPdfFiles([]);
//     setNewPdfFiles([]);
//     setPdfUrlInput('');
//     // --- End PDF specific reset ---
//   };

//   const handleEditFormChange = async (e) => {
//     const { name, value } = e.target;
//     setEditFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//     setFormErrors((prev) => ({ ...prev, [name]: '' }));

//     if (name === 'category') {
//       setEditFormData((prevData) => ({ ...prevData, subCategory: '', subSubCategory: '' }));
//       await fetchSubcategoriesForEdit(value);
//     } else if (name === 'country') {
//       setEditFormData((prevData) => ({ ...prevData, state: '', city: '' }));
//       await fetchStatesForEdit(value);
//     } else if (name === 'state') {
//       setEditFormData((prevData) => ({ ...prevData, city: '' }));
//       await fetchCitiesForEdit(value);
//     }
//   };

//   const handleEditEditorChange = (content, editorName) => {
//     setEditFormData((prevData) => ({
//       ...prevData,
//       [editorName]: content,
//     }));
//     setFormErrors((prev) => ({ ...prev, [editorName]: '' }));

//     console.log('DEBUG: --- TinyMCE Editor Content Changed (onEditorChange) ---');
//     console.log('DEBUG: Editor Name:', editorName);

//     const extractedUrlsFromCurrentContent = extractUrlsFromHtml(content);

//     setExistingMediaToKeep(prev => {
//       const combinedUrls = new Set([...prev, ...extractedUrlsFromCurrentContent]);
//       const finalUniqueUrls = Array.from(combinedUrls);
//       return finalUniqueUrls;
//     });
//     console.log('DEBUG: --- End Editor Content Change ---');
//   };

//   const handleTagsChange = (e) => {
//     const tagsArray = e.target.value.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
//     setEditFormData((prevData) => ({
//       ...prevData,
//       tags: tagsArray,
//     }));
//   };

//   const handleNewMediaUpload = (e) => {
//     console.log('DEBUG: handleNewMediaUpload triggered.');
//     setNewMediaFiles(Array.from(e.target.files));
//   };

//   const handleRemoveExistingMedia = (urlToRemove) => {
//     console.log('DEBUG: handleRemoveExistingMedia triggered for URL:', urlToRemove);
//     setExistingMediaToKeep((prev) => prev.filter((url) => url !== urlToRemove));
//   };

//   const handleMediaUrlInputChange = (e) => {
//     setMediaUrlInput(e.target.value);
//     setFormErrors((prev) => ({ ...prev, mediaUrlInput: '' }));
//   };

//   const handleAddMediaUrl = () => {
//     const url = mediaUrlInput.trim();
//     if (url) {
//       if (!isValidUrl(url)) {
//         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' }));
//         return;
//       }
//       if (!existingMediaToKeep.includes(url)) {
//         setExistingMediaToKeep(prev => [...prev, url]);
//         setMediaUrlInput('');
//       } else {
//         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'This URL has already been added.' }));
//       }
//     }
//   };

//   // --- PDF specific handlers ---
//   const handleNewPdfUpload = (e) => {
//     setNewPdfFiles(Array.from(e.target.files));
//   };

//   const handleRemoveExistingPdf = (pdfToRemove) => {
//     setExistingPdfFiles(prev => prev.filter(pdf => pdf._id !== pdfToRemove._id));
//   };

//   const handlePdfUrlInputChange = (e) => {
//     setPdfUrlInput(e.target.value);
//     setFormErrors((prev) => ({ ...prev, pdfUrlInput: '' }));
//   };

//   const handleAddPdfUrl = () => {
//     const url = pdfUrlInput.trim();
//     if (url) {
//       if (!isValidUrl(url)) {
//         setFormErrors((prev) => ({ ...prev, pdfUrlInput: 'Please enter a valid URL.' }));
//         return;
//       }
//       // Check if URL already exists in either existingPdfFiles or newPdfFiles
//       const isDuplicate = existingPdfFiles.some(pdf => pdf.url === url) ||
//                          newPdfFiles.some(file => file.url === url); // Assuming newPdfFiles can store URLs if needed, but it's file objects currently
//       if (!isDuplicate) {
//         setExistingPdfFiles(prev => [...prev, { url, originalName: url.split('/').pop() || 'external_pdf' }]);
//         setPdfUrlInput('');
//       } else {
//         setFormErrors((prev) => ({ ...prev, pdfUrlInput: 'This URL has already been added.' }));
//       }
//     }
//   };
//   // --- End PDF specific handlers ---


//   const handleUpdateSubmit = async () => {
//     if (!selectedNews) return;

//     setUpdating(true);
//     setUpdateError(null);
//     setUpdateSuccess(null);
//     setFormErrors({});

//     let currentMediaUrls = [...existingMediaToKeep];
//     const currentMediaUrlInputVal = mediaUrlInput.trim();
//     if (currentMediaUrlInputVal) {
//       if (!isValidUrl(currentMediaUrlInputVal)) {
//         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' }));
//         setUpdating(false);
//         setUpdateError("Please correct the errors in the form.");
//         return;
//       }
//       if (!currentMediaUrls.includes(currentMediaUrlInputVal)) {
//         currentMediaUrls.push(currentMediaUrlInputVal);
//       } else {
//         setFormErrors((prev) => ({ ...prev, mediaUrlInput: 'This URL has already been added.' }));
//         setUpdating(false);
//         setUpdateError("Please correct the errors in the form.");
//         return;
//       }
//     }

//     try {
//       let finalMediaUrls = [...currentMediaUrls];
//       let finalPdfFiles = [...existingPdfFiles]; // Start with existing PDFs

//       if (newMediaFiles.length > 0) {
//         console.log('DEBUG: Uploading new media files from dedicated button...');
//         const formDataForNewFiles = new FormData();
//         newMediaFiles.forEach(file => {
//           formDataForNewFiles.append('mediaFiles', file);
//         });
//         const uploadResponse = await uploadMediaFiles(formDataForNewFiles);
//         if (uploadResponse && uploadResponse.locations) {
//           console.log('DEBUG: New media files uploaded, locations:', uploadResponse.locations);
//           const uniqueNewUploadUrls = uploadResponse.locations.filter(url => !finalMediaUrls.includes(url));
//           finalMediaUrls = [...finalMediaUrls, ...uniqueNewUploadUrls];
//         } else {
//           throw new Error('Failed to upload new media files.');
//         }
//       }

//       // --- PDF upload logic ---
//       if (newPdfFiles.length > 0) {
//         console.log('DEBUG: Uploading new PDF files...');
//         const formDataForNewPdfs = new FormData();
//         newPdfFiles.forEach(file => {
//           formDataForNewPdfs.append('mediaFiles', file); // Assuming the same endpoint
//         });
//         const uploadResponsePdfs = await uploadMediaFiles(formDataForNewPdfs);
//         if (uploadResponsePdfs && uploadResponsePdfs.locations) {
//           console.log('DEBUG: New PDF files uploaded, locations:', uploadResponsePdfs.locations);
//           uploadResponsePdfs.locations.forEach((url, index) => {
//             const file = newPdfFiles[index];
//             finalPdfFiles.push({ url, originalName: file.name }); // Add new PDFs to the final array
//           });
//         } else {
//           throw new Error('Failed to upload new PDF files.');
//         }
//       }

//       // --- Handle external PDF URL input ---
//       const currentPdfUrlInputVal = pdfUrlInput.trim();
//       if (currentPdfUrlInputVal) {
//         if (!isValidUrl(currentPdfUrlInputVal)) {
//           setFormErrors((prev) => ({ ...prev, pdfUrlInput: 'Please enter a valid URL.' }));
//           setUpdating(false);
//           setUpdateError("Please correct the errors in the form.");
//           return;
//         }
//         const isDuplicate = finalPdfFiles.some(pdf => pdf.url === currentPdfUrlInputVal);
//         if (!isDuplicate) {
//           finalPdfFiles.push({ url: currentPdfUrlInputVal, originalName: currentPdfUrlInputVal.split('/').pop() || 'external_pdf' });
//         } else {
//           setFormErrors((prev) => ({ ...prev, pdfUrlInput: 'This URL has already been added.' }));
//           setUpdating(false);
//           setUpdateError("Please correct the errors in the form.");
//           return;
//         }
//       }
//       // --- End PDF upload logic ---


//       const formDataPayload = new FormData();

//       Object.keys(editFormData).forEach(key => {
//         if (key === 'tags') {
//           formDataPayload.append(key, JSON.stringify(editFormData[key]));
//         } else if (editFormData[key] !== undefined && editFormData[key] !== null) {
//           formDataPayload.append(key, editFormData[key]);
//         } else {
//           formDataPayload.append(key, '');
//         }
//       });

//       formDataPayload.append('mediaUrls', JSON.stringify(finalMediaUrls));
//       formDataPayload.append('pdfFiles', JSON.stringify(finalPdfFiles)); // Append final PDF files array

//       console.log("DEBUG: Submitting formDataPayload (for debug, cannot inspect FormData directly):");
//       console.log("DEBUG:   title_en:", editFormData.title_en);
//       console.log("DEBUG:   content_en length:", editFormData.content_en?.length);
//       console.log("DEBUG:   finalMediaUrls (sent to backend):", finalMediaUrls);
//       console.log("DEBUG:   finalPdfFiles (sent to backend):", finalPdfFiles);


//       const response = await updateNews(selectedNews._id, formDataPayload);
//       setUpdateSuccess(response.message || "News updated successfully!");
//       handleEditClose();
//       fetchMyNews(page);
//     } catch (error) {
//       console.error("ERROR: Failed to update news:", error);
//       setUpdateError(error.response?.data?.message || error.message || "Failed to update news.");
//     } finally {
//       setUpdating(false);
//     }
//   };

//   const handleDeleteClick = (item) => {
//     setSelectedNews(item);
//     setDeleteConfirmOpen(true);
//   };

//   const handleDeleteConfirm = async () => {
//     if (!selectedNews) return;
//     try {
//       setDeleting(true);
//       await deleteNews(selectedNews._id);
//       setDeleteConfirmOpen(false);
//       setViewOpen(false);
//       handleEditClose();
//       fetchMyNews(page);
//     } catch (error) {
//       console.error("ERROR: Failed to delete news:", error);
//     } finally {
//       setDeleting(false);
//     }
//   };

//   const handleDeleteCancel = () => {
//     setDeleteConfirmOpen(false);
//     setSelectedNews(null);
//   };

//   const selectedCategoryName = categoriesDropdown.find(cat => cat._id === editFormData.category)?.name?.toLowerCase();
//   const selectedSubCategoryName = subCategoriesDropdown.find(sub => sub._id === editFormData.subCategory)?.name?.toLowerCase();
//   const showSubSubCategoryDropdown = selectedCategoryName === 'astrology' && selectedSubCategoryName === 'rashi';

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center mt-10">
//         <CircularProgress />
//       </div>
//     );
//   }

//   return (
//     <div className="p-4">
//       <Typography variant="h5" gutterBottom>
//         My News
//       </Typography>

//       {news.length === 0 ? (
//         <Typography>No news found.</Typography>
//       ) : (
//         <>
//           <TableContainer component={Paper}>
//             <Table>
//               <TableHead>
//                 <TableRow>
//                       <TableCell>#No</TableCell>
//                   <TableCell>Image</TableCell>
//                   <TableCell>Title (English)</TableCell>
//                   <TableCell>Category</TableCell>
//                   <TableCell>Status</TableCell>
//                   <TableCell>Created At</TableCell>
//                   <TableCell align="center">Action</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {news.map((item,index) => (
//                   <TableRow key={item._id}>
//                        <TableCell>{index + 1}</TableCell>
//                     <TableCell>
//                       {item.media && item.media.length > 0 ? (
//                         item.media[0].type === "video" ? (
//                           <video
//                             src={item.media[0].url}
//                             width="90"
//                             height="60"
//                             controls={false}
//                             autoPlay="true"
//                             muted
//                             loop
//                             style={{
//                               borderRadius: "8px",
//                               objectFit: "cover",
//                               backgroundColor: "#f0fdf9ff",
//                             }}
//                           />
//                         ) : (
//                           <img
//                             src={item.media[0].url}
//                             alt={item.media[0].caption || "News image"}
//                             style={{
//                               width: "90px",
//                               maxHeight: "70px",
//                               objectFit: "contain",
//                               borderRadius: "8px",
//                               backgroundColor: "#f0fdf9ff",
//                             }}
//                           />
//                         )
//                       ) : (
//                         <Typography variant="caption" color="textSecondary">
//                           No Media
//                         </Typography>
//                       )}
//                     </TableCell>
//                             <TableCell dangerouslySetInnerHTML={{ __html: item.title_hi || item.title_en }} />
//                     {/* <TableCell>{item.title_en || item.title_hi}</TableCell> */}
//                     <TableCell>{item.category?.name || "-"}</TableCell>
//                     <TableCell>{item.status}</TableCell>
//                     <TableCell>
//                       {item.createdAtDate} {item.createdAtTime}
//                     </TableCell>
//                     <TableCell align="center">
//                       <Button
//                         size="small"
//                         variant="outlined"
//                         onClick={() => handleViewOpen(item)}
//                         sx={{ mr: 1 }}
//                       >
//                         View
//                       </Button>
//                       <Button
//                         size="small"
//                         variant="outlined"
//                         color="primary"
//                         onClick={() => handleEditOpen(item)}
//                         sx={{ mr: 1 }}
//                       >
//                         Edit
//                       </Button>
//                       <Button
//                         size="small"
//                         variant="outlined"
//                         color="error"
//                         onClick={() => handleDeleteClick(item)}
//                       >
//                         Delete
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>


//           </TableContainer>
//           <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
//             <Pagination
//               count={totalPages}
//               page={page}
//               onChange={(e, value) => setPage(value)}
//               color="primary"
//             />
//             <Select
//               value={limit}
//               onChange={(e) => {
//                 setLimit(e.target.value);
//                 fetchMyNews(1);
//               }}
//             >
//               {[5, 10, 20, 50].map((l) => (
//                 <MenuItem key={l} value={l}>
//                   {l} per page
//                 </MenuItem>
//               ))}
//             </Select>
//           </Stack>
//         </>
//       )}

//       <Dialog open={viewOpen} onClose={handleViewClose} fullWidth maxWidth="md">
//         <DialogTitle>News Details</DialogTitle>
//         <DialogContent dividers>
//           {selectedNews?.media && selectedNews?.media.length > 0 && (
//             <img
//               src={selectedNews.media[0].url}
//               alt={selectedNews.media[0].caption || "News image"}
//               style={{
//                 width: "100%",
//                 maxHeight: "300px",
//                 objectFit: "contain",
//                 borderRadius: "8px",
//                 marginBottom: "16px",
//                 backgroundColor: "#f0fdf9ff",
//               }}
//             />
//           )}

//           <Typography variant="h6" gutterBottom><strong>Title (English):</strong> {selectedNews?.title_en || "-"}</Typography>
//           {/* <Typography variant="h6" gutterBottom><strong>शीर्षक (हिंदी):</strong> {selectedNews?.title_hi || "-"}</Typography> */}
// <Typography variant="h6" gutterBottom>
//   <strong>शीर्षक (हिंदी): </strong><span
// dangerouslySetInnerHTML={{
//       __html: selectedNews?.title_hi || "-"
//     }}
//   />
// </Typography>


//           <Typography variant="subtitle1" gutterBottom><strong>Summary (English):</strong> {selectedNews?.summary_en || "-"}</Typography>
//           <Typography variant="subtitle1" gutterBottom><strong>सारांश (हिंदी):</strong> {selectedNews?.summary_hi || "-"}</Typography>

//           <Typography variant="subtitle1" gutterBottom><strong>Category:</strong> {selectedNews?.category?.name || "-"}</Typography>
//           <Typography variant="subtitle1" gutterBottom><strong>Sub Category:</strong> {selectedNews?.subCategory?.name || "-"}</Typography>
//           {selectedNews?.subSubCategory && (
//             <Typography variant="subtitle1" gutterBottom><strong>Sub-Sub Category (Rashi):</strong> {selectedNews.subSubCategory}</Typography>
//           )}
//           <Typography variant="subtitle1" gutterBottom><strong>Status:</strong> {selectedNews?.status}</Typography>
//           <Typography variant="subtitle1" gutterBottom><strong>Country:</strong> {selectedNews?.country?.name || "-"}</Typography>
//           <Typography variant="subtitle1" gutterBottom><strong>State:</strong> {selectedNews?.state?.name || "-"}</Typography>
//           <Typography variant="subtitle1" gutterBottom><strong>City:</strong> {selectedNews?.city?.name || "-"}</Typography>
//           <Typography variant="subtitle1" gutterBottom><strong>Local Address:</strong> {selectedNews?.localAddress || "-"}</Typography>
//           <Typography variant="subtitle1" gutterBottom><strong>Reporter:</strong> {selectedNews?.createdBy?.name || "-"} / ({selectedNews?.createdBy?.email})</Typography>

//           <Typography variant="subtitle2" gutterBottom><strong>Posted Date:</strong> {selectedNews?.postedDate || "N/A"} {selectedNews?.postedTime || "N/A"}</Typography>
//           <Typography variant="subtitle2" gutterBottom><strong>Last Updated:</strong> {selectedNews?.updatedAtDate} {selectedNews?.updatedAtTime}</Typography>

//           <Typography variant="body1" sx={{ mt: 2 }}>
//             <strong>Content (English):</strong>
//             <br />
//             <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_en || "No English content available" }} />
//           </Typography>
//           <Typography variant="body1" sx={{ mt: 2 }}>
//             <strong>सामग्री (हिंदी):</strong>
//             <br />
//             <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_hi || "कोई हिंदी सामग्री उपलब्ध नहीं है" }} />
//           </Typography>

//           {selectedNews?.tags?.length > 0 && (
//             <Typography variant="subtitle1" sx={{ mt: 2 }}>
//               <strong>Tags:</strong> {selectedNews.tags.join(", ")}
//             </Typography>
//           )}
//           {selectedNews?.referenceLinks?.length > 0 && (
//             <Box sx={{ mt: 2 }}>
//               <Typography variant="subtitle1"><strong>Reference Links:</strong></Typography>
//               <List dense>
//                 {selectedNews.referenceLinks.map((link, index) => (
//                   <ListItem key={index} disablePadding>
//                     <ListItemText primary={<a href={link} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{link}</a>} />
//                   </ListItem>
//                 ))}
//               </List>
//             </Box>
//           )}
//           {selectedNews?.mediaUrls?.length > 0 && (
//             <Box sx={{ mt: 2 }}>
//               <Typography variant="subtitle1"><strong>External Media URLs:</strong></Typography>
//               <List dense>
//                 {selectedNews.mediaUrls.map((url, index) => (
//                   <ListItem key={index} disablePadding>
//                     <ListItemText primary={<a href={url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{url}</a>} />
//                   </ListItem>
//                 ))}
//               </List>
//             </Box>
//           )}
//           {selectedNews?.pdfFiles?.length > 0 && ( // Display PDF Files in View Modal
//             <Box sx={{ mt: 2 }}>
//               <Typography variant="subtitle1"><strong>PDF Files:</strong></Typography>
//               <List dense>
//                 {selectedNews.pdfFiles.map((pdf, index) => (
//                   <ListItem key={pdf._id || index} disablePadding>
//                     <ListItemIcon><PictureAsPdfIcon /></ListItemIcon>
//                     <ListItemText primary={<a href={pdf.url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{pdf.originalName || pdf.url.split('/').pop()}</a>} />
//                   </ListItem>
//                 ))}
//               </List>
//             </Box>
//           )}
//           <Typography variant="subtitle2" sx={{ mt: 2 }}>
//             <strong>Views:</strong> {selectedNews?.viewsCount || 0}
//           </Typography>
//           <Typography variant="subtitle2">
//             <strong>Likes:</strong> {selectedNews?.likesCount || 0}
//           </Typography>
//           <Typography variant="subtitle2">
//             <strong>Comments:</strong> {selectedNews?.commentsCount || 0}
//           </Typography>
//         </DialogContent>

//         <DialogActions>
//           <Button onClick={handleViewClose} variant="contained" color="primary">
//             Close
//           </Button>
//           <Button
//             onClick={() => handleDeleteClick(selectedNews)}
//             variant="contained"
//             color="error"
//           >
//             Delete
//           </Button>

//         </DialogActions>
//       </Dialog>

//       <Dialog open={editOpen} onClose={handleEditClose} fullWidth maxWidth="md" disableEnforceFocus={true}>
//         {/* <DialogTitle>
//           Edit News: {selectedNews?.title_en || selectedNews?.title_hi}
//         </DialogTitle> */}

//         <DialogTitle>
//   Edit News:{" "}
//   <span
//     dangerouslySetInnerHTML={{
//       __html: selectedNews?.title_en || selectedNews?.title_hi || "-"
//     }}
//   />
// </DialogTitle>


//         <DialogContent dividers>
//           {updateError && <Alert severity="error" sx={{ mb: 2 }}>{updateError}</Alert>}
//           {updateSuccess && <Alert severity="success" sx={{ mb: 2 }}>{updateSuccess}</Alert>}


//           <Box
//   sx={{
  
//     border: formErrors.title_en ? "1px solid red" : "1px solid #ccc",
//     borderRadius: 1,
//     mb: 2,
      
//   }}
// >
//    <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 1 }}>
//               Title (English) *
//             </Typography>
//   <Editor
//     apiKey="eqp6uwfvp5am7ljwyqw294zsk9cvb0n212tg8offs3ki9h6q"
//     init={headlineEditorConfig}
//     value={editFormData.title_en || ""}
//     onEditorChange={(content) =>
//       setEditFormData((prev) => ({
//         ...prev,
//         title_en: content,
//       }))
//     }
//   />
// </Box>

// {formErrors.title_en && (
//   <Typography color="error" variant="caption">
//     {formErrors.title_en}
//   </Typography>
// )}

// <Box
//   sx={{
//     border: formErrors.title_hi ? "1px solid red" : "1px solid #ccc",
//     borderRadius: 1,
//     mb: 2,
//   }}
// >
//   <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 1 }}>
//               Title (Hindi) *
//             </Typography>
//   <Editor
//     apiKey="eqp6uwfvp5am7ljwyqw294zsk9cvb0n212tg8offs3ki9h6q"
//     init={headlineEditorConfig}
//     value={editFormData.title_hi || ""}
//     onEditorChange={(content) =>
//       setEditFormData((prev) => ({
//         ...prev,
//         title_hi: content,
//       }))
//     }
//   />
// </Box>

// {formErrors.title_hi && (
//   <Typography color="error" variant="caption">
//     {formErrors.title_hi}
//   </Typography>
// )}


//           {/* <TextField
//             margin="dense"
//             name="title_en"
//             label="Title (English)"
//             type="text"
//             fullWidth
//             variant="outlined"
//             value={editFormData.title_en || ""}
//             onChange={handleEditFormChange}
//             sx={{ mb: 2 }}
//             error={!!formErrors.title_en}
//             helperText={formErrors.title_en}
//           />
//           <TextField
//             margin="dense"
//             name="title_hi"
//             label="शीर्षक (हिंदी)"
//             type="text"
//             fullWidth
//             variant="outlined"
//             value={editFormData.title_hi || ""}
//             onChange={handleEditFormChange}
//             sx={{ mb: 2 }}
//             error={!!formErrors.title_hi}
//             helperText={formErrors.title_hi}
//           /> */}
//           <TextField
//             margin="dense"
//             name="summary_en"
//             label="Summary (English)"
//             type="text"
//             fullWidth
//             multiline
//             rows={2}
//             variant="outlined"
//             value={editFormData.summary_en || ""}
//             onChange={handleEditFormChange}
//             sx={{ mb: 2 }}
//             error={!!formErrors.summary_en}
//             helperText={formErrors.summary_en}
//           />
//           <TextField
//             margin="dense"
//             name="summary_hi"
//             label="सारांश (हिंदी)"
//             type="text"
//             fullWidth
//             multiline
//             rows={2}
//             variant="outlined"
//             value={editFormData.summary_hi || ""}
//             onChange={handleEditFormChange}
//             sx={{ mb: 2 }}
//             error={!!formErrors.summary_hi}
//             helperText={formErrors.summary_hi}
//           />

//           <Box sx={{ mt: 3, mb: 3 }}>
//             <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 1 }}>
//               Content (English) *
//             </Typography>
//             <Box sx={{ border: formErrors.content_en ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
//               <Editor
//                 apiKey="eqp6uwfvp5am7ljwyqw294zsk9cvb0n212tg8offs3ki9h6q"
//                 onInit={(evt, editor) => editorRefEn.current = editor}
//                 init={editorConfig}
//                 value={editFormData.content_en}
//                 onEditorChange={(content) => handleEditEditorChange(content, 'content_en')}
//               />
//             </Box>
//             {formErrors.content_en && (
//               <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
//                 {formErrors.content_en}
//               </Typography>
//             )}
//           </Box>
//           <Divider sx={{ my: 2 }} />

//           <Box sx={{ mt: 3, mb: 3 }}>
//             <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 1 }}>
//               सामग्री (हिंदी) * 
//             </Typography>
//             <Box sx={{ border: formErrors.content_hi ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
//               <Editor
//                 apiKey="eqp6uwfvp5am7ljwyqw294zsk9cvb0n212tg8offs3ki9h6q"
//                 onInit={(evt, editor) => editorRefHi.current = editor}
//                 init={editorConfig}
//                 value={editFormData.content_hi}
//                 onEditorChange={(content) => handleEditEditorChange(content, 'content_hi')}
//               />
//             </Box>
//             {formErrors.content_hi && (
//               <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
//                 {formErrors.content_hi}
//               </Typography>
//             )}
//           </Box>
//           <Divider sx={{ my: 2 }} />

//           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
//             <InputLabel id="category-select-label">Category</InputLabel>
//             <Select
//               labelId="category-select-label"
//               name="category"
//               value={editFormData.category || ''}
//               label="Category"
//               onChange={handleEditFormChange}
//               error={!!formErrors.category}
//             >
//               <MenuItem value="">Select Category</MenuItem>
//               {categoriesDropdown.map((cat) => (
//                 <MenuItem key={cat._id} value={cat._id}>
//                   {cat.name}
//                 </MenuItem>
//               ))}
//             </Select>
//             {formErrors.category && (
//               <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
//                 {formErrors.category}
//               </Typography>
//             )}
//           </FormControl>

//           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
//             <InputLabel id="subcategory-select-label">Sub Category</InputLabel>
//             <Select
//               labelId="subcategory-select-label"
//               name="subCategory"
//               value={editFormData.subCategory || ''}
//               label="Sub Category"
//               onChange={handleEditFormChange}
//               disabled={!editFormData.category || subCategoriesDropdown.length === 0}
//             >
//               <MenuItem value="">Select Sub Category (Optional)</MenuItem>
//               {subCategoriesDropdown.map((subCat) => (
//                 <MenuItem key={subCat._id} value={subCat._id}>
//                   {subCat.name}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {showSubSubCategoryDropdown && (
//             <TextField
//               label="Select Rashi (subSubCategory)"
//               name="subSubCategory"
//               select
//               fullWidth
//               margin="normal"
//               value={editFormData.subSubCategory}
//               onChange={handleEditFormChange}
//               sx={{ mb: 2 }}
//             >
//               <MenuItem value="">Select Rashi</MenuItem>
//               {RASHI_OPTIONS.map(r => (
//                 <MenuItem key={r} value={r}>{r}</MenuItem>
//               ))}
//             </TextField>
//           )}

//           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
//             <InputLabel htmlFor="news-tags">Tags (comma separated)</InputLabel>
//             <OutlinedInput
//               id="news-tags"
//               name="tags"
//               value={editFormData.tags?.join(', ') || ""}
//               onChange={handleTagsChange}
//               label="Tags (comma separated)"
//             />
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
//               {editFormData.tags?.map((tag, index) => (
//                 <Chip key={index} label={tag} />
//               ))}
//             </Box>
//           </FormControl>

//           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
//             <InputLabel id="country-select-label">Country</InputLabel>
//             <Select
//               labelId="country-select-label"
//               name="country"
//               value={editFormData.country || ''}
//               label="Country"
//               onChange={handleEditFormChange}
//             >
//               <MenuItem value="">Select Country (Optional)</MenuItem>
//               {countriesDropdown.map((country) => (
//                 <MenuItem key={country._id} value={country._id}>
//                   {country.name}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
//             <InputLabel id="state-select-label">State</InputLabel>
//             <Select
//               labelId="state-select-label"
//               name="state"
//               value={editFormData.state || ''}
//               label="State"
//               onChange={handleEditFormChange}
//               disabled={!editFormData.country || statesDropdown.length === 0}
//             >
//               <MenuItem value="">Select State (Optional)</MenuItem>
//               {statesDropdown.map((state) => (
//                 <MenuItem key={state._id} value={state._id}>
//                   {state.name}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {/* Enhanced Media Section */}
//           <Box sx={{ my: 3 }}>
//             <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//               Media Files & External URLs
//             </Typography>
//             <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>
//               Upload new images/videos or add external media URLs. TinyMCE में uploaded media automatically यहां add हो जाएगा।
//             </Typography>

//             {/* File Upload Button for Images/Videos */}
//             <Button
//               variant="outlined"
//               component="label"
//               fullWidth
//               startIcon={<AddCircleOutlineIcon />}
//               sx={{ mb: 2, py: 1.5 }}
//               disabled={updating}
//             >
//               Upload Images/Videos
//               <input
//                 type="file"
//                 hidden
//                 onChange={handleNewMediaUpload}
//                 multiple
//                 accept="image/*,video/*"
//               />
//             </Button>

//             {/* New Files Preview (Images/Videos) */}
//             {newMediaFiles.length > 0 && (
//               <Box sx={{ mt: 2, mb: 2 }}>
//                 <Typography variant="subtitle2" gutterBottom>New Images/Videos to Upload:</Typography>
//                 <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
//                   {newMediaFiles.map((file) => (
//                     <ListItem
//                       key={file.name + file.size}
//                       secondaryAction={
//                         <IconButton edge="end" aria-label="delete" onClick={() => {
//                           setNewMediaFiles(prev => prev.filter(f => f !== file));
//                         }}>
//                           <CloseIcon />
//                         </IconButton>
//                       }
//                     >
//                       <ListItemIcon>
//                         {file.type.startsWith('image/') ? <ImageOutlinedIcon color="primary" /> : <VideoFileIcon color="secondary" />}
//                       </ListItemIcon>
//                       <ListItemText
//                         primary={file.name}
//                         secondary={`${(file.size / 1024 / 1024).toFixed(2)} MB (${file.type})`}
//                       />
//                     </ListItem>
//                   ))}
//                 </List>
//               </Box>
//             )}

//             {/* External URL Input for Images/Videos */}
//             <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
//               <TextField
//                 label="Add External Media URL (YouTube, Image, Video)"
//                 value={mediaUrlInput}
//                 onChange={handleMediaUrlInputChange}
//                 fullWidth
//                 placeholder="https://example.com/image.jpg"
//                 error={!!formErrors.mediaUrlInput}
//                 helperText={formErrors.mediaUrlInput}
//                 disabled={updating}
//               />
//               <IconButton
//                 color="primary"
//                 onClick={handleAddMediaUrl}
//                 disabled={!mediaUrlInput.trim() || updating}
//                 sx={{
//                   border: '1px solid',
//                   borderColor: 'primary.main',
//                   borderRadius: 1
//                 }}
//               >
//                 <AddCircleOutlineIcon />
//               </IconButton>
//             </Box>

//             {/* Existing Media Display (Images/Videos) */}
//             {existingMediaToKeep.length > 0 && (
//               <Box sx={{ mt: 2 }}>
//                 <Typography variant="subtitle2" gutterBottom>Current Images/Videos ({existingMediaToKeep.length}):</Typography>
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 1 }}>
//                   {existingMediaToKeep.map((url, index) => {
//                     const isImage = /\.(jpeg|jpg|gif|png|webp|svg)\b/i.test(url.split('?')[0]);
//                     const isVideo = /\.(mp4|webm|ogg)\b/i.test(url.split('?')[0]) || url.includes('youtube.com') || url.includes('vimeo.com');
//                     const isLink = !isImage && !isVideo;

//                     return (
//                       <Box key={url} sx={{
//                           position: 'relative',
//                           width: '100px',
//                           height: '100px',
//                           border: '1px solid #ccc',
//                           borderRadius: '4px',
//                           overflow: 'hidden',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center',
//                           backgroundColor: '#f5f5f5',
//                           flexDirection: 'column',
//                           padding: '5px'
//                       }}>
//                         {isImage && (
//                           <img
//                             src={url}
//                             alt={`Media ${index}`}
//                             style={{ maxWidth: '100%', maxHeight: 'calc(100% - 20px)', objectFit: 'contain' }}
//                           />
//                         )}
//                         {isVideo && (
//                           <VideoFileIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
//                         )}
//                         {isLink && !isImage && !isVideo && (
//                           <LinkIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
//                         )}
//                         {(!isImage && !isVideo && !isLink) && (
//                           <ImageOutlinedIcon sx={{ fontSize: 40, color: 'text.secondary' }} />
//                         )}
//                         <IconButton
//                           size="small"
//                           sx={{
//                             position: 'absolute',
//                             top: 0,
//                             right: 0,
//                             backgroundColor: 'rgba(255, 255, 255, 0.7)',
//                             '&:hover': {
//                               backgroundColor: 'rgba(255, 255, 255, 0.9)',
//                             },
//                             zIndex: 1,
//                           }}
//                           onClick={() => handleRemoveExistingMedia(url)}
//                         >
//                           <CloseIcon fontSize="small" />
//                         </IconButton>
//                         <Typography
//                           variant="caption"
//                           title={url}
//                           sx={{
//                             position: 'absolute',
//                             bottom: 0,
//                             left: 0,
//                             right: 0,
//                             backgroundColor: 'rgba(0,0,0,0.6)',
//                             color: 'white',
//                             px: 0.5,
//                             py: 0.2,
//                             fontSize: '0.6rem',
//                             whiteSpace: 'nowrap',
//                             overflow: 'hidden',
//                             textOverflow: 'ellipsis'
//                           }}
//                         >
//                           {url.split('/').pop().split('?')[0] || url}
//                         </Typography>
//                       </Box>
//                     );
//                   })}
//                 </Box>
//               </Box>
//             )}
//           </Box>
//           <Divider sx={{ my: 2 }} />

//           {/* --- PDF Files Section --- */}
//           <Box sx={{ my: 3 }}>
//             <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//               PDF Files
//             </Typography>
//             <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>
//               Upload new PDF files or add external PDF URLs.
//             </Typography>

//             {/* File Upload Button for PDFs */}
//             <Button
//               variant="outlined"
//               component="label"
//               fullWidth
//               startIcon={<PictureAsPdfIcon />}
//               sx={{ mb: 2, py: 1.5 }}
//               disabled={updating}
//             >
//               Upload PDF Files
//               <input
//                 type="file"
//                 hidden
//                 onChange={handleNewPdfUpload}
//                 multiple
//                 accept="application/pdf"
//               />
//             </Button>

//             {/* New PDF Files Preview */}
//             {newPdfFiles.length > 0 && (
//               <Box sx={{ mt: 2, mb: 2 }}>
//                 <Typography variant="subtitle2" gutterBottom>New PDF Files to Upload:</Typography>
//                 <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
//                   {newPdfFiles.map((file) => (
//                     <ListItem
//                       key={file.name + file.size}
//                       secondaryAction={
//                         <IconButton edge="end" aria-label="delete" onClick={() => {
//                           setNewPdfFiles(prev => prev.filter(f => f !== file));
//                         }}>
//                           <CloseIcon />
//                         </IconButton>
//                       }
//                     >
//                       <ListItemIcon><PictureAsPdfIcon color="error" /></ListItemIcon>
//                       <ListItemText
//                         primary={file.name}
//                         secondary={`${(file.size / 1024).toFixed(2)} KB`}
//                       />
//                     </ListItem>
//                   ))}
//                 </List>
//               </Box>
//             )}

//             {/* External PDF URL Input */}
//             <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
//               <TextField
//                 label="Add External PDF URL"
//                 value={pdfUrlInput}
//                 onChange={handlePdfUrlInputChange}
//                 fullWidth
//                 placeholder="https://example.com/document.pdf"
//                 error={!!formErrors.pdfUrlInput}
//                 helperText={formErrors.pdfUrlInput}
//                 disabled={updating}
//               />
//               <IconButton
//                 color="primary"
//                 onClick={handleAddPdfUrl}
//                 disabled={!pdfUrlInput.trim() || updating}
//                 sx={{
//                   border: '1px solid',
//                   borderColor: 'primary.main',
//                   borderRadius: 1
//                 }}
//               >
//                 <AddCircleOutlineIcon />
//               </IconButton>
//             </Box>

//             {/* Existing PDF Files Display */}
//             {existingPdfFiles.length > 0 && (
//               <Box sx={{ mt: 2 }}>
//                 <Typography variant="subtitle2" gutterBottom>Current PDF Files ({existingPdfFiles.length}):</Typography>
//                 <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
//                   {existingPdfFiles.map((pdf, index) => (
//                     <ListItem
//                       key={pdf._id || pdf.url} // Use _id if available, else url
//                       secondaryAction={
//                         <IconButton edge="end" aria-label="delete" onClick={() => handleRemoveExistingPdf(pdf)}>
//                           <CloseIcon />
//                         </IconButton>
//                       }
//                     >
//                       <ListItemIcon><PictureAsPdfIcon color="error" /></ListItemIcon>
//                       <ListItemText
//                         primary={<a href={pdf.url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{pdf.originalName || pdf.url.split('/').pop()}</a>}
//                       />
//                     </ListItem>
//                   ))}
//                 </List>
//               </Box>
//             )}
//           </Box>
//           <Divider sx={{ my: 2 }} />
//           {/* --- End PDF Files Section --- */}


//           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
//             <InputLabel id="city-select-label">City</InputLabel>
//             <Select
//               labelId="city-select-label"
//               name="city"
//               value={editFormData.city || ''}
//               label="City"
//               onChange={handleEditFormChange}
//               disabled={!editFormData.state || citiesDropdown.length === 0}
//             >
//               <MenuItem value="">Select City (Optional)</MenuItem>
//               {citiesDropdown.map((city) => (
//                 <MenuItem key={city._id} value={city._id}>
//                   {city.name}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <TextField
//             margin="dense"
//             name="localAddress"
//             label="Local Address"
//             type="text"
//             fullWidth
//             variant="outlined"
//             value={editFormData.localAddress || ""}
//             onChange={handleEditFormChange}
//             sx={{ mb: 2 }}
//           />
//           <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
//             <InputLabel id="status-select-label">Status</InputLabel>
//             <Select
//               labelId="status-select-label"
//               name="status"
//               value={editFormData.status || ""}
//               label="Status"
//               onChange={handleEditFormChange}
//             >
//               <MenuItem value="draft">Draft</MenuItem>
//               <MenuItem value="pending_approval">Pending Approval</MenuItem>
//               <MenuItem value="posted">Posted</MenuItem>
//               <MenuItem value="live">Live</MenuItem>
//               <MenuItem value="rejected">Rejected</MenuItem>
//             </Select>
//           </FormControl>

//         </DialogContent>

//         <DialogActions>
//           <Button onClick={handleEditClose} disabled={updating}>
//             Cancel
//           </Button>
//           <Button
//             onClick={handleUpdateSubmit}
//             variant="contained"
//             color="primary"
//             disabled={updating}
//           >
//             {updating ? "Updating..." : "Save Changes"}
//           </Button>
//         </DialogActions>
//       </Dialog>


//       <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent dividers>
//           Are you sure you want to delete this news?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDeleteCancel} disabled={deleting}>
//             Cancel
//           </Button>
//           <Button
//             onClick={handleDeleteConfirm}
//             color="error"
//             variant="contained"
//             disabled={deleting}
//           >
//             {deleting ? "Deleting..." : "Delete"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default MyNewsAdmin;















////////////////////// cdn use in  editer modal content and headline  editor also in this file  //////////////////////

import React, { useEffect, useState, useRef, useCallback } from "react";
import { getMyNews, deleteNews, updateNews, uploadMediaFiles } from "../../../services/adminService";
import {
  CircularProgress,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Pagination,
  Stack,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  Chip,
  Box,
  IconButton,
  ListItem,
  List,
  ListItemText,
  Alert,
  Divider,
  ListItemIcon,
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import {
  getCategories,
  getSubcategories,
  getCountries,
  getStatesByCountry,
  getCitiesByState,
} from '../../../services/apiService';
import LinkIcon from '@mui/icons-material/Link';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

// ─────────────────────────────────────────────
// TinyMCE CDN Wrapper — No API Key Needed
// ─────────────────────────────────────────────
const TinyEditor = ({ value, onEditorChange, editorRef, config, id }) => {
  const containerRef = useRef(null);
  const editorInstanceRef = useRef(null);
  const isInitialized = useRef(false);

  useEffect(() => {
    const initEditor = () => {
      if (!window.tinymce || !containerRef.current || isInitialized.current) return;
      isInitialized.current = true;

      const textarea = containerRef.current.querySelector('textarea');
      if (!textarea) return;

      window.tinymce.init({
        target: textarea,
        ...config,
        setup: (editor) => {
          editorInstanceRef.current = editor;
          if (editorRef) editorRef.current = editor;
          if (config.setup) config.setup(editor);
          editor.on('init', () => {
            if (value) editor.setContent(value);
          });
          editor.on('input change keyup', () => {
            if (onEditorChange) onEditorChange(editor.getContent());
          });
        },
      });
    };

    if (window.tinymce) {
      initEditor();
    } else {
      const existing = document.getElementById('tinymce-cdn-script');
      if (!existing) {
        const script = document.createElement('script');
        script.id = 'tinymce-cdn-script';
        script.src = 'https://cdn.jsdelivr.net/npm/tinymce@6/tinymce.min.js';
        script.referrerPolicy = 'origin';
        script.onload = () => setTimeout(initEditor, 100);
        document.head.appendChild(script);
      } else {
        existing.addEventListener('load', () => setTimeout(initEditor, 100));
      }
    }

    return () => {
      if (editorInstanceRef.current) {
        try { editorInstanceRef.current.remove(); } catch (e) {}
        editorInstanceRef.current = null;
        isInitialized.current = false;
      }
    };
  }, []);

  // Sync value from outside only when it's cleared (reset)
  useEffect(() => {
    if (editorInstanceRef.current && value === '') {
      editorInstanceRef.current.setContent('');
    }
  }, [value]);

  // Sync value when dialog opens with new content
  useEffect(() => {
    if (editorInstanceRef.current && value !== undefined) {
      const currentContent = editorInstanceRef.current.getContent();
      if (currentContent !== value) {
        editorInstanceRef.current.setContent(value || '');
      }
    }
  }, [value]);

  return (
    <div ref={containerRef}>
      <textarea id={id} defaultValue={value} style={{ visibility: 'hidden', height: 0 }} />
    </div>
  );
};

// ─────────────────────────────────────────────

const RASHI_OPTIONS = [
  "Mesh", "Vrishabh", "Mithun", "Karka", "Singh", "Kanya",
  "Tula", "Vrischik", "Dhanu", "Makar", "Kumbh", "Meen"
];

const isValidUrl = (string) => {
  try { new URL(string); return true; } catch (e) { return false; }
};

const MyNewsAdmin = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewOpen, setViewOpen] = useState(false);
  const [selectedNews, setSelectedNews] = useState(null);
  const [editOpen, setEditOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [newMediaFiles, setNewMediaFiles] = useState([]);
  const [existingMediaToKeep, setExistingMediaToKeep] = useState([]);
  const [mediaUrlInput, setMediaUrlInput] = useState('');

  const [existingPdfFiles, setExistingPdfFiles] = useState([]);
  const [newPdfFiles, setNewPdfFiles] = useState([]);
  const [pdfUrlInput, setPdfUrlInput] = useState('');

  const [formErrors, setFormErrors] = useState({});

  const [categoriesDropdown, setCategoriesDropdown] = useState([]);
  const [subCategoriesDropdown, setSubCategoriesDropdown] = useState([]);
  const [countriesDropdown, setCountriesDropdown] = useState([]);
  const [statesDropdown, setStatesDropdown] = useState([]);
  const [citiesDropdown, setCitiesDropdown] = useState([]);

  const [updateError, setUpdateError] = useState(null);
  const [updateSuccess, setUpdateSuccess] = useState(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [updating, setUpdating] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const editorRefEn = useRef(null);
  const editorRefHi = useRef(null);
  const editorRefTitleEn = useRef(null);
  const editorRefTitleHi = useRef(null);

  // Track uploaded URLs from editor (avoid closure issues)
  const existingMediaRef = useRef([]);
  useEffect(() => { existingMediaRef.current = existingMediaToKeep; }, [existingMediaToKeep]);

  const extractUrlsFromHtml = useCallback((htmlContent) => {
    const extracted = new Set();
    if (!htmlContent) return Array.from(extracted);
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    doc.querySelectorAll('img, video, source, iframe, a').forEach(el => {
      let url = el.getAttribute('src') || el.getAttribute('href');
      if (url && isValidUrl(url)) extracted.add(url);
    });
    doc.querySelectorAll('img').forEach(el => {
      const srcset = el.getAttribute('srcset');
      if (srcset) {
        srcset.split(',').forEach(srcPart => {
          const url = srcPart.trim().split(' ')[0];
          if (url && isValidUrl(url)) extracted.add(url);
        });
      }
    });
    doc.querySelectorAll('[data-mce-src]').forEach(el => {
      const v = el.getAttribute('data-mce-src');
      if (v && isValidUrl(v)) extracted.add(v);
    });
    doc.querySelectorAll('[data-mce-p-src]').forEach(el => {
      const v = el.getAttribute('data-mce-p-src');
      if (v && isValidUrl(v)) extracted.add(v);
    });
    return Array.from(extracted);
  }, []);

  const fetchMyNews = useCallback(async (pageNumber = page) => {
    try {
      setLoading(true);
      const response = await getMyNews({ page: pageNumber, limit });
      setNews(response.data || []);
      setTotalPages(response.totalPages || 1);
    } catch (error) {
      console.error("ERROR: Failed to load my news:", error);
    } finally {
      setLoading(false);
    }
  }, [limit, page]);

  // ─────────────────────────────────────────────
  // TinyMCE Config — Headline (minimal)
  // ─────────────────────────────────────────────
  const headlineEditorConfig = {
    height: 180,
    menubar: false,
    branding: false,
    license_key: 'gpl',
    plugins: ['lists', 'link', 'searchreplace', 'wordcount'],
    toolbar: 'undo redo | italic underline | fontsizeselect | forecolor backcolor | removeformat',
    fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt',
    forced_root_block: 'p',
    paste_as_text: true,
    invalid_styles: 'font-size font-family',
    content_style: `body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; font-size: 18px; }`,
  };

  // ─────────────────────────────────────────────
  // TinyMCE Config — Full Content Editor
  // ─────────────────────────────────────────────
  const buildEditorConfig = useCallback(() => ({
    height: 500,
    menubar: true,
    branding: false,
    license_key: 'gpl',
    plugins: [
      'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
      'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
      'insertdatetime', 'media', 'table', 'help', 'wordcount', 'emoticons',
      'codesample', 'hr', 'nonbreaking', 'directionality', 'quickbars'
    ],
    toolbar1: 'undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify',
    toolbar2: 'outdent indent | numlist bullist | forecolor backcolor removeformat | charmap emoticons | fullscreen preview',
    toolbar3: 'insertfile image media link anchor codesample | customupload | ltr rtl',
    content_style: `
      body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif; font-size: 14px; line-height: 1.6; margin: 1rem; }
      img { max-width: 100%; height: auto; }
    `,
    paste_data_images: true,
    automatic_uploads: true,
    file_picker_types: 'image media',
    file_picker_callback: function (callback, value, meta) {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      if (meta.filetype === 'image') input.setAttribute('accept', 'image/*');
      else if (meta.filetype === 'media') input.setAttribute('accept', 'video/*,audio/*');
      else input.setAttribute('accept', 'image/*,video/*,audio/*');

      input.onchange = function () {
        const file = this.files[0];
        if (!file) return;
        const editor = window.tinymce.activeEditor;
        editor.setProgressState(true);
        const fd = new FormData();
        fd.append('mediaFiles', file);
        uploadMediaFiles(fd)
          .then(response => {
            editor.setProgressState(false);
            if (response && response.locations && response.locations.length > 0) {
              const uploadedUrl = response.locations[0];
              const currentUrls = [...existingMediaRef.current];
              if (!currentUrls.includes(uploadedUrl)) {
                currentUrls.push(uploadedUrl);
                existingMediaRef.current = currentUrls;
                setExistingMediaToKeep(currentUrls);
              }
              callback(uploadedUrl, { title: file.name, alt: file.name });
              editor.notificationManager.open({ text: `File "${file.name}" uploaded!`, type: 'success', timeout: 3000 });
            } else throw new Error('No URL returned');
          })
          .catch(err => {
            editor.setProgressState(false);
            editor.notificationManager.open({ text: `Upload failed: ${err.message}`, type: 'error', timeout: 5000 });
          });
      };
      input.click();
    },
    images_upload_handler: function (blobInfo) {
      return new Promise((resolve, reject) => {
        const blob = blobInfo.blob();
        const file = new File([blob], blobInfo.filename() || `image-${Date.now()}.png`, { type: blob.type || 'image/png' });
        const editor = window.tinymce.activeEditor;
        editor.setProgressState(true);
        const fd = new FormData();
        fd.append('mediaFiles', file);
        uploadMediaFiles(fd)
          .then(response => {
            editor.setProgressState(false);
            if (response && response.locations && response.locations.length > 0) {
              const uploadedUrl = response.locations[0];
              const currentUrls = [...existingMediaRef.current];
              if (!currentUrls.includes(uploadedUrl)) {
                currentUrls.push(uploadedUrl);
                existingMediaRef.current = currentUrls;
                setExistingMediaToKeep(currentUrls);
              }
              resolve(uploadedUrl);
            } else reject(new Error('No URL returned'));
          })
          .catch(err => { editor.setProgressState(false); reject(err); });
      });
    },
    setup: function (editor) {
      editor.ui.registry.addButton('customupload', {
        text: 'Upload Media',
        icon: 'upload',
        tooltip: 'Upload images or videos',
        onAction: function () {
          const input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*,video/*,application/pdf');
          input.setAttribute('multiple', 'true');
          input.onchange = function () {
            const files = Array.from(this.files);
            if (!files.length) return;
            editor.setProgressState(true);
            const fd = new FormData();
            files.forEach(f => fd.append('mediaFiles', f));
            uploadMediaFiles(fd)
              .then(response => {
                editor.setProgressState(false);
                if (response && response.locations && response.locations.length > 0) {
                  const currentUrls = [...existingMediaRef.current];
                  const newUrls = response.locations.filter(u => !currentUrls.includes(u));
                  const updatedUrls = [...currentUrls, ...newUrls];
                  existingMediaRef.current = updatedUrls;
                  setExistingMediaToKeep(updatedUrls);

                  response.locations.forEach((url, i) => {
                    const f = files[i];
                    if (f && f.type.startsWith('image/')) {
                      editor.insertContent(`<img src="${url}" alt="${f.name}" style="max-width: 100%; height: auto;" />`);
                    } else if (f && f.type.startsWith('video/')) {
                      editor.insertContent(`<video controls style="max-width: 100%; height: auto;"><source src="${url}" type="${f.type}">Your browser does not support the video tag.</video>`);
                    } else if (f && f.type === 'application/pdf') {
                      setExistingPdfFiles(prev => [...prev, { url, originalName: f.name }]);
                      editor.insertContent(`<p><a href="${url}" target="_blank">${f.name}</a></p>`);
                    }
                  });
                  editor.notificationManager.open({ text: `Uploaded ${response.locations.length} file(s)!`, type: 'success', timeout: 3000 });
                }
              })
              .catch(err => { editor.setProgressState(false); editor.notificationManager.open({ text: `Upload failed: ${err.message}`, type: 'error', timeout: 5000 }); });
          };
          input.click();
        }
      });
    },
    contextmenu: 'link image table',
    quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
    quickbars_insert_toolbar: 'quickimage quicktable customupload',
    image_advtab: true,
    image_uploadtab: true,
    image_caption: true,
    image_title: true,
    formats: {
      bold: { inline: 'strong' },
      italic: { inline: 'em' },
      underline: { inline: 'u' },
      strikethrough: { inline: 'del' },
    }
  }), []);

  const editorConfig = buildEditorConfig();

  useEffect(() => {
    const fetchInitialDropdownData = async () => {
      try {
        const [catsRes, countriesRes] = await Promise.all([getCategories(), getCountries()]);
        setCategoriesDropdown(catsRes.data || []);
        setCountriesDropdown(countriesRes.data || []);
      } catch (err) {
        console.error("ERROR: Failed to load initial dropdown data:", err);
      }
    };
    fetchInitialDropdownData();
    fetchMyNews();
  }, [limit, fetchMyNews]);

  const fetchSubcategoriesForEdit = useCallback(async (categoryId) => {
    if (categoryId) {
      try { const res = await getSubcategories(categoryId); setSubCategoriesDropdown(res.data || []); }
      catch (err) { setSubCategoriesDropdown([]); }
    } else { setSubCategoriesDropdown([]); }
  }, []);

  const fetchStatesForEdit = useCallback(async (countryId) => {
    if (countryId) {
      try { const res = await getStatesByCountry(countryId); setStatesDropdown(res.data || []); }
      catch (err) { setStatesDropdown([]); }
    } else { setStatesDropdown([]); }
  }, []);

  const fetchCitiesForEdit = useCallback(async (stateId) => {
    if (stateId) {
      try { const res = await getCitiesByState(stateId); setCitiesDropdown(res.data || []); }
      catch (err) { setCitiesDropdown([]); }
    } else { setCitiesDropdown([]); }
  }, []);

  const handleViewOpen = (item) => { setSelectedNews(item); setViewOpen(true); };
  const handleViewClose = () => { setViewOpen(false); setSelectedNews(null); };

  const handleEditOpen = async (item) => {
    setSelectedNews(item);
    setUpdateError(null);
    setUpdateSuccess(null);
    setFormErrors({});

    await fetchSubcategoriesForEdit(item.category?._id);
    await fetchStatesForEdit(item.country?._id);
    await fetchCitiesForEdit(item.state?._id);

    setEditFormData({
      title_en: item.title_en || '',
      title_hi: item.title_hi || '',
      content_en: item.content_en || '',
      content_hi: item.content_hi || '',
      summary_en: item.summary_en || '',
      summary_hi: item.summary_hi || '',
      category: item.category?._id || '',
      subCategory: item.subCategory?._id || '',
      tags: item.tags || [],
      country: item.country?._id || '',
      state: item.state?._id || '',
      city: item.city?._id || '',
      localAddress: item.localAddress || '',
      status: item.status,
      subSubCategory: item.subSubCategory || '',
    });

    let initialMediaUrlsToKeep = new Set(item.media ? item.media.map(m => m.url) : []);
    if (item.mediaUrls && Array.isArray(item.mediaUrls)) item.mediaUrls.forEach(url => initialMediaUrlsToKeep.add(url));
    extractUrlsFromHtml(item.content_en).forEach(url => initialMediaUrlsToKeep.add(url));
    extractUrlsFromHtml(item.content_hi).forEach(url => initialMediaUrlsToKeep.add(url));

    const initialArray = Array.from(initialMediaUrlsToKeep);
    setExistingMediaToKeep(initialArray);
    existingMediaRef.current = initialArray;

    setExistingPdfFiles(item.pdfFiles || []);
    setNewPdfFiles([]);
    setPdfUrlInput('');
    setNewMediaFiles([]);
    setMediaUrlInput('');
    setEditOpen(true);
  };

  const handleEditClose = () => {
    setEditOpen(false);
    setSelectedNews(null);
    setEditFormData({});
    setNewMediaFiles([]);
    setExistingMediaToKeep([]);
    existingMediaRef.current = [];
    setSubCategoriesDropdown([]);
    setStatesDropdown([]);
    setCitiesDropdown([]);
    setUpdateError(null);
    setUpdateSuccess(null);
    setMediaUrlInput('');
    setFormErrors({});
    setExistingPdfFiles([]);
    setNewPdfFiles([]);
    setPdfUrlInput('');
  };

  const handleEditFormChange = async (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({ ...prev, [name]: value }));
    setFormErrors(prev => ({ ...prev, [name]: '' }));
    if (name === 'category') { setEditFormData(prev => ({ ...prev, subCategory: '', subSubCategory: '' })); await fetchSubcategoriesForEdit(value); }
    else if (name === 'country') { setEditFormData(prev => ({ ...prev, state: '', city: '' })); await fetchStatesForEdit(value); }
    else if (name === 'state') { setEditFormData(prev => ({ ...prev, city: '' })); await fetchCitiesForEdit(value); }
  };

  const handleEditEditorChange = (content, editorName) => {
    setEditFormData(prev => ({ ...prev, [editorName]: content }));
    setFormErrors(prev => ({ ...prev, [editorName]: '' }));
    const extractedUrls = extractUrlsFromHtml(content);
    setExistingMediaToKeep(prev => {
      const combined = new Set([...prev, ...extractedUrls]);
      const arr = Array.from(combined);
      existingMediaRef.current = arr;
      return arr;
    });
  };

  const handleTagsChange = (e) => {
    const tagsArray = e.target.value.split(',').map(tag => tag.trim()).filter(tag => tag !== '');
    setEditFormData(prev => ({ ...prev, tags: tagsArray }));
  };

  const handleNewMediaUpload = (e) => setNewMediaFiles(Array.from(e.target.files));
  const handleRemoveExistingMedia = (urlToRemove) => setExistingMediaToKeep(prev => prev.filter(url => url !== urlToRemove));

  const handleMediaUrlInputChange = (e) => { setMediaUrlInput(e.target.value); setFormErrors(prev => ({ ...prev, mediaUrlInput: '' })); };
  const handleAddMediaUrl = () => {
    const url = mediaUrlInput.trim();
    if (!url) return;
    if (!isValidUrl(url)) { setFormErrors(prev => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' })); return; }
    if (!existingMediaToKeep.includes(url)) { setExistingMediaToKeep(prev => [...prev, url]); setMediaUrlInput(''); }
    else setFormErrors(prev => ({ ...prev, mediaUrlInput: 'This URL has already been added.' }));
  };

  const handleNewPdfUpload = (e) => setNewPdfFiles(Array.from(e.target.files));
  const handleRemoveExistingPdf = (pdfToRemove) => setExistingPdfFiles(prev => prev.filter(pdf => (pdf._id || pdf.url) !== (pdfToRemove._id || pdfToRemove.url)));
  const handlePdfUrlInputChange = (e) => { setPdfUrlInput(e.target.value); setFormErrors(prev => ({ ...prev, pdfUrlInput: '' })); };
  const handleAddPdfUrl = () => {
    const url = pdfUrlInput.trim();
    if (!url) return;
    if (!isValidUrl(url)) { setFormErrors(prev => ({ ...prev, pdfUrlInput: 'Please enter a valid URL.' })); return; }
    if (!existingPdfFiles.some(pdf => pdf.url === url)) { setExistingPdfFiles(prev => [...prev, { url, originalName: url.split('/').pop() || 'external_pdf' }]); setPdfUrlInput(''); }
    else setFormErrors(prev => ({ ...prev, pdfUrlInput: 'This URL has already been added.' }));
  };

  const handleUpdateSubmit = async () => {
    if (!selectedNews) return;
    setUpdating(true);
    setUpdateError(null);
    setUpdateSuccess(null);
    setFormErrors({});

    // Get fresh content from editors before submit
    const title_en_final = editorRefTitleEn.current ? editorRefTitleEn.current.getContent() : editFormData.title_en;
    const title_hi_final = editorRefTitleHi.current ? editorRefTitleHi.current.getContent() : editFormData.title_hi;
    const content_en_final = editorRefEn.current ? editorRefEn.current.getContent() : editFormData.content_en;
    const content_hi_final = editorRefHi.current ? editorRefHi.current.getContent() : editFormData.content_hi;

    let currentMediaUrls = [...existingMediaToKeep];
    const currentMediaUrlInputVal = mediaUrlInput.trim();
    if (currentMediaUrlInputVal) {
      if (!isValidUrl(currentMediaUrlInputVal)) { setFormErrors(prev => ({ ...prev, mediaUrlInput: 'Please enter a valid URL.' })); setUpdating(false); setUpdateError("Please correct the errors in the form."); return; }
      if (!currentMediaUrls.includes(currentMediaUrlInputVal)) currentMediaUrls.push(currentMediaUrlInputVal);
      else { setFormErrors(prev => ({ ...prev, mediaUrlInput: 'This URL has already been added.' })); setUpdating(false); setUpdateError("Please correct the errors in the form."); return; }
    }

    try {
      let finalMediaUrls = [...currentMediaUrls];
      let finalPdfFiles = [...existingPdfFiles];

      if (newMediaFiles.length > 0) {
        const fd = new FormData();
        newMediaFiles.forEach(file => fd.append('mediaFiles', file));
        const uploadResponse = await uploadMediaFiles(fd);
        if (uploadResponse && uploadResponse.locations) {
          finalMediaUrls = [...finalMediaUrls, ...uploadResponse.locations.filter(url => !finalMediaUrls.includes(url))];
        } else throw new Error('Failed to upload new media files.');
      }

      if (newPdfFiles.length > 0) {
        const fd = new FormData();
        newPdfFiles.forEach(file => fd.append('mediaFiles', file));
        const uploadResponsePdfs = await uploadMediaFiles(fd);
        if (uploadResponsePdfs && uploadResponsePdfs.locations) {
          uploadResponsePdfs.locations.forEach((url, index) => {
            finalPdfFiles.push({ url, originalName: newPdfFiles[index].name });
          });
        } else throw new Error('Failed to upload new PDF files.');
      }

      const currentPdfUrlInputVal = pdfUrlInput.trim();
      if (currentPdfUrlInputVal) {
        if (!isValidUrl(currentPdfUrlInputVal)) { setFormErrors(prev => ({ ...prev, pdfUrlInput: 'Please enter a valid URL.' })); setUpdating(false); setUpdateError("Please correct the errors in the form."); return; }
        if (!finalPdfFiles.some(pdf => pdf.url === currentPdfUrlInputVal)) {
          finalPdfFiles.push({ url: currentPdfUrlInputVal, originalName: currentPdfUrlInputVal.split('/').pop() || 'external_pdf' });
        }
      }

      const formDataPayload = new FormData();
      const updatedFormData = { ...editFormData, title_en: title_en_final, title_hi: title_hi_final, content_en: content_en_final, content_hi: content_hi_final };

      Object.keys(updatedFormData).forEach(key => {
        if (key === 'tags') formDataPayload.append(key, JSON.stringify(updatedFormData[key]));
        else if (updatedFormData[key] !== undefined && updatedFormData[key] !== null) formDataPayload.append(key, updatedFormData[key]);
        else formDataPayload.append(key, '');
      });

      formDataPayload.append('mediaUrls', JSON.stringify(finalMediaUrls));
      formDataPayload.append('pdfFiles', JSON.stringify(finalPdfFiles));

      const response = await updateNews(selectedNews._id, formDataPayload);
      setUpdateSuccess(response.message || "News updated successfully!");
      handleEditClose();
      fetchMyNews(page);
    } catch (error) {
      console.error("ERROR: Failed to update news:", error);
      setUpdateError(error.response?.data?.message || error.message || "Failed to update news.");
    } finally {
      setUpdating(false);
    }
  };

  const handleDeleteClick = (item) => { setSelectedNews(item); setDeleteConfirmOpen(true); };
  const handleDeleteConfirm = async () => {
    if (!selectedNews) return;
    try {
      setDeleting(true);
      await deleteNews(selectedNews._id);
      setDeleteConfirmOpen(false);
      setViewOpen(false);
      handleEditClose();
      fetchMyNews(page);
    } catch (error) {
      console.error("ERROR: Failed to delete news:", error);
    } finally { setDeleting(false); }
  };
  const handleDeleteCancel = () => { setDeleteConfirmOpen(false); setSelectedNews(null); };

  const selectedCategoryName = categoriesDropdown.find(cat => cat._id === editFormData.category)?.name?.toLowerCase();
  const selectedSubCategoryName = subCategoriesDropdown.find(sub => sub._id === editFormData.subCategory)?.name?.toLowerCase();
  const showSubSubCategoryDropdown = selectedCategoryName === 'astrology' && selectedSubCategoryName === 'rashi';

  if (loading) {
    return <div className="flex justify-center items-center mt-10"><CircularProgress /></div>;
  }

  return (
    <div className="p-4">
      <Typography variant="h5" gutterBottom>My News</Typography>

      {news.length === 0 ? (
        <Typography>No news found.</Typography>
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>#No</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {news.map((item, index) => (
                  <TableRow key={item._id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      {item.media && item.media.length > 0 ? (
                        item.media[0].type === "video" ? (
                          <video src={item.media[0].url} width="90" height="60" controls={false} autoPlay muted loop style={{ borderRadius: "8px", objectFit: "cover", backgroundColor: "#f0fdf9ff" }} />
                        ) : (
                          <img src={item.media[0].url} alt={item.media[0].caption || "News image"} style={{ width: "90px", maxHeight: "70px", objectFit: "contain", borderRadius: "8px", backgroundColor: "#f0fdf9ff" }} />
                        )
                      ) : (
                        <Typography variant="caption" color="textSecondary">No Media</Typography>
                      )}
                    </TableCell>
                    <TableCell dangerouslySetInnerHTML={{ __html: item.title_hi || item.title_en }} />
                    <TableCell>{item.category?.name || "-"}</TableCell>
                    <TableCell>{item.status}</TableCell>
                    <TableCell>{item.createdAtDate} {item.createdAtTime}</TableCell>
                    <TableCell align="center">
                      <Button size="small" variant="outlined" onClick={() => handleViewOpen(item)} sx={{ mr: 1 }}>View</Button>
                      <Button size="small" variant="outlined" color="primary" onClick={() => handleEditOpen(item)} sx={{ mr: 1 }}>Edit</Button>
                      <Button size="small" variant="outlined" color="error" onClick={() => handleDeleteClick(item)}>Delete</Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Stack spacing={2} sx={{ mt: 2 }} alignItems="center">
            <Pagination count={totalPages} page={page} onChange={(e, value) => setPage(value)} color="primary" />
            <Select value={limit} onChange={(e) => { setLimit(e.target.value); fetchMyNews(1); }}>
              {[5, 10, 20, 50].map(l => <MenuItem key={l} value={l}>{l} per page</MenuItem>)}
            </Select>
          </Stack>
        </>
      )}

      {/* ── View Dialog ── */}
      <Dialog open={viewOpen} onClose={handleViewClose} fullWidth maxWidth="md">
        <DialogTitle>News Details</DialogTitle>
        <DialogContent dividers>
          {selectedNews?.media && selectedNews?.media.length > 0 && (
            <img src={selectedNews.media[0].url} alt={selectedNews.media[0].caption || "News image"} style={{ width: "100%", maxHeight: "300px", objectFit: "contain", borderRadius: "8px", marginBottom: "16px", backgroundColor: "#f0fdf9ff" }} />
          )}
          <Typography variant="h6" gutterBottom><strong>Title (English):</strong> {selectedNews?.title_en || "-"}</Typography>
          <Typography variant="h6" gutterBottom>
            <strong>शीर्षक (हिंदी): </strong>
            <span dangerouslySetInnerHTML={{ __html: selectedNews?.title_hi || "-" }} />
          </Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Summary (English):</strong> {selectedNews?.summary_en || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>सारांश (हिंदी):</strong> {selectedNews?.summary_hi || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Category:</strong> {selectedNews?.category?.name || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Sub Category:</strong> {selectedNews?.subCategory?.name || "-"}</Typography>
          {selectedNews?.subSubCategory && <Typography variant="subtitle1" gutterBottom><strong>Sub-Sub Category (Rashi):</strong> {selectedNews.subSubCategory}</Typography>}
          <Typography variant="subtitle1" gutterBottom><strong>Status:</strong> {selectedNews?.status}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Country:</strong> {selectedNews?.country?.name || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>State:</strong> {selectedNews?.state?.name || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>City:</strong> {selectedNews?.city?.name || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Local Address:</strong> {selectedNews?.localAddress || "-"}</Typography>
          <Typography variant="subtitle1" gutterBottom><strong>Reporter:</strong> {selectedNews?.createdBy?.name || "-"} / ({selectedNews?.createdBy?.email})</Typography>
          <Typography variant="subtitle2" gutterBottom><strong>Posted Date:</strong> {selectedNews?.postedDate || "N/A"} {selectedNews?.postedTime || "N/A"}</Typography>
          <Typography variant="subtitle2" gutterBottom><strong>Last Updated:</strong> {selectedNews?.updatedAtDate} {selectedNews?.updatedAtTime}</Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            <strong>Content (English):</strong><br />
            <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_en || "No English content available" }} />
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            <strong>सामग्री (हिंदी):</strong><br />
            <div dangerouslySetInnerHTML={{ __html: selectedNews?.content_hi || "कोई हिंदी सामग्री उपलब्ध नहीं है" }} />
          </Typography>
          {selectedNews?.tags?.length > 0 && <Typography variant="subtitle1" sx={{ mt: 2 }}><strong>Tags:</strong> {selectedNews.tags.join(", ")}</Typography>}
          {selectedNews?.referenceLinks?.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1"><strong>Reference Links:</strong></Typography>
              <List dense>
                {selectedNews.referenceLinks.map((link, index) => (
                  <ListItem key={index} disablePadding>
                    <ListItemText primary={<a href={link} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{link}</a>} />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
          {selectedNews?.pdfFiles?.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="subtitle1"><strong>PDF Files:</strong></Typography>
              <List dense>
                {selectedNews.pdfFiles.map((pdf, index) => (
                  <ListItem key={pdf._id || index} disablePadding>
                    <ListItemIcon><PictureAsPdfIcon /></ListItemIcon>
                    <ListItemText primary={<a href={pdf.url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{pdf.originalName || pdf.url.split('/').pop()}</a>} />
                  </ListItem>
                ))}
              </List>
            </Box>
          )}
          <Typography variant="subtitle2" sx={{ mt: 2 }}><strong>Views:</strong> {selectedNews?.viewsCount || 0}</Typography>
          <Typography variant="subtitle2"><strong>Likes:</strong> {selectedNews?.likesCount || 0}</Typography>
          <Typography variant="subtitle2"><strong>Comments:</strong> {selectedNews?.commentsCount || 0}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewClose} variant="contained" color="primary">Close</Button>
          <Button onClick={() => handleDeleteClick(selectedNews)} variant="contained" color="error">Delete</Button>
        </DialogActions>
      </Dialog>

      {/* ── Edit Dialog ── */}
      <Dialog open={editOpen} onClose={handleEditClose} fullWidth maxWidth="md" disableEnforceFocus={true}>
        <DialogTitle>
          Edit News:{" "}
          <span dangerouslySetInnerHTML={{ __html: selectedNews?.title_en || selectedNews?.title_hi || "-" }} />
        </DialogTitle>
        <DialogContent dividers>
          {updateError && <Alert severity="error" sx={{ mb: 2 }}>{updateError}</Alert>}
          {updateSuccess && <Alert severity="success" sx={{ mb: 2 }}>{updateSuccess}</Alert>}

          {/* Title English */}
          <Typography variant="body2" color="textSecondary" gutterBottom>Title (English) *</Typography>
          <Box sx={{ border: formErrors.title_en ? "1px solid red" : "1px solid #ccc", borderRadius: 1, mb: 1 }}>
            <TinyEditor
              id="edit_title_en_editor"
              value={editFormData.title_en || ''}
              onEditorChange={(content) => setEditFormData(prev => ({ ...prev, title_en: content }))}
              editorRef={editorRefTitleEn}
              config={headlineEditorConfig}
            />
          </Box>
          {formErrors.title_en && <Typography color="error" variant="caption">{formErrors.title_en}</Typography>}

          {/* Title Hindi */}
          <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mt: 2 }}>शीर्षक (हिंदी) *</Typography>
          <Box sx={{ border: formErrors.title_hi ? "1px solid red" : "1px solid #ccc", borderRadius: 1, mb: 1 }}>
            <TinyEditor
              id="edit_title_hi_editor"
              value={editFormData.title_hi || ''}
              onEditorChange={(content) => setEditFormData(prev => ({ ...prev, title_hi: content }))}
              editorRef={editorRefTitleHi}
              config={headlineEditorConfig}
            />
          </Box>
          {formErrors.title_hi && <Typography color="error" variant="caption">{formErrors.title_hi}</Typography>}

          <TextField margin="dense" name="summary_en" label="Summary (English)" fullWidth multiline rows={2} variant="outlined" value={editFormData.summary_en || ""} onChange={handleEditFormChange} sx={{ mb: 2, mt: 2 }} error={!!formErrors.summary_en} helperText={formErrors.summary_en} />
          <TextField margin="dense" name="summary_hi" label="सारांश (हिंदी)" fullWidth multiline rows={2} variant="outlined" value={editFormData.summary_hi || ""} onChange={handleEditFormChange} sx={{ mb: 2 }} error={!!formErrors.summary_hi} helperText={formErrors.summary_hi} />

          {/* Content English */}
          <Box sx={{ mt: 3, mb: 3 }}>
            <Typography variant="body2" color="textSecondary" gutterBottom>Content (English) *</Typography>
            <Box sx={{ border: formErrors.content_en ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
              <TinyEditor
                id="edit_content_en_editor"
                value={editFormData.content_en || ''}
                onEditorChange={(content) => handleEditEditorChange(content, 'content_en')}
                editorRef={editorRefEn}
                config={editorConfig}
              />
            </Box>
            {formErrors.content_en && <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>{formErrors.content_en}</Typography>}
          </Box>
          <Divider sx={{ my: 2 }} />

          {/* Content Hindi */}
          <Box sx={{ mt: 3, mb: 3 }}>
            <Typography variant="body2" color="textSecondary" gutterBottom>सामग्री (हिंदी) *</Typography>
            <Box sx={{ border: formErrors.content_hi ? '1px solid #f44336' : '1px solid #e0e0e0', borderRadius: 1 }}>
              <TinyEditor
                id="edit_content_hi_editor"
                value={editFormData.content_hi || ''}
                onEditorChange={(content) => handleEditEditorChange(content, 'content_hi')}
                editorRef={editorRefHi}
                config={editorConfig}
              />
            </Box>
            {formErrors.content_hi && <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>{formErrors.content_hi}</Typography>}
          </Box>
          <Divider sx={{ my: 2 }} />

          {/* Category */}
          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="category-select-label">Category</InputLabel>
            <Select labelId="category-select-label" name="category" value={editFormData.category || ''} label="Category" onChange={handleEditFormChange} error={!!formErrors.category}>
              <MenuItem value="">Select Category</MenuItem>
              {categoriesDropdown.map(cat => <MenuItem key={cat._id} value={cat._id}>{cat.name}</MenuItem>)}
            </Select>
            {formErrors.category && <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>{formErrors.category}</Typography>}
          </FormControl>

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="subcategory-select-label">Sub Category</InputLabel>
            <Select labelId="subcategory-select-label" name="subCategory" value={editFormData.subCategory || ''} label="Sub Category" onChange={handleEditFormChange} disabled={!editFormData.category || subCategoriesDropdown.length === 0}>
              <MenuItem value="">Select Sub Category (Optional)</MenuItem>
              {subCategoriesDropdown.map(subCat => <MenuItem key={subCat._id} value={subCat._id}>{subCat.name}</MenuItem>)}
            </Select>
          </FormControl>

          {showSubSubCategoryDropdown && (
            <TextField label="Select Rashi (subSubCategory)" name="subSubCategory" select fullWidth margin="normal" value={editFormData.subSubCategory} onChange={handleEditFormChange} sx={{ mb: 2 }}>
              <MenuItem value="">Select Rashi</MenuItem>
              {RASHI_OPTIONS.map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
            </TextField>
          )}

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel htmlFor="news-tags">Tags (comma separated)</InputLabel>
            <OutlinedInput id="news-tags" name="tags" value={editFormData.tags?.join(', ') || ""} onChange={handleTagsChange} label="Tags (comma separated)" />
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
              {editFormData.tags?.map((tag, index) => <Chip key={index} label={tag} />)}
            </Box>
          </FormControl>

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="country-select-label">Country</InputLabel>
            <Select labelId="country-select-label" name="country" value={editFormData.country || ''} label="Country" onChange={handleEditFormChange}>
              <MenuItem value="">Select Country (Optional)</MenuItem>
              {countriesDropdown.map(country => <MenuItem key={country._id} value={country._id}>{country.name}</MenuItem>)}
            </Select>
          </FormControl>

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="state-select-label">State</InputLabel>
            <Select labelId="state-select-label" name="state" value={editFormData.state || ''} label="State" onChange={handleEditFormChange} disabled={!editFormData.country || statesDropdown.length === 0}>
              <MenuItem value="">Select State (Optional)</MenuItem>
              {statesDropdown.map(state => <MenuItem key={state._id} value={state._id}>{state.name}</MenuItem>)}
            </Select>
          </FormControl>

          {/* Media Section */}
          <Box sx={{ my: 3 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>Media Files & External URLs</Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>Upload new images/videos or add external media URLs.</Typography>
            <Button variant="outlined" component="label" fullWidth startIcon={<AddCircleOutlineIcon />} sx={{ mb: 2, py: 1.5 }} disabled={updating}>
              Upload Images/Videos
              <input type="file" hidden onChange={handleNewMediaUpload} multiple accept="image/*,video/*" />
            </Button>
            {newMediaFiles.length > 0 && (
              <Box sx={{ mt: 2, mb: 2 }}>
                <Typography variant="subtitle2" gutterBottom>New Images/Videos to Upload:</Typography>
                <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                  {newMediaFiles.map(file => (
                    <ListItem key={file.name + file.size} secondaryAction={<IconButton edge="end" onClick={() => setNewMediaFiles(prev => prev.filter(f => f !== file))}><CloseIcon /></IconButton>}>
                      <ListItemIcon>{file.type.startsWith('image/') ? <ImageOutlinedIcon color="primary" /> : <VideoFileIcon color="secondary" />}</ListItemIcon>
                      <ListItemText primary={file.name} secondary={`${(file.size / 1024 / 1024).toFixed(2)} MB (${file.type})`} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
            <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
              <TextField label="Add External Media URL" value={mediaUrlInput} onChange={handleMediaUrlInputChange} fullWidth placeholder="https://example.com/image.jpg" error={!!formErrors.mediaUrlInput} helperText={formErrors.mediaUrlInput} disabled={updating} />
              <IconButton color="primary" onClick={handleAddMediaUrl} disabled={!mediaUrlInput.trim() || updating} sx={{ border: '1px solid', borderColor: 'primary.main', borderRadius: 1 }}>
                <AddCircleOutlineIcon />
              </IconButton>
            </Box>
            {existingMediaToKeep.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" gutterBottom>Current Images/Videos ({existingMediaToKeep.length}):</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 1 }}>
                  {existingMediaToKeep.map((url, index) => {
                    const isImage = /\.(jpeg|jpg|gif|png|webp|svg)\b/i.test(url.split('?')[0]);
                    const isVideo = /\.(mp4|webm|ogg)\b/i.test(url.split('?')[0]) || url.includes('youtube.com') || url.includes('vimeo.com');
                    return (
                      <Box key={url} sx={{ position: 'relative', width: '100px', height: '100px', border: '1px solid #ccc', borderRadius: '4px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5', flexDirection: 'column', padding: '5px' }}>
                        {isImage && <img src={url} alt={`Media ${index}`} style={{ maxWidth: '100%', maxHeight: 'calc(100% - 20px)', objectFit: 'contain' }} />}
                        {isVideo && <VideoFileIcon sx={{ fontSize: 40, color: 'text.secondary' }} />}
                        {!isImage && !isVideo && <LinkIcon sx={{ fontSize: 40, color: 'text.secondary' }} />}
                        <IconButton size="small" sx={{ position: 'absolute', top: 0, right: 0, backgroundColor: 'rgba(255,255,255,0.7)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }, zIndex: 1 }} onClick={() => handleRemoveExistingMedia(url)}>
                          <CloseIcon fontSize="small" />
                        </IconButton>
                        <Typography variant="caption" title={url} sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, backgroundColor: 'rgba(0,0,0,0.6)', color: 'white', px: 0.5, py: 0.2, fontSize: '0.6rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {url.split('/').pop().split('?')[0] || url}
                        </Typography>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            )}
          </Box>
          <Divider sx={{ my: 2 }} />

          {/* PDF Section */}
          <Box sx={{ my: 3 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>PDF Files</Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mb: 2 }}>Upload new PDF files or add external PDF URLs.</Typography>
            <Button variant="outlined" component="label" fullWidth startIcon={<PictureAsPdfIcon />} sx={{ mb: 2, py: 1.5 }} disabled={updating}>
              Upload PDF Files
              <input type="file" hidden onChange={handleNewPdfUpload} multiple accept="application/pdf" />
            </Button>
            {newPdfFiles.length > 0 && (
              <Box sx={{ mt: 2, mb: 2 }}>
                <Typography variant="subtitle2" gutterBottom>New PDF Files to Upload:</Typography>
                <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                  {newPdfFiles.map(file => (
                    <ListItem key={file.name + file.size} secondaryAction={<IconButton edge="end" onClick={() => setNewPdfFiles(prev => prev.filter(f => f !== file))}><CloseIcon /></IconButton>}>
                      <ListItemIcon><PictureAsPdfIcon color="error" /></ListItemIcon>
                      <ListItemText primary={file.name} secondary={`${(file.size / 1024).toFixed(2)} KB`} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
            <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
              <TextField label="Add External PDF URL" value={pdfUrlInput} onChange={handlePdfUrlInputChange} fullWidth placeholder="https://example.com/document.pdf" error={!!formErrors.pdfUrlInput} helperText={formErrors.pdfUrlInput} disabled={updating} />
              <IconButton color="primary" onClick={handleAddPdfUrl} disabled={!pdfUrlInput.trim() || updating} sx={{ border: '1px solid', borderColor: 'primary.main', borderRadius: 1 }}>
                <AddCircleOutlineIcon />
              </IconButton>
            </Box>
            {existingPdfFiles.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" gutterBottom>Current PDF Files ({existingPdfFiles.length}):</Typography>
                <List dense sx={{ bgcolor: 'background.paper', borderRadius: 1, border: '1px solid #e0e0e0' }}>
                  {existingPdfFiles.map((pdf) => (
                    <ListItem key={pdf._id || pdf.url} secondaryAction={<IconButton edge="end" onClick={() => handleRemoveExistingPdf(pdf)}><CloseIcon /></IconButton>}>
                      <ListItemIcon><PictureAsPdfIcon color="error" /></ListItemIcon>
                      <ListItemText primary={<a href={pdf.url} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>{pdf.originalName || pdf.url.split('/').pop()}</a>} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
          </Box>
          <Divider sx={{ my: 2 }} />

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="city-select-label">City</InputLabel>
            <Select labelId="city-select-label" name="city" value={editFormData.city || ''} label="City" onChange={handleEditFormChange} disabled={!editFormData.state || citiesDropdown.length === 0}>
              <MenuItem value="">Select City (Optional)</MenuItem>
              {citiesDropdown.map(city => <MenuItem key={city._id} value={city._id}>{city.name}</MenuItem>)}
            </Select>
          </FormControl>

          <TextField margin="dense" name="localAddress" label="Local Address" fullWidth variant="outlined" value={editFormData.localAddress || ""} onChange={handleEditFormChange} sx={{ mb: 2 }} />

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="status-select-label">Status</InputLabel>
            <Select labelId="status-select-label" name="status" value={editFormData.status || ""} label="Status" onChange={handleEditFormChange}>
              <MenuItem value="draft">Draft</MenuItem>
              <MenuItem value="pending_approval">Pending Approval</MenuItem>
              <MenuItem value="posted">Posted</MenuItem>
              <MenuItem value="live">Live</MenuItem>
              <MenuItem value="rejected">Rejected</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose} disabled={updating}>Cancel</Button>
          <Button onClick={handleUpdateSubmit} variant="contained" color="primary" disabled={updating}>
            {updating ? "Updating..." : "Save Changes"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Delete Confirm Dialog ── */}
      <Dialog open={deleteConfirmOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent dividers>Are you sure you want to delete this news?</DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} disabled={deleting}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained" disabled={deleting}>
            {deleting ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MyNewsAdmin;